<template >
  <div class="block-layout questionnaire que_tmp_parent" id="scrollableques" v-if="isEveryThingLoaded">
    <button  v-if="isEdit" :disabled="updating"  class="questionary_save r130" @click="saveMe(true)">Update
      <span class="loader" v-if="updating" ><img src="@/assets/images/main/loader.gif" /></span>
    </button> 
    <div
      class="vx-col w-full wizard-container form_section questionnairesection pad0 case-form-v2"
    >
      <div class="questionnaire_page" id="questionnaire_page">
        <div class="questionnaire_sec">
          <div class="questionnaire_titles">
            <div class="questionnaire_titles_info">
              <h2>Questionnaire </h2> 

              <p>Please take a few moments to complete this short registration form</p>
              
              <ul class="qs-list-count">
                
                <template  v-if=" !isEdit && false " >
                    <template  v-if=" (canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations') || canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo'))" >
                      <template  v-if=" (canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations') && canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo'))">
                          <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                          <li :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info' ,'Parents Info','Sponsor Info'].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>2</span><a>Educational Info</a></li>
                          <li :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>3</span><a>Employment Info</a></li>
                          <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='ASSOCIATIONS/GROUPS Info'"><span>4</span><a>ASSOCIATIONS/GROUPS Info</a></li> -->
                          <li :class="{'active':['Documents Info' ,'Dependents Info','Parents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>4</span><a>Parents Info</a></li>
                          <li :class="{'active':['Documents Info' ,'Dependents Info',,'Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                          <li :class="{'active':['Dependents Info' ,'Sponsor Info'].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info </a></li>
                          <li v-if="checkProperty(configDetails, 'entityType')=='I-130'" :class="{'active':['Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Sponsor Info'"><span>7</span><a>Sponsor Info </a></li>
                  
                        </template>
                        <template v-else>

                          <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                          <li v-if="canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations')" :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>2</span><a>Educational Info</a></li>
                          <li v-if="canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo')" :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>3</span><a>Employment Info</a></li>
                          <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='ASSOCIATIONS/GROUPS Info'"><span>4</span><a>ASSOCIATIONS/GROUPS Info</a></li> -->
                          <li :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ,'Sponsor Info'].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>4</span><a>Parents Info</a></li>
                          <li :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                          <li :class="{'active':['Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info </a></li>
                          <li v-if="checkProperty(configDetails, 'entityType')=='I-130'" :class="{'active':['Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Sponsor Info'"><span>7</span><a>Sponsor Info </a></li>
                  

                        </template>
                      
                    </template>
                    <template v-else>
                      <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                      <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='ASSOCIATIONS/GROUPS Info'"><span>2</span><a>ASSOCIATIONS/GROUPS Info</a></li> -->
                          <li :class="{'active':['Documents Info' ,'Dependents Info','Parents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>3</span><a>Parents Info</a></li>
                      <li :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>4</span><a>Documents Info</a></li>
                    <li :class="{'active':['Dependents Info','Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>5</span><a>Dependents Info </a></li>
                    <li v-if="checkProperty(configDetails, 'entityType')=='I-130'" :class="{'active':['Sponsor Info' ].indexOf(currentTab)>-1}" @click="currentTab='Sponsor Info'"><span>6</span><a>Sponsor Info </a></li>
                  

                    </template>
                </template>
                <template v-if=" !isEdit">
                  <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info', 'Financial Info','Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                  <li v-if="canRenderField('i485AdditionalInformation', dbFields ,false,'beneficiaryInfo')" :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Additional Info', 'Petitioner Info', 'Financial Info', 'Household Info' ].indexOf(currentTab)>-1}" @click="currentTab='Additional Info'"><span>2</span><a>Additional Info</a></li>
                  <li v-if="canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations')" :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info', 'Financial Info' ,'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>3</span><a>Educational Info</a></li>
                  <li v-if="canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo')" :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info' , 'Financial Info', 'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>4</span><a>Employment Info</a></li>
                  <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='ASSOCIATIONS/GROUPS Info'"><span>4</span><a>ASSOCIATIONS/GROUPS Info</a></li> -->
                  <li :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ,'Sponsor Info', 'Petitioner Info', 'Financial Info', 'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>5</span><a>Parents Info</a></li>
                  <li v-if="canRenderField('houseHoldNumber', dbFields ,false,'beneficiaryInfo') || canRenderField('houseHoldAnnualIncome', dbFields ,false,'beneficiaryInfo') || 
                  canRenderField('houseHoldAnnualAssets', dbFields ,false,'beneficiaryInfo') || canRenderField('houseHoldAnnualliabilities', dbFields ,false,'beneficiaryInfo')"
                  :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info', 'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Household Info'"><span>6</span><a>Household Info</a></li>

                  <!-- <li v-if="canRenderField('benfAssets', dbFields ,false,'beneficiaryInfo.benfAssets') || canRenderField('benfIncome', dbFields ,false,'beneficiaryInfo.benfIncome') " :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info', 'Financial Info' ].indexOf(currentTab)>-1}" @click="currentTab='Financial Info'"><span>2</span><a>Financial Info</a></li> -->

                  <li :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>6</span><a>Documents Info</a></li>
                  <li :class="{'active':['Dependents Info','Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>7</span><a>Dependents Info </a></li>
                  <li v-if="checkProperty(configDetails, 'entityType')=='I-130'" :class="{'active':['Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Sponsor Info'"><span>8</span><a>Sponsor Info </a></li>
                  <li v-if="checkProperty(configDetails, 'entityType')=='L-VISA'" :class="{'active':['Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Petitioner Info'"><span>8</span><a>Petitioner Info </a></li>
                </template>
                <template v-else>
                  <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Additional Info', 'Petitioner Info', 'Financial Info', 'Household Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                  
                  <li :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Additional Info', 'Petitioner Info', 'Financial Info', 'Household Info' ].indexOf(currentTab)>-1}" @click="currentTab='Additional Info'"><span>2</span><a>Additional Info</a></li>
                  <li :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Petitioner Info', 'Financial Info', 'Household Info' ].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>3</span><a>Educational Info</a></li>
                  <li :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Petitioner Info', 'Financial Info', 'Household Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>4</span><a>Employement Info</a></li>
                  <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='ASSOCIATIONS/GROUPS Info'"><span>4</span><a>ASSOCIATIONS/GROUPS Info</a></li> -->
                  <li :class="{'active':['Documents Info' ,'Dependents Info','Parents Info','Sponsor Info', 'Petitioner Info', 'Financial Info' , 'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>5</span><a>Parents Info</a></li>
                  <li :class="{'active':['Documents Info' ,'Dependents Info', 'Sponsor Info', 'Petitioner Info', 'Household Info'].indexOf(currentTab)>-1}" @click="currentTab='Household Info'"><span>6</span><a>Household Info</a></li>

                  <!-- <li :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info', 'Financial Info' ].indexOf(currentTab)>-1}" @click="currentTab='Financial Info'"><span>2</span><a>Financial Info</a></li> -->
                  <li :class="{'active':['Documents Info' ,'Dependents Info','Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>6</span><a>Documents Info</a></li>
                  <li :class="{'active':['Dependents Info','Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>7</span><a>Dependents Info </a></li>
                  <li v-if="checkProperty(configDetails, 'entityType')=='I-130'" :class="{'active':['Sponsor Info', 'Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Sponsor Info'"><span>8</span><a>Sponsor Info </a></li>
                  <li v-if="checkProperty(configDetails, 'entityType')=='L-VISA'" :class="{'active':['Petitioner Info' ].indexOf(currentTab)>-1}" @click="currentTab='Petitioner Info'"><span>7</span><a>Petitioner Info </a></li>
                </template>   
           
            </ul>

              

            </div> 
            <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
          </div>
          <div class="questionnaire_form questionnaire_template_form">
            
            <div v-if="currentTab=='Personal Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT"> 
                    <div class="vx-row">
                      <template>
                       
                       <div class="vx-col w-full" >
                         <template v-if="showOrHideField({section: 'beneficiaryInfo',key: 'adjustmentOfI485Status'}) || showOrHideField({section: 'beneficiaryInfo',key: 'consularProcessing'})">
                           <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                         </template>
                          <template v-if="showOrHideField({section: 'beneficiaryInfo',key: 'adjustmentOfI485Status'})">
                            <div class="d-flex align-center">
                              <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                              <vs-checkbox :disabled="true"> Adjustment of Status (I-485)<p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green&nbsp;Card</p> </vs-checkbox>
                              </div>
                              <div class="check_box_container mart30" v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})}"  >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})">
                                  <vs-checkbox
                              
                                      v-model="beneficiaryInfo.adjustmentOfI485Status"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'adjustmentOfI485Status',
                                        })
                                      "
                                    ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'consularProcessing'})">
                       <div class="d-flex align-center">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true"> Consular Processing
                           <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                           abroad to apply for an immigrant visa to get your Green Card</p> </vs-checkbox>
                         </div>
                         <div class="check_box_container mart30" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'consularProcessing'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consularProcessing'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consularProcessing'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.consularProcessing"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'consularProcessing',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'areYouUnderRemoveOfIndOrUscis'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Are you currently under removal proceedings by the INS/USCIS? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.areYouUnderRemoveOfIndOrUscis"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'areYouUnderRemoveOfIndOrUscis',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyImmPetitionFiled'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Has any Immigrant Visa Petition ever been filed on your behalf? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.anyImmPetitionFiled"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'anyImmPetitionFiled',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'immPetitionPriorityDate'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Your priority date obtained from your previous immigrant petition<em v-if="beneficiaryInfo.immPetitionPriorityDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.immPetitionPriorityDate"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'immPetitionPriorityDate',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     </template>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentlyInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Are you currently in USA? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'currentlyInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'currentlyInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'currentlyInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.currentlyInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'currentlyInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
       
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveOwnershipInterest'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Do you have ownership interest in this Company?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'haveOwnershipInterest'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveOwnershipInterest'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveOwnershipInterest'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.haveOwnershipInterest"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveOwnershipInterest',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'ownershipInterestDesc'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Ownership Details<em v-if="beneficiaryInfo.ownershipInterestDesc">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'ownershipInterestDesc'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'ownershipInterestDesc'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'ownershipInterestDesc'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.ownershipInterestDesc"
                               @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'ownershipInterestDesc',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-textarea w-full vs-textarea-primary">
                           <textarea class="vs-textarea" :disabled="true"></textarea>
                         </div>
                       </div>
                     </div>




                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverAppliedH1bCase'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                          Have you ever applied for a H1B petition earlier?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.haveYouEverAppliedH1bCase"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveYouEverAppliedH1bCase',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'prevH1bCaseStatus'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Select the H1B petition status<em v-if="beneficiaryInfo.prevH1bCaseStatus">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'prevH1bCaseStatus'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseStatus'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseStatus'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.prevH1bCaseStatus"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'prevH1bCaseStatus',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'prevH1bCaseDesc'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Please mention Receipt Number and other information
                            <em v-if="beneficiaryInfo.prevH1bCaseDesc">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.prevH1bCaseDesc"
                               @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'prevH1bCaseDesc',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-textarea w-full vs-textarea-primary">
                           <textarea class="vs-textarea" :disabled="true"></textarea>
                         </div>
                       </div>
                     </div>
                     
                     

                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'beneficiaryCnfmNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">CAP Confirmation Number<em v-if="beneficiaryInfo.beneficiaryCnfmNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'beneficiaryCnfmNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'beneficiaryCnfmNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'beneficiaryCnfmNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.beneficiaryCnfmNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'beneficiaryCnfmNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>

                     



                     <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="beneficiaryInfo.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.gender"
                             @change="
                             selectCheck({ section: 'beneficiaryInfo', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                     </div>
                     <div class="divider full-divider mb-10"></div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'firstName'})">
                       <div class="vx-input-group flex form-input-group FML">
                         <div class="vx-input-group-default flex-grow">
                           <div class="vx-col w-full md:w-1/2">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">First Name<em v-if="beneficiaryInfo.firstName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.firstName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>

                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                           <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'middleName'})">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">Middle Name<em v-if="beneficiaryInfo.middleName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.middleName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                           <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'lastName'})">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">Last Name<em v-if="beneficiaryInfo.lastName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.lastName"
                                   @change="
                                     selectCheck({
                                       section: 'beneficiaryInfo',
                                       key: 'lastName',
                                     })
                                   "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'otherNames'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Have you ever used any other names previously?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'otherNames'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'otherNames'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'otherNames'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.otherNames"
                           @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'otherNames',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>                         
                       </div>
                     </div>
                     <!--485-->
                     
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'email'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Email<em v-if="beneficiaryInfo.email">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'email'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'email'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'email'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.email"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'email' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'cellPhoneNumber'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Phone Number<em v-if="beneficiaryInfo.cellPhoneNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.cellPhoneNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'cellPhoneNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-component">
                           <VuePhoneNumberInput
                             icon-pack="feather"
                             class="w-full no-icon-border"
                             :no-example="false"
                             key="phone"
                             data-vv-as="Phone Number"
                             name="phone"
                             placeholder="Phone Number"
                             :preferred-countries="['US', 'IN']"
                             :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'homePhoneNumber'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Home Phone Number<em v-if="beneficiaryInfo.homePhoneNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.homePhoneNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'homePhoneNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         
                         </div>
                         <div class="vs-component">
                           <VuePhoneNumberInput
                             icon-pack="feather"
                             class="w-full no-icon-border"
                             :no-example="false"
                             key="phone"
                             data-vv-as="Phone Number"
                             name="phone"
                             placeholder="Home Phone Number"
                             :preferred-countries="['US', 'IN']"
                             :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Birth<em v-if="beneficiaryInfo.countryOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'countryOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'provinceOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Province of Birth<em v-if="beneficiaryInfo.provinceOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.provinceOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'provinceOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'locationOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Birth<em v-if="beneficiaryInfo.locationOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'locationOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.locationOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'locationOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfCitizenship'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Country of Citizenship<em v-if="beneficiaryInfo.countryOfCitizenship">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfCitizenship"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfCitizenship',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.height',key: 'feet'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Feet<em v-if="beneficiaryInfo.height.feet">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.height',key:'feet'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.height',key:'feet'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.height',key:'feet'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.height.feet"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.height',
                                 key: 'feet',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.height',key: 'inches'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Inches<em v-if="beneficiaryInfo.height.inches">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.height',key:'inches'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.height',key:'inches'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.height',key:'inches'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.height.inches"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.height',
                                 key: 'inches',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'weight'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Weight<em v-if="beneficiaryInfo.weight">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'weight'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'weight'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'weight'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.weight"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'weight',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'race'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Ethnicity/Race<em v-if="beneficiaryInfo.race">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'race'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'race'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'race'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.race"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'race',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'eyeColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">EYE COLOR<em v-if="beneficiaryInfo.eyeColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'eyeColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'eyeColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'eyeColor'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.eyeColor"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'eyeColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hairColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">HAIR COLOR<em v-if="beneficiaryInfo.hairColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'hairColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hairColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hairColor'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.hairColor"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'hairColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     
                     <!-- <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaStatus'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Current Nonimmigrant visa category <em v-if="beneficiaryInfo.curNonImmigrantVisaStatus">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.curNonImmigrantVisaStatus"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'curNonImmigrantVisaStatus',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select">
                           </multiselect>
                         </div>
                       </div>
                     </div> -->
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'maritalStatus'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Marital Status<em v-if="beneficiaryInfo.maritalStatus">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'maritalStatus'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'maritalStatus'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'maritalStatus'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.maritalStatus"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'maritalStatus',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'noOfTimesMarriedBeneficiary'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">How many times has the beneficiary been married?<em v-if="beneficiaryInfo.noOfTimesMarriedBeneficiary">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'noOfTimesMarriedBeneficiary'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'noOfTimesMarriedBeneficiary'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'noOfTimesMarriedBeneficiary'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.noOfTimesMarriedBeneficiary"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'noOfTimesMarriedBeneficiary',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'noOfChildrens'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"> No of Childrens <em v-if="beneficiaryInfo.noOfChildrens">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'noOfChildrens'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'noOfChildrens'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'noOfChildrens'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.noOfChildrens"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'noOfChildrens',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="beneficiaryInfo.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="beneficiaryInfo.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Province of Marriage<em v-if="beneficiaryInfo.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="beneficiaryInfo.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'doYouHaveMarriageCert'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you have a Marriage Certificate? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.doYouHaveMarriageCert"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'doYouHaveMarriageCert',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'marriageCertDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >Marriage Certificates<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'marriageCertDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'marriageCertDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'marriageCertDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.marriageCertDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'marriageCertDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'have2AffidavitsAttestingToMarriage'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you have two(2) affidavits attesting to the marriage? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.have2AffidavitsAttestingToMarriage"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'have2AffidavitsAttestingToMarriage',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'birthCertHaveNamePobDob'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.birthCertHaveNamePobDob"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'birthCertHaveNamePobDob',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div> 
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'have2AffidavitsOfBirthFamily'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Do you have two (2) affidavits of birth from family members?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.have2AffidavitsOfBirthFamily"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'have2AffidavitsOfBirthFamily',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'nameDiffFromBirthCert'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> if your name is different from that stated on your birth certificate, have you had it legally changes? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.nameDiffFromBirthCert"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'nameDiffFromBirthCert',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo.education',key: 'highestDegree'})">
                                 <div class="form_group">
                                   <div class="d-flex align-end mb-1">
                                     <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.education.highestDegree">*</em></label>
                                     <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.education',key:'highestDegree'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.education',key:'highestDegree'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.education',key:'highestDegree'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.educations.highestDegree"
                                       @change="
                                         selectCheck({
                                           section: 'beneficiaryInfo.education',
                                           key: 'highestDegree',
                                         })
                                       "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                                     
                                   </div>
                                   <selectField
                                     wrapclass=""
                                     placeholder="Highest Degree"
                                     :disabled="true"
                                   />
                                 </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.education',key: 'majorFieldOfStudy'})">
                                 <div class="form_group">
                                   <div class="d-flex align-end mb-1">
                                     <label class="form_label"
                                       >Major Field of Study<em v-if="beneficiaryInfo.education.majorFieldOfStudy">*</em></label
                                     >
                                     <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})">
                             <vs-checkbox
                            
                             v-model="
                                         beneficiaryInfo.education.majorFieldOfStudy
                                       "
                                       @change="
                                         selectCheck({
                                           section: 'beneficiaryInfo.education',
                                           key: 'majorFieldOfStudy',
                                         })
                                       "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                                     
                                   </div>
                                   <div class="vs-con-input">
                                     <input
                                       type="text"
                                       class="vs-inputx vs-input--input normal" :disabled="true"
                                     />
                                   </div>
                                 </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'enterInUSUnderCaseWaiverProgram'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Did you enter the U.S. under the Visa waiver program?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.enterInUSUnderCaseWaiverProgram"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'enterInUSUnderCaseWaiverProgram',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>
                     
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverTravelledToUS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever travelled to the United States?<em v-if="beneficiaryInfo.haveYouEverTravelledToUS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.haveYouEverTravelledToUS"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'haveYouEverTravelledToUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'stateOfLastEntryInUS'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             > State of recent entry into the USA<em v-if="beneficiaryInfo.stateOfLastEntryInUS">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.stateOfLastEntryInUS"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'stateOfLastEntryInUS',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'placeOfLastEntryInUS'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Place of recent entry into the USA<em v-if="beneficiaryInfo.placeOfLastEntryInUS">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.placeOfLastEntryInUS"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'placeOfLastEntryInUS',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'lastArrivalDate'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Date of most recent entry into the USA<em v-if="beneficiaryInfo.lastArrivalDate">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'lastArrivalDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'lastArrivalDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'lastArrivalDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.lastArrivalDate"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'lastArrivalDate',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'inspectedByAnyImmOfficer'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Were you inspected by an immigration officer?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.inspectedByAnyImmOfficer"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'inspectedByAnyImmOfficer',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>

                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'issuedAnyEADFromUSCIS'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Have you ever been issued an Employement Authorization Document(EAD) from the USCIS?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.issuedAnyEADFromUSCIS"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'issuedAnyEADFromUSCIS',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'documents',key: 'eadCard'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >Please provide a copy of the EAD CARD(S), front and  back<em v-if="documents.eadCard">*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'documents',key:'eadCard'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'eadCard'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'eadCard'})">
                             <vs-checkbox
                            
                             v-model="documents.eadCard"
                                 @change="
                                   selectCheck({
                                     section: 'documents',
                                     key: 'eadCard',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'i140PriorityDate'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Priority Date of I-140<em v-if="beneficiaryInfo.i140PriorityDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'i140PriorityDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'i140PriorityDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'i140PriorityDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.i140PriorityDate"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'i140PriorityDate',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'classification'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Classificaton/Category<em v-if="beneficiaryInfo.classification">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'classification'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'classification'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'classification'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.classification"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'classification',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasPermResidencyInOtherCountry'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you hold Permanent residence in any other country? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.hasPermResidencyInOtherCountry"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'hasPermResidencyInOtherCountry',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Permanent Residency Country<em>*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.permResidencyCountryDetails"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'permResidencyCountryDetails',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouArrestedBefore'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been arrested,cited, charged or detained for any reason by an law enforcement official? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouArrestedBefore"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouArrestedBefore',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouArrestedBeforeDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >documents, if any<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.haveYouArrestedBeforeDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveYouArrestedBeforeDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>                  
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAppliedAOSInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever applied AOS in the united states or an immigrant visa at the US Embassy/Consulate to obatain permanent resident status before? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.everAppliedAOSInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'everAppliedAOSInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'appliedAOSInUSDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >documents, if any<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.appliedAOSInUSDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'appliedAOSInUSDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverReceivedPublicAssistendeInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever received public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouEverReceivedPublicAssistendeInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouEverReceivedPublicAssistendeInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverlikelyReceivePublicAssistendeInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Have you ever likely to receive public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)?
</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouEverlikelyReceivePublicAssistendeInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouEverlikelyReceivePublicAssistendeInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isVisaDenieedTOUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been denied a visa to the United States?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.isVisaDenieedTOUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'isVisaDenieedTOUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'visaDeniedReason'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Reason<em v-if="beneficiaryInfo.visaDeniedReason">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'visaDeniedReason'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'visaDeniedReason'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'visaDeniedReason'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.visaDeniedReason"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'visaDeniedReason',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYoueverPresntUnlawfully'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been present in the united states unlawfully for more than 180 days?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYoueverPresntUnlawfully"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYoueverPresntUnlawfully',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'presntUnlawfullyReason'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Reason<em v-if="beneficiaryInfo.presntUnlawfullyReason">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.presntUnlawfullyReason"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'presntUnlawfullyReason',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     
                     <!-- <div class="divider full-divider mb-0"></div> -->
                    </div>
                  </div>
                </vs-col>
              
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full" v-if="checkPassportLabel({section:'beneficiaryInfo'})" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3>
                            <div class="IB_tooltip H1-140 QT">
                              <span
                                ><info-icon size="1.5x" class="custom-class"></info-icon
                              ></span>
                              <div class="tooltip_cnt">
                                <p>
                                  Make sure you input the most recent passport
                                  information. Also, note that the passport must have more
                                  than 6 months validity.
                                </p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Number<em v-if="beneficiaryInfo.passportNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})}">
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.passportNumber"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'passportNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Passport Issued Date<em v-if="beneficiaryInfo.passportIssuedDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.passportIssuedDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'passportIssuedDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Passport Expiry Date<em v-if="beneficiaryInfo.passportExpiryDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.passportExpiryDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'passportExpiryDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportIssuedCountry'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Passport Issued<em v-if="beneficiaryInfo.passportIssuedCountry">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportIssuedCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedCountry'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.passportIssuedCountry"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'passportIssuedCountry',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Current nonimmigrant visa number<em v-if="beneficiaryInfo.curNonImmigrantVisaNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.curNonImmigrantVisaNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'curNonImmigrantVisaNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Current Non-Immigrant Status<em v-if="beneficiaryInfo.curNonImmigrantVisaStatus">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})}">
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.curNonImmigrantVisaStatus"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'curNonImmigrantVisaStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curVisaExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Current Status Expiry Date<em v-if="beneficiaryInfo.curVisaExpiryDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.curVisaExpiryDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'curVisaExpiryDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curVisaExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isDSExpiryDate'})">
                        <div class="">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box ">
                          <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                          </div>
                          <div class="check_box_container mart10" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                              <vs-checkbox
                                
                                  v-model="beneficiaryInfo.isDSExpiryDate"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'isDSExpiryDate',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div> 
                        <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Current Status Expiry Date<em v-if="beneficiaryInfo.curVisaExpiryDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.curVisaExpiryDate"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'curVisaExpiryDate' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                        </div>
                     </div>
                      <!-- <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">I-94 Number<em v-if="beneficiaryInfo.I94">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.I94"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'I94' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94ExpiryDate'})">
                      <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isI94DSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box ">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container mart10" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div> 
                      <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">I-94 Expiry Date<em v-if="beneficiaryInfo.I94ExpiryDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.I94ExpiryDate"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'I94ExpiryDate' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'sevisNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">SEVIS Number<em v-if="beneficiaryInfo.sevisNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'sevisNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'sevisNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'sevisNumber'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.sevisNumber"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'sevisNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'eadNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EAD Number<em v-if="beneficiaryInfo.eadNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'eadNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'eadNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'eadNumber'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.eadNumber"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'eadNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="beneficiaryInfo.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'mailingAddressIsSameAsAddress'})">
                        <h3 class="small-header">
                          Mailing Address <em v-if="beneficiaryInfo.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'mailingAddressIsSameAsAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'mailingAddressIsSameAsAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'mailingAddressIsSameAsAddress'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.mailingAddressIsSameAsAddress"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'mailingAddressIsSameAsAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S <em v-if="beneficiaryInfo.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.addressOutsideUS"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'addressOutsideUS' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'typeOfOffice'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Type of Office<em v-if="beneficiaryInfo.typeOfOffice">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'typeOfOffice'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'typeOfOffice'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'typeOfOffice'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.typeOfOffice"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'typeOfOffice',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border"> Consulate</vs-button>
                                <vs-button class="no mr-5" color="danger" type="border">Pre-flight inspection</vs-button>
                                <vs-button class="no" color="danger" type="border">Port of Entry</vs-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'officeAddress'})">
                        <h3 class="small-header">
                          Office Address <em v-if="beneficiaryInfo.officeAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'officeAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'officeAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'officeAddress'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.officeAddress"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'officeAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="divider full-divider mb-5"></div>
                      <!--new address-->
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'addressOutsideUSMoreThanYear'})">
                        <h3 class="small-header">
                          Last Address outside Of the United States for more than one year<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.addressOutsideUSMoreThanYear"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'addressOutsideUSMoreThanYear' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="beneficiaryInfo.addressOutsideUSMoreThanYear.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.addressOutsideUSMoreThanYear.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="beneficiaryInfo.addressOutsideUSMoreThanYear.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.addressOutsideUSMoreThanYear.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                      <div class="divider full-divider mb-5"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'addressOfLastNYears'})">
                        <h3 class="small-header">
                          Your Residence starting with most current for the Past Five Years in the U.S and Aboard<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOfLastNYears'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOfLastNYears'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOfLastNYears'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.addressOfLastNYears"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'addressOfLastNYears' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOfLastNYears',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="beneficiaryInfo.addressOfLastNYears.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.addressOfLastNYears.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.addressOfLastNYears',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOfLastNYears',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="beneficiaryInfo.addressOfLastNYears.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.addressOfLastNYears.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.addressOfLastNYears',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                      <div class="divider full-divider mb-5"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'consulateInfo'})">
                        <h3 class="small-header">
                          Consulate you want to attend the visa interview<em v-if="beneficiaryInfo.consulateInfo">*</em>
                        <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'consulateInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consulateInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consulateInfo'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.consulateInfo"
                          @change="
                            selectCheck({
                              section: 'beneficiaryInfo',
                              key: 'consulateInfo',
                            })
                          "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </h3>
                       
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <!-- <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div> -->
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'SSN'})">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full mb-5">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security number (if applicable)<em v-if="beneficiaryInfo.SSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'SSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.SSN"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'SSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'beneficiaryInfo',key: 'alienNumber'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Your Alien Number (if applicable)<em v-if="beneficiaryInfo.alienNumber">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'alienNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.alienNumber"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'alienNumber',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'beneficiaryInfo',key: 'consulateNotifyAddress'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Consulate to Notify upon Approval of your petition (if outside the USA)<em v-if="beneficiaryInfo.consulateNotifyAddress">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'consulateNotifyAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consulateNotifyAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consulateNotifyAddress'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.consulateNotifyAddress"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'consulateNotifyAddress',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasI140ImmPetitionFiled'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Has I-140 immigrant petition been filed on your behalf?<em v-if="beneficiaryInfo.hasI140ImmPetitionFiled">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.hasI140ImmPetitionFiled"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'hasI140ImmPetitionFiled',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I140ApprovalNotice'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >I-140 Approval Notice, if any<em v-if="beneficiaryInfo.I140ApprovalNotice">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'documents',key:'I140ApprovalNotice'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'I140ApprovalNotice'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'I140ApprovalNotice'})">
                              <vs-checkbox
                             
                              v-model="documents.I140ApprovalNotice"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'I140ApprovalNotice',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'didThisPtnrFliedImmPetitionEarlier'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Has this employer ever filed a Non-Immigrant H1B petition for you earlier?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.didThisPtnrFliedImmPetitionEarlier"
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo',
                                key: 'didThisPtnrFliedImmPetitionEarlier',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'nonImmPetitionsInfo'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-0 mb-5">
                              <div class="d-flex">
                                  <h3 class="small-header">
                                    Non-Immigrant Petitions Information<em v-if="beneficiaryInfo.nonImmPetitionsInfo">*</em>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})">
                                      <vs-checkbox
                                    
                                      v-model="beneficiaryInfo.nonImmPetitionsInfo"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'nonImmPetitionsInfo',
                                          })
                                        "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                </div>
                                  </h3>
                              </div>
                              <p>List all the petitions filed till date on your behalf</p>
                            </div>
                            <div class="vx-col w-full">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Visa Status</label>
                                    </div>
                                    <selectField wrapclass="" placeholder="Visa Status" />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Receipt Number</label>
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Petitioner/Employer Name</label
                                      >
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Valid From</label>
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="mx-input-wrapper">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Valid To</label>
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="mx-input-wrapper">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                      
                  
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-5 mb-5">
                              <div class="d-flex">
                              <h3 class="small-header">Dates of Stay in USA<em v-if="beneficiaryInfo.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.priorPeriodOfStayInUS"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'priorPeriodOfStayInUS',
                                      })
                                    "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                              </div>
                              </h3>
                          </div>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa Status</label>
                                </div>
                                <selectField wrapclass="" placeholder="Visa Status" />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="mx-input-wrapper">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                       
                      </div>
                      <template>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyImmPetitionFiled'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                          Has any immigrant Visa petition I-140 ever been filed on your behalf?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.anyImmPetitionFiled"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'anyImmPetitionFiled',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                      </div>
                     <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyImmPetitionFiledDesc'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Immigrant Visa Petition Details<em v-if="beneficiaryInfo.anyImmPetitionFiledDesc">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.anyImmPetitionFiledDesc"
                               @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'anyImmPetitionFiledDesc',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-textarea w-full vs-textarea-primary">
                           <textarea class="vs-textarea"></textarea>
                         </div>
                       </div>
                     </div>
                        <div class="vx-col w-full">
                          <h3 class="small-header" v-if=" showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'}) || 
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyI140Filed'}) ||  showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'fieldDate'}) || 
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'employerName'}) ||  showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'priorityDate'}) || 
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'currentStatus'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'eb2orEb3'}) 

                          ">
                            Immigrant Petition Information<em v-if="beneficiaryInfo.h1bImmPetitionsInfo">*</em>
                            <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})">
                                      <vs-checkbox
                                    
                                      v-model="beneficiaryInfo.h1bImmPetitionsInfo"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'h1bImmPetitionsInfo',
                                          })
                                        "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                </div>
                          </h3>
                        </div>
                        <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'h1bImmPetitionsInfo'})">
                            <p>List all the petitions filed till date on your behalf</p>
                            <div class="vx-col w-full">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Petition Type</label>
                                    </div>
                                    <selectField wrapclass="" placeholder="Petition Type" />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Receipt Number</label>
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Petitioner/Employer Name</label
                                      >
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Valid From</label>
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="mx-input-wrapper">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/3 w-full">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Valid To</label>
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="mx-input-wrapper">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                            </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Has any other Alien Employment Certification, a.k.a Labor Certification been filed on your behalf?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.anyOtherAlienFiled"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'anyImmPetitionFiled',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date Filed<em v-if="beneficiaryInfo.immPetitionInfo.filedDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.filedDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo',
                                  key: 'filedDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Name of the Employer<em v-if="beneficiaryInfo.immPetitionInfo.employerName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.employerName"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'employerName' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            RIR or Regular Processing
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.rirOrRegularProcessing"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'rirOrRegularProcessing',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">State where it was filed<em v-if="beneficiaryInfo.immPetitionInfo.filedStateId">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.filedStateId"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo',
                                  key: 'filedStateId',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status of the Application<em v-if="beneficiaryInfo.immPetitionInfo.applCurStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.applCurStatus"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'applCurStatus' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Are you seeking to utilize the filing date from a previously submitted Application for Alien Employment Certification (ETA 750)?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.seekingFiledDateforETA750"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'seekingFiledDateforETA750',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyI140Filed'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Has any I-140 Petition been filed on your behalf?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.anyI140Filed"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'anyI140Filed',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'fieldDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date Filed<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.fieldDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.i140Info.fieldDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo.i140Info',
                                  key: 'fieldDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'employerName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Name of the Employer<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.employerName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.i140Info.employerName"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'employerName' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'priorityDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Priority Date<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.priorityDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.i140Info.priorityDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo.i140Info',
                                  key: 'priorityDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status of the I-140<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.i140Info.currentStatus"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'currentStatus' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'eb2orEb3'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EB2/EB3<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.eb2orEb3">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.i140Info.eb2orEb3"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'eb2orEb3' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                      </template>
                      
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasApprovedI140'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Approved I-140 (from any employer that has not been revoked within 180 days of its approval)
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasApprovedI140'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasApprovedI140'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasApprovedI140'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.hasApprovedI140"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo',
                                key: 'hasApprovedI140',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasPermPendingForMorethan365Days'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            PERM application pending for more than 365 days
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.hasPermPendingForMorethan365Days"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo',
                                key: 'hasPermPendingForMorethan365Days',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="divider full-divider mb-10"></div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'previouslyMarried'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Were you married previously? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previouslyMarried"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'previouslyMarried',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                        </div>
                        
                     <div class="vx-col w-full" v-if="checkSpouseLabel({section:'beneficiaryInfo.previousSpouse'})" >
                       <div class="form_group w-full">
                         <label class="form_label"
                           ><h3 class="small-header">Previous Spouse
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              beneficiaryInfo.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                           </h3> 
                         </label>
                       </div>
                     </div>  
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'firstName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">First Name<em v-if="beneficiaryInfo.previousSpouse.firstName">*</em></label>

                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                            
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.firstName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'middleName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Middle Name<em v-if="beneficiaryInfo.previousSpouse.middleName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.middleName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'lastName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Last Name<em v-if="beneficiaryInfo.previousSpouse.lastName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.lastName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'lastName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'maidenName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Maiden Name<em v-if="beneficiaryInfo.previousSpouse.maidenName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.maidenName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'maidenName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.previousSpouse.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriageEnd'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage End<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriageEnd">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriageEnd"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriageEnd',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Marriage<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Termination<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Termination<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Termination<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedDueTo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Marriage Ended Due To<em v-if="beneficiaryInfo.previousSpouse.marriageEndedDueTo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedDueTo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedDueTo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedOtherInfo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">If, Marriage Ended<em v-if="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedOtherInfo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previousSpouse.obtainPermResidenceThroughSpouse"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo.previousSpouse',
                                   key: 'obtainPermResidenceThroughSpouse',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                    </div>
                  </div>
                </vs-col>
                <vs-col class="w-full p-0 mt-5" v-if="checkAssociationLabel({section:'beneficiaryInfo.associations'})">
                        <vs-alert
                        color="warning"
                        class="warning-alert top-warning-alert"
                        icon-pack="IntakePortal"
                        icon="IP-information-button"
                        active="true"
                        >
                          All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None".
                        </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                
                <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header" v-if="checkAssociationLabel({section:'beneficiaryInfo.associations'})">ASSOCIATIONS/GROUPS
                    <div class="check_box_container"  v-if="isEdit">
                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'associations'})">
                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'associations'})}" >
                          <span class="checkmark" >
                            <i class="material-icons">check</i>
                          </span>
                        </span>
                        <div class="tooltip_cnt">
                          <p>Field is required</p>
                        </div>
                      </div>
                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'associations'})">
                        <vs-checkbox
                            v-model="
                          beneficiaryInfo.associations.associations
                        "
                        @change="
                          selectCheck({
                            section: 'beneficiaryInfo.associations',
                            key: 'associations',
                          })
                        "
                        ></vs-checkbox>
                        <div class="tooltip_cnt">
                            <p>Validation is required</p>
                        </div>
                      </div>
                    </div>
                  </h3>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'name'})">
                              <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Name of the associations and groups<em v-if="beneficiaryInfo.associations.name">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'name'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'name'})}">
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'name'})">
                                            <vs-checkbox
                      
                                                  v-model="beneficiaryInfo.associations.name"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo.associations',
                                                      key: 'name',
                                                    })
                                                  "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                          </div>
                                    </div>
                                  </div>
                                  <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                                  </div>
                              </div>
                          </div>    
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'startDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Start Date<em v-if="beneficiaryInfo.associations.startDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'startDate'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'startDate'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'startDate'})">
                                <vs-checkbox
                              
                                v-model="beneficiaryInfo.associations.startDate"
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo.associations',
                                key: 'startDate',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                              :disabled="true"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                          </div>                                 
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'endDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">End Date<em v-if="beneficiaryInfo.associations.endDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'endDate'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'endDate'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'endDate'})">
                                <vs-checkbox
                              
                                v-model="beneficiaryInfo.associations.endDate"
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo.associations',
                                key: 'endDate',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                              :disabled="true"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                          </div>                                 
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'natureofAssociations'})">
                              <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Nature of associations and groups<em v-if="beneficiaryInfo.associations.natureofAssociations">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'natureofAssociations'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'natureofAssociations'})}">
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'natureofAssociations'})">
                                            <vs-checkbox
                      
                                                  v-model="beneficiaryInfo.associations.natureofAssociations"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo.associations',
                                                      key: 'natureofAssociations',
                                                    })
                                                  "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                          </div>
                                    </div>
                                  </div>
                                  <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                                  </div>
                              </div>
                          </div>             
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'address'})">
                <h3 class="small-header">
                Address<em v-if="beneficiaryInfo.associations.address">*</em>
                <div class="check_box_container"  v-if="isEdit">
                    <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'address'})">
                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'address'})}" >
                        <span class="checkmark" >
                          <i class="material-icons">check</i>
                        </span>
                      </span>
                      <div class="tooltip_cnt">
                        <p>Field is required</p>
                      </div>
                    </div>
                    <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'address'})">
                      <vs-checkbox
                    
                      v-model="beneficiaryInfo.associations.address"
                  @change="
                    selectCheck({
                      section: 'beneficiaryInfo.associations',
                      key: 'address',
                    })
                  "
                      ></vs-checkbox>
                      <div class="tooltip_cnt">
                        <p>Validation is required</p>
                      </div>
                    </div>
                    </div>
                </h3>
              
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="form_group">
                      <div class="con-select w-full select-large">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Country</label>
                        </div>
                        <multiselect
                          name="Status"
                          :multiple="false"
                          :options="[]"
                          :hideSelected="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select Country"
                          :preselect-first="false"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="form_group">
                      <div class="con-select w-full select-large">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"> State</label>
                        </div>
                        <multiselect
                          name="Status"
                          :multiple="false"
                          :options="[]"
                          :hideSelected="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select State"
                          :preselect-first="false"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="form_group">
                      <div class="con-select w-full select-large">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"> City</label>
                        </div>
                        <multiselect
                          name="Status"
                          :multiple="false"
                          :options="[]"
                          :hideSelected="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select City"
                          :preselect-first="false"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                          </div>                 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                
                <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header">Public Charge</h3>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'inadmissibility'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Are you subject to the public charge ground of inadmissibility under INA section 212(a)(4)?<em v-if="beneficiaryInfo.inadmissibility">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'inadmissibility'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'inadmissibility'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'inadmissibility'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.inadmissibility"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'inadmissibility',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'highestDegreeCompleted'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">What is the highest degree or level of school you have completed?<em v-if="beneficiaryInfo.highestDegreeCompleted">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'highestDegreeCompleted'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'highestDegreeCompleted'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'highestDegreeCompleted'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.highestDegreeCompleted"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'highestDegreeCompleted',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'listOfCertifications'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">List your certifications, licenses, skills obtained through work experience, and educational certificates.
                                <em v-if="beneficiaryInfo.listOfCertifications">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'listOfCertifications'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'listOfCertifications'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'listOfCertifications'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.listOfCertifications"
                                    @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'listOfCertifications',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="vs-con-textarea w-full vs-textarea-primary">
                                <textarea class="vs-textarea" :disabled="true"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'SSI'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> Have you ever received Supplemental Security Income (SSI), Temporary Assistance for Needy Families 
                          (TANF), or State, Tribal, territorial, or local, cash benefit programs for income maintenance (often called 
“General Assistance” in the State context, but which also exist under other names)?<em v-if="beneficiaryInfo.SSI">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'SSI'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'SSI'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'SSI'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.SSI"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'SSI',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>

                          <h3 class="small-header">list the specific benefit(s) you received, the start and end dates of each period of receipt, and the dollar amount of benefits received</h3>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benefitsRecAmounts',key: 'benefitReceived'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Benefit Received<em v-if="beneficiaryInfo.benefitsRecAmounts.benefitReceived">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.benefitsRecAmounts',key:'benefitReceived'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'benefitReceived'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'benefitReceived'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.benefitsRecAmounts.benefitReceived"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.benefitsRecAmounts',
                                      key: 'benefitReceived',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benefitsRecAmounts',key: 'startDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Start Date<em v-if="beneficiaryInfo.benefitsRecAmounts.startDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benefitsRecAmounts',key:'startDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'startDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'startDate'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.benefitsRecAmounts.startDate"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.benefitsRecAmounts',
                                      key: 'startDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benefitsRecAmounts',key: 'endDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >End Date<em v-if="beneficiaryInfo.benefitsRecAmounts.endDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benefitsRecAmounts',key:'endDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'endDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'endDate'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.benefitsRecAmounts.endDate"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.benefitsRecAmounts',
                                      key: 'endDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benefitsRecAmounts',key: 'amount'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Amount($)<em v-if="beneficiaryInfo.benefitsRecAmounts.amount">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.benefitsRecAmounts',key:'amount'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'amount'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benefitsRecAmounts',key:'amount'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.benefitsRecAmounts.amount"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.benefitsRecAmounts',
                                      key: 'amount',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'longTermInstiAtGovtExpense'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Have you ever received long-term institutionalization at government expense?<em v-if="beneficiaryInfo.longTermInstiAtGovtExpense">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'longTermInstiAtGovtExpense'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'longTermInstiAtGovtExpense'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'longTermInstiAtGovtExpense'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.longTermInstiAtGovtExpense"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'longTermInstiAtGovtExpense',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'institutionName'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Institution Name<em v-if="beneficiaryInfo.periodOfInstutions.institutionName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'institutionName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'institutionName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'institutionName'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.institutionName"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'institutionName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'stateDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >State<em v-if="beneficiaryInfo.periodOfInstutions.stateDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'stateDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'stateDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'stateDetails'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.stateDetails"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'stateDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'locationDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Location<em v-if="beneficiaryInfo.periodOfInstutions.locationDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'locationDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'locationDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'locationDetails'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.locationDetails"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'locationDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'dateFrom'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date From<em v-if="beneficiaryInfo.periodOfInstutions.dateFrom">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'dateFrom'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'dateFrom'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'dateFrom'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.dateFrom"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'dateFrom',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'dateTo'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date To<em v-if="beneficiaryInfo.periodOfInstutions.dateTo">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'dateTo'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'dateTo'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'dateTo'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.dateTo"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'dateTo',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.periodOfInstutions',key: 'reason'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Reason<em v-if="beneficiaryInfo.periodOfInstutions.reason">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.periodOfInstutions',key:'reason'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'reason'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.periodOfInstutions',key:'reason'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.periodOfInstutions.reason"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.periodOfInstutions',
                                      key: 'reason',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>
              </form>
            </div>
            <div v-if="currentTab=='Financial Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                  <h3 class="small-header">Income 
                      
                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.benfIncome.benfIncome"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.benfIncome',
                                            key: 'benfIncome',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                  </h3>
                  <div class="vx-row">
                      <div class="vx-col w-full">
                          <div class="form-container alt-rows-bg questionnaire_hb">
                              <div class="vx-row">
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'firstName'})">
                                      <div class="vx-input-group flex form-input-group FML">
                                        <div class="vx-input-group-default flex-grow">
                                          <div class="vx-col w-full md:w-1/2">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">First Name<em v-if="beneficiaryInfo.benfIncome.firstName">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'firstName'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'firstName'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'firstName'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.firstName"
                                            @change="
                                              selectCheck({
                                                section: 'beneficiaryInfo.benfIncome',
                                                key: 'firstName',
                                              })
                                            "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>

                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                  <input
                                                    type="text"
                                                    maxlength="200"
                                                    class="vs-inputx vs-input--input normal"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'middleName'})">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">Middle Name<em v-if="beneficiaryInfo.benfIncome.middleName">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'middleName'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'middleName'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'middleName'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.middleName"
                                            @change="
                                              selectCheck({
                                                section: 'beneficiaryInfo.benfIncome',
                                                key: 'middleName',
                                              })
                                            "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                  <input
                                                    type="text"
                                                    maxlength="200"
                                                    class="vs-inputx vs-input--input normal"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'lastName'})">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">Last Name<em v-if="beneficiaryInfo.benfIncome.lastName">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'lastName'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'lastName'})}"  >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'lastName'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.lastName"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo.benfIncome',
                                                      key: 'lastName',
                                                    })
                                                  "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                  <input
                                                    type="text"
                                                    maxlength="200"
                                                    class="vs-inputx vs-input--input normal"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                              </div>
                              <div class="vx-row">
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'dateOfBirth'})">
                                      <div class="vx-input-group flex form-input-group FML">
                                        <div class="vx-input-group-default flex-grow">
                                          <div class="vx-col w-full md:w-1/2">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.benfIncome.dateOfBirth">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'dateOfBirth'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'dateOfBirth'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'dateOfBirth'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.dateOfBirth"
                                            @change="
                                              selectCheck({
                                                section: 'beneficiaryInfo.benfIncome',
                                                key: 'dateOfBirth',
                                              })
                                            "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>

                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'relToTheBenf'})">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">Relationship to the Beneficiary<em v-if="beneficiaryInfo.benfIncome.relToTheBenf">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'relToTheBenf'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'relToTheBenf'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'relToTheBenf'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.relToTheBenf"
                                            @change="
                                              selectCheck({
                                                section: 'beneficiaryInfo.benfIncome',
                                                key: 'relToTheBenf',
                                              })
                                            "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                  <input
                                                    type="text"
                                                    maxlength="200"
                                                    class="vs-inputx vs-input--input normal"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfIncome',key: 'amount'})">
                                            <div class="form_group">
                                              <div class="d-flex align-end mb-1">
                                                <label class="form_label">Amount<em v-if="beneficiaryInfo.benfIncome.amount">*</em></label>
                                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'amount'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'amount'})}"  >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'amount'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.benfIncome.amount"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo.benfIncome',
                                                      key: 'amount',
                                                    })
                                                  "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                              </div>
                                              <div class="vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                  <input
                                                    type="text"
                                                    maxlength="200"
                                                    class="vs-inputx vs-input--input normal"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                              </div>
                              
                          </div>
                      </div>
                  </div>
                </div>
                <div class="form-container pt-10 form-container_QT">
                  <!-- <h3 class="small-header">Assets</h3> -->
                  <h3 class="small-header">Assets 
                      
                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'benfAssets'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'benfAssets'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'benfAssets'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.benfAssets.benfAssets"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.benfAssets',
                                            key: 'benfAssets',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                                <div class="vx-row">
                                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.benfAssets',key: 'firstName'})">
                                        <div class="vx-input-group flex form-input-group FML">
                                          <div class="vx-input-group-default flex-grow">
                                            <div class="vx-col w-full md:w-1/2">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">First Name<em v-if="beneficiaryInfo.benfAssets.firstName">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'firstName'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'firstName'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'firstName'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.benfAssets.firstName"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo.benfAssets',
                                                  key: 'firstName',
                                                })
                                              "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>

                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfAssets',key: 'middleName'})">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Middle Name<em v-if="beneficiaryInfo.benfAssets.middleName">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'middleName'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'middleName'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'middleName'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.benfAssets.middleName"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo.benfAssets',
                                                  key: 'middleName',
                                                })
                                              "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfAssets',key: 'lastName'})">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Last Name<em v-if="beneficiaryInfo.benfAssets.lastName">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'lastName'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'lastName'})}"  >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'lastName'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.benfAssets.lastName"
                                                    @change="
                                                      selectCheck({
                                                        section: 'beneficiaryInfo.benfAssets',
                                                        key: 'lastName',
                                                      })
                                                    "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                </div>

                                <div class="vx-row">
                                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfAssets',key: 'typeOfAsset'})">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Type of Asset<em v-if="beneficiaryInfo.benfAssets.typeOfAsset">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'typeOfAsset'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'typeOfAsset'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'typeOfAsset'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.benfAssets.typeOfAsset"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo.benfAssets',
                                                  key: 'typeOfAsset',
                                                })
                                              "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.benfAssets',key: 'amount'})">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Amount<em v-if="beneficiaryInfo.benfAssets.amount">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfAssets',key:'amount'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'amount'})}"  >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfAssets',key:'amount'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.benfAssets.amount"
                                                    @change="
                                                      selectCheck({
                                                        section: 'beneficiaryInfo.benfAssets',
                                                        key: 'amount',
                                                      })
                                                    "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                        </div>
                      </div>
                    </div>
                 </div>
                 <div class="vx-col w-full mb-5 mt-5" style="padding-left:35px;" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'illegalGamblingOrDrug'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Does any of the beneficiary's total income (including income from dependents and other individuals who contribute to the beneficiary's income, excluding any individuals) come from an illegal activity or source (such as proceeds from illegal gambling or illegal drug sales)?<em v-if="beneficiaryInfo.illegalGamblingOrDrug">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'illegalGamblingOrDrug'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'illegalGamblingOrDrug'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'illegalGamblingOrDrug'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.illegalGamblingOrDrug"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'illegalGamblingOrDrug',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
              <div class="form-container pt-10 form-container_QT">
              <div class="vx-row">
              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'illegalActivityOrSource'})">
                                              <div class="form_group">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">What amount of the beneficiary's total income comes from an illegal activity or source<em v-if="beneficiaryInfo.illegalActivityOrSource">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'illegalActivityOrSource'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'illegalActivityOrSource'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'illegalActivityOrSource'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.illegalActivityOrSource"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'illegalActivityOrSource',
                                                })
                                              "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                                </div>
                                                <div class="vs-input w-full vs-input-primary">
                                                  <div class="vs-con-input">
                                                    <input
                                                      type="text"
                                                      maxlength="200"
                                                      class="vs-inputx vs-input--input normal"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
               
 
              </form>
            </div>
            <div v-if="currentTab=='Household Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                  <h3 class="small-header">Household Info </h3>
                  <!-- <h3 class="small-header">Household Info 
                    <div class="check_box_container"  v-if="isEdit">
                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})">
                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})}" >
                          <span class="checkmark" >
                            <i class="material-icons">check</i>
                          </span>
                        </span>
                        <div class="tooltip_cnt">
                          <p>Field is required</p>
                        </div>
                      </div>
                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.benfIncome',key:'benfIncome'})">
                        <vs-checkbox
                        
                        v-model="beneficiaryInfo.benfIncome.benfIncome"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.benfIncome',
                                      key: 'benfIncome',
                                    })
                                  "
                        ></vs-checkbox>
                        <div class="tooltip_cnt">
                          <p>Validation is required</p>
                        </div>
                      </div>
                    </div>
                  </h3> -->
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'houseHoldNumber'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">What is the size of your household<em v-if="beneficiaryInfo.houseHoldNumber">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'houseHoldNumber'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldNumber'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.houseHoldNumber"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'houseHoldNumber',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'houseHoldAnnualIncome'})">
                            <div class="vx-row">
                              <div class="vx-col w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"
                                      >Indicate your annual household income<em v-if="beneficiaryInfo.houseHoldAnnualIncome">*</em></label
                                    >
                                    <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'houseHoldAnnualIncome'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualIncome'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualIncome'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.houseHoldAnnualIncome"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'houseHoldAnnualIncome',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                    
                                  </div>
                                  <div class="form_radio_btns">
                                    <vs-button class="yes mr-5" color="success" type="border">
                                      $0-27,000  </vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$27,001-52,000  </vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$52,001-85,000</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >$85,001-141,000</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >Over $141,000</vs-button
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>         
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'houseHoldAnnualAssets'})">
                            <div class="vx-row">
                              <div class="vx-col w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"
                                      >Identify the total value of your household assets<em v-if="beneficiaryInfo.houseHoldAnnualAssets">*</em></label
                                    >
                                    <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'houseHoldAnnualAssets'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualAssets'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualAssets'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.houseHoldAnnualAssets"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'houseHoldAnnualAssets',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                    
                                  </div>
                                  <div class="form_radio_btns">
                                    <vs-button class="yes mr-5" color="success" type="border">
                                      $0-18,400  </vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$18,401-136,000  </vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$136,001-321,400</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >$321,401-707,100</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >Over $707,100</vs-button
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'houseHoldAnnualliabilities'})">
                            <div class="vx-row">
                              <div class="vx-col w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"
                                      >Identify the total value of your household liabilities (including both secured and unsecured liabilities).<em v-if="beneficiaryInfo.houseHoldAnnualliabilities">*</em></label
                                    >
                                    <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'houseHoldAnnualliabilities'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualliabilities'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'houseHoldAnnualliabilities'})">
                                  <vs-checkbox
                                
                                  v-model="beneficiaryInfo.houseHoldAnnualliabilities"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'houseHoldAnnualliabilities',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                    
                                  </div>
                                  <div class="form_radio_btns">
                                    <vs-button class="yes mr-5" color="success" type="border">
                                      $0</vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$1-10,100  </vs-button
                                    >
                                    <vs-button class="no mr-5" color="danger" type="border"
                                      >$10,101-57,700</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >$57,701-186,800</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >Over $186,800</vs-button
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- Additional Info -->
            <div v-if="currentTab=='Additional Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT">
                    <h3 class="small-header">Additional Information 
                      
                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'i485AdditionalInformation'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'i485AdditionalInformation'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'i485AdditionalInformation'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.i485AdditionalInformation"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'i485AdditionalInformation',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                    </h3> 
                    <div class="vx-row">
                      <!-- v-if="checkProperty(beneficiaryInfo, 'i485AdditionalInformation')" --> 
                      <template >
                        <h3 class="small-header">General Eligibility and Inadmissibility Grounds</h3>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everDeniedAdmissionInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been denied admission to the United States?<em v-if="beneficiaryInfo.everDeniedAdmissionInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everDeniedAdmissionInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everDeniedAdmissionInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everDeniedAdmissionInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everDeniedAdmissionInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everDeniedAdmissionInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isVisaDenieedTOUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been denied a visa to the United States?<em v-if="beneficiaryInfo.isVisaDenieedTOUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.isVisaDenieedTOUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'isVisaDenieedTOUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everWorkedInUSWithoutAuth'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER worked in the United States without authorization?<em v-if="beneficiaryInfo.everWorkedInUSWithoutAuth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everWorkedInUSWithoutAuth'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everWorkedInUSWithoutAuth'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everWorkedInUSWithoutAuth'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everWorkedInUSWithoutAuth"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everWorkedInUSWithoutAuth',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everViolatedTandCofYourNonImmStatus'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER violated the terms or conditions of your nonimmigrant status?<em v-if="beneficiaryInfo.everViolatedTandCofYourNonImmStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everViolatedTandCofYourNonImmStatus'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everViolatedTandCofYourNonImmStatus'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everViolatedTandCofYourNonImmStatus'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everViolatedTandCofYourNonImmStatus"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everViolatedTandCofYourNonImmStatus',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everBeenInRemovalExcl'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?<em v-if="beneficiaryInfo.everBeenInRemovalExcl">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everBeenInRemovalExcl'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everBeenInRemovalExcl'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everBeenInRemovalExcl'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everBeenInRemovalExcl"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everBeenInRemovalExcl',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everBeenIssuedOrderExclRemoval'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been issued a final order of exclusion, deportation, or removal?<em v-if="beneficiaryInfo.everBeenIssuedOrderExclRemoval">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everBeenIssuedOrderExclRemoval'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everBeenIssuedOrderExclRemoval'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everBeenIssuedOrderExclRemoval'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everBeenIssuedOrderExclRemoval"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everBeenIssuedOrderExclRemoval',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everHadPriorOrderExclDeport'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?<em v-if="beneficiaryInfo.everHadPriorOrderExclDeport">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everHadPriorOrderExclDeport'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everHadPriorOrderExclDeport'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everHadPriorOrderExclDeport'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everHadPriorOrderExclDeport"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everHadPriorOrderExclDeport',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everHeldPermResidentStatus'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER held lawful permanent resident status which was later rescinded?<em v-if="beneficiaryInfo.everHeldPermResidentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everHeldPermResidentStatus'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everHeldPermResidentStatus'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everHeldPermResidentStatus'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everHeldPermResidentStatus"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everHeldPermResidentStatus',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everGrantedVolDepartimmgOfficer'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?<em v-if="beneficiaryInfo.everGrantedVolDepartimmgOfficer">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everGrantedVolDepartimmgOfficer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everGrantedVolDepartimmgOfficer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everGrantedVolDepartimmgOfficer'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everGrantedVolDepartimmgOfficer"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everGrantedVolDepartimmgOfficer',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAppliedReliefOrExclDeport'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?<em v-if="beneficiaryInfo.everAppliedReliefOrExclDeport">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAppliedReliefOrExclDeport'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedReliefOrExclDeport'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedReliefOrExclDeport'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAppliedReliefOrExclDeport"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAppliedReliefOrExclDeport',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everJNonImmmExchangeVistor'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?<em v-if="beneficiaryInfo.everJNonImmmExchangeVistor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everJNonImmmExchangeVistor'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everJNonImmmExchangeVistor'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everJNonImmmExchangeVistor'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everJNonImmmExchangeVistor"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everJNonImmmExchangeVistor',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everCompailedForeignResi'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you complied with the foreign residence requirement?<em v-if="beneficiaryInfo.everCompailedForeignResi">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everCompailedForeignResi'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everCompailedForeignResi'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everCompailedForeignResi'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everCompailedForeignResi"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everCompailedForeignResi',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everGrantedWavierRecomndLtr'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you?<em v-if="beneficiaryInfo.everGrantedWavierRecomndLtr">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everGrantedWavierRecomndLtr'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everGrantedWavierRecomndLtr'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everGrantedWavierRecomndLtr'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everGrantedWavierRecomndLtr"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everGrantedWavierRecomndLtr',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <h3 class="small-header">Criminal Acts and Violations</h3>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everArrested'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?<em v-if="beneficiaryInfo.everArrested">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everArrested'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everArrested'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everArrested'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everArrested"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everArrested',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everCommittedCrime'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? <em v-if="beneficiaryInfo.everCommittedCrime">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everCommittedCrime'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everCommittedCrime'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everCommittedCrime'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everCommittedCrime"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everCommittedCrime',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everPledGuilty'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?<em v-if="beneficiaryInfo.everPledGuilty">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everPledGuilty'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everPledGuilty'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everPledGuilty'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everPledGuilty"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everPledGuilty',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everPunishedByJudge'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?<em v-if="beneficiaryInfo.everPunishedByJudge">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everPunishedByJudge'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everPunishedByJudge'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everPunishedByJudge'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everPunishedByJudge"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everPunishedByJudge',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAccusedCrimProc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? <em v-if="beneficiaryInfo.everAccusedCrimProc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAccusedCrimProc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAccusedCrimProc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAccusedCrimProc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAccusedCrimProc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAccusedCrimProc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everViolated'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country? <em v-if="beneficiaryInfo.everViolated">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everViolated'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everViolated'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everViolated'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everViolated"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everViolated',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everConvictedTwoOrMoreOffens'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years or more? <em v-if="beneficiaryInfo.everConvictedTwoOrMoreOffens">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everConvictedTwoOrMoreOffens'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everConvictedTwoOrMoreOffens'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everConvictedTwoOrMoreOffens'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everConvictedTwoOrMoreOffens"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everConvictedTwoOrMoreOffens',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everIlleglTraf'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?<em v-if="beneficiaryInfo.everIlleglTraf">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everIlleglTraf'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everIlleglTraf'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everIlleglTraf'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everIlleglTraf"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everIlleglTraf',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everKnowinglyIlleglTraf'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?<em v-if="beneficiaryInfo.everKnowinglyIlleglTraf">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everKnowinglyIlleglTraf'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everKnowinglyIlleglTraf'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everKnowinglyIlleglTraf'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everKnowinglyIlleglTraf"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everKnowinglyIlleglTraf',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpouseSondaughterIlleglTraf'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?<em v-if="beneficiaryInfo.everSpouseSondaughterIlleglTraf">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpouseSondaughterIlleglTraf'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpouseSondaughterIlleglTraf'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpouseSondaughterIlleglTraf'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpouseSondaughterIlleglTraf"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpouseSondaughterIlleglTraf',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngageProst'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?<em v-if="beneficiaryInfo.everEngageProst">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngageProst'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngageProst'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngageProst'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngageProst"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngageProst',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everdirOrIndirectProst'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?<em v-if="beneficiaryInfo.everdirOrIndirectProst">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everdirOrIndirectProst'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everdirOrIndirectProst'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everdirOrIndirectProst'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everdirOrIndirectProst"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everdirOrIndirectProst',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everReceiveMoneyFronProst'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER received any proceeds or money fromprostitution?<em v-if="beneficiaryInfo.everReceiveMoneyFronProst">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everReceiveMoneyFronProst'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everReceiveMoneyFronProst'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everReceiveMoneyFronProst'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everReceiveMoneyFronProst"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everReceiveMoneyFronProst',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everIntentIllegalGamblUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?<em v-if="beneficiaryInfo.everIntentIllegalGamblUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everIntentIllegalGamblUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everIntentIllegalGamblUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everIntentIllegalGamblUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everIntentIllegalGamblUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everIntentIllegalGamblUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everImmunityCriminalOffensedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?<em v-if="beneficiaryInfo.everImmunityCriminalOffensedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everImmunityCriminalOffensedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everImmunityCriminalOffensedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everImmunityCriminalOffensedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everImmunityCriminalOffensedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everImmunityCriminalOffensedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everViolateReliFreedomAsForeignGovOffi'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?<em v-if="beneficiaryInfo.everViolateReliFreedomAsForeignGovOffi">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everViolateReliFreedomAsForeignGovOffi'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everViolateReliFreedomAsForeignGovOffi'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everViolateReliFreedomAsForeignGovOffi'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everViolateReliFreedomAsForeignGovOffi"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everViolateReliFreedomAsForeignGovOffi',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everForceFraudCommercialSexActs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?<em v-if="beneficiaryInfo.everForceFraudCommercialSexActs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everForceFraudCommercialSexActs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everForceFraudCommercialSexActs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everForceFraudCommercialSexActs'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everForceFraudCommercialSexActs"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everForceFraudCommercialSexActs',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everTraffPersonIntoInvolSlavery'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.<em v-if="beneficiaryInfo.everTraffPersonIntoInvolSlavery">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everTraffPersonIntoInvolSlavery'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everTraffPersonIntoInvolSlavery'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everTraffPersonIntoInvolSlavery'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everTraffPersonIntoInvolSlavery"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everTraffPersonIntoInvolSlavery',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everKnowWithTraffPersonCommSexAct'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?<em v-if="beneficiaryInfo.everKnowWithTraffPersonCommSexAct">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everKnowWithTraffPersonCommSexAct'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everKnowWithTraffPersonCommSexAct'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everKnowWithTraffPersonCommSexAct'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everKnowWithTraffPersonCommSexAct"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everKnowWithTraffPersonCommSexAct',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpouseSonDughterEngTraffAnyFinBef'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?<em v-if="beneficiaryInfo.everSpouseSonDughterEngTraffAnyFinBef">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpouseSonDughterEngTraffAnyFinBef'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpouseSonDughterEngTraffAnyFinBef'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpouseSonDughterEngTraffAnyFinBef'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpouseSonDughterEngTraffAnyFinBef"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpouseSonDughterEngTraffAnyFinBef',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngMoneyLaundering'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?<em v-if="beneficiaryInfo.everEngMoneyLaundering">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngMoneyLaundering'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngMoneyLaundering'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngMoneyLaundering'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngMoneyLaundering"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngMoneyLaundering',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'criminalActsAndViolationsAddiInfo'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Additional Information
                            <em v-if="beneficiaryInfo.criminalActsAndViolationsAddiInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'criminalActsAndViolationsAddiInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'criminalActsAndViolationsAddiInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'criminalActsAndViolationsAddiInfo'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.criminalActsAndViolationsAddiInfo"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'criminalActsAndViolationsAddiInfo',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <h3 class="small-header">Security and Related</h3>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everViolateEvidenceLawRelatedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?<em v-if="beneficiaryInfo.everViolateEvidenceLawRelatedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everViolateEvidenceLawRelatedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everViolateEvidenceLawRelatedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everViolateEvidenceLawRelatedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everViolateEvidenceLawRelatedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everViolateEvidenceLawRelatedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everViolateExpGoodsSensInfoTechInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? <em v-if="beneficiaryInfo.everViolateExpGoodsSensInfoTechInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everViolateExpGoodsSensInfoTechInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everViolateExpGoodsSensInfoTechInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everViolateExpGoodsSensInfoTechInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everViolateExpGoodsSensInfoTechInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everViolateExpGoodsSensInfoTechInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everOverthrowingUSGovtByForceViolence'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?<em v-if="beneficiaryInfo.everOverthrowingUSGovtByForceViolence">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everOverthrowingUSGovtByForceViolence'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everOverthrowingUSGovtByForceViolence'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everOverthrowingUSGovtByForceViolence'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everOverthrowingUSGovtByForceViolence"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everOverthrowingUSGovtByForceViolence',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everActivityDangerScurityOfUs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engage in any activity that could endanger the welfare,safety, or security of the United States? <em v-if="beneficiaryInfo.everActivityDangerScurityOfUs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everActivityDangerScurityOfUs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everActivityDangerScurityOfUs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everActivityDangerScurityOfUs'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everActivityDangerScurityOfUs"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everActivityDangerScurityOfUs',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngUnlawfulActivity'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engage in any other unlawful activity?<em v-if="beneficiaryInfo.everEngUnlawfulActivity">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngUnlawfulActivity'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngUnlawfulActivity'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngUnlawfulActivity'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngUnlawfulActivity"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngUnlawfulActivity',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngActSeriousForeignPolicyforUs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?<em v-if="beneficiaryInfo.everEngActSeriousForeignPolicyforUs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngActSeriousForeignPolicyforUs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngActSeriousForeignPolicyforUs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngActSeriousForeignPolicyforUs'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngActSeriousForeignPolicyforUs"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngActSeriousForeignPolicyforUs',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everCommitedKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? <em v-if="beneficiaryInfo.everCommitedKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everCommitedKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everCommitedKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everCommitedKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everCommitedKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everCommitedKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everCommMemberGrpOrgKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? <em v-if="beneficiaryInfo.everCommMemberGrpOrgKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everCommMemberGrpOrgKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everCommMemberGrpOrgKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everCommMemberGrpOrgKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everCommMemberGrpOrgKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everCommMemberGrpOrgKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAskMoneyRecruGrpKidnapHijackEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?<em v-if="beneficiaryInfo.everAskMoneyRecruGrpKidnapHijackEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAskMoneyRecruGrpKidnapHijackEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAskMoneyRecruGrpKidnapHijackEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAskMoneyRecruGrpKidnapHijackEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAskMoneyRecruGrpKidnapHijackEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAskMoneyRecruGrpKidnapHijackEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everProvideMoneyForAssiKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? <em v-if="beneficiaryInfo.everProvideMoneyForAssiKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everProvideMoneyForAssiKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everProvideMoneyForAssiKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everProvideMoneyForAssiKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everProvideMoneyForAssiKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everProvideMoneyForAssiKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everProvideMoneyForAssiIndiGrpKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?<em v-if="beneficiaryInfo.everProvideMoneyForAssiIndiGrpKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everProvideMoneyForAssiIndiGrpKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everProvideMoneyForAssiIndiGrpKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everProvideMoneyForAssiIndiGrpKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everProvideMoneyForAssiIndiGrpKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everProvideMoneyForAssiIndiGrpKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everTraiParaOrMilataryWepons'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER received any type of military,paramilitary, or weapons training? <em v-if="beneficiaryInfo.everTraiParaOrMilataryWepons">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everTraiParaOrMilataryWepons'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everTraiParaOrMilataryWepons'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everTraiParaOrMilataryWepons'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everTraiParaOrMilataryWepons"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everTraiParaOrMilataryWepons',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you intend to engage in any of the activities<em v-if="beneficiaryInfo.everEngKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'genEligAndInadmisGroundsQ46aTo50AddiInfo'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Additional Information
                            <em v-if="beneficiaryInfo.genEligAndInadmisGroundsQ46aTo50AddiInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ46aTo50AddiInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ46aTo50AddiInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ46aTo50AddiInfo'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.genEligAndInadmisGroundsQ46aTo50AddiInfo"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'genEligAndInadmisGroundsQ46aTo50AddiInfo',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <!-- <h3 class="small-header">Additional info</h3> -->
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpoOrChiEngKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property?<em v-if="beneficiaryInfo.everSpoOrChiEngKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpoOrChiEngKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiEngKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiEngKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpoOrChiEngKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpoOrChiEngKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everHSpoOrChiPartMemberKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? <em v-if="beneficiaryInfo.everHSpoOrChiPartMemberKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everHSpoOrChiPartMemberKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everHSpoOrChiPartMemberKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everHSpoOrChiPartMemberKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everHSpoOrChiPartMemberKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everHSpoOrChiPartMemberKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpoOrChiRecrutKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? <em v-if="beneficiaryInfo.everSpoOrChiRecrutKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpoOrChiRecrutKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiRecrutKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiRecrutKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpoOrChiRecrutKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpoOrChiRecrutKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpoOrChiAskMoneyAssiKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.?  <em v-if="beneficiaryInfo.everSpoOrChiAskMoneyAssiKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpoOrChiAskMoneyAssiKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiAskMoneyAssiKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiAskMoneyAssiKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpoOrChiAskMoneyAssiKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpoOrChiAskMoneyAssiKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpoOrChiForAssiIndiGrpKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.?   <em v-if="beneficiaryInfo.everSpoOrChiForAssiIndiGrpKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpoOrChiForAssiIndiGrpKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiForAssiIndiGrpKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiForAssiIndiGrpKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpoOrChiForAssiIndiGrpKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpoOrChiForAssiIndiGrpKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.?   <em v-if="beneficiaryInfo.everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'genEligAndInadmisGroundsQ51AddiInfo'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Additional Information
                            <em v-if="beneficiaryInfo.genEligAndInadmisGroundsQ46aTo50AddiInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ51AddiInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ51AddiInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ51AddiInfo'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.genEligAndInadmisGroundsQ51AddiInfo"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'genEligAndInadmisGroundsQ51AddiInfo',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <!-- <h3 class="small-header">Additional info</h3> -->
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSellProvideTransWepon'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?<em v-if="beneficiaryInfo.everSellProvideTransWepon">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSellProvideTransWepon'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSellProvideTransWepon'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSellProvideTransWepon'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSellProvideTransWepon"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSellProvideTransWepon',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everWorkedPrisionAndDetained'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?<em v-if="beneficiaryInfo.everWorkedPrisionAndDetained">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everWorkedPrisionAndDetained'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everWorkedPrisionAndDetained'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everWorkedPrisionAndDetained'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everWorkedPrisionAndDetained"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everWorkedPrisionAndDetained',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everUsingWeponPartGrpOrgThreatPerson'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?<em v-if="beneficiaryInfo.everUsingWeponPartGrpOrgThreatPerson">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everUsingWeponPartGrpOrgThreatPerson'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everUsingWeponPartGrpOrgThreatPerson'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everUsingWeponPartGrpOrgThreatPerson'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everUsingWeponPartGrpOrgThreatPerson"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everUsingWeponPartGrpOrgThreatPerson',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everServedParaOrMilataryEtc'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?<em v-if="beneficiaryInfo.everServedParaOrMilataryEtc">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everServedParaOrMilataryEtc'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everServedParaOrMilataryEtc'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everServedParaOrMilataryEtc'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everServedParaOrMilataryEtc"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everServedParaOrMilataryEtc',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everMemberCommPartyInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?<em v-if="beneficiaryInfo.everMemberCommPartyInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everMemberCommPartyInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everMemberCommPartyInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everMemberCommPartyInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everMemberCommPartyInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everMemberCommPartyInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'ever080545To230393AssoNaziGerGov'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?<em v-if="beneficiaryInfo.ever080545To230393AssoNaziGerGov">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'ever080545To230393AssoNaziGerGov'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'ever080545To230393AssoNaziGerGov'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'ever080545To230393AssoNaziGerGov'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.ever080545To230393AssoNaziGerGov"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'ever080545To230393AssoNaziGerGov',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everInvolveTorture'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Acts involving torture or genocide?<em v-if="beneficiaryInfo.everInvolveTorture">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everInvolveTorture'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everInvolveTorture'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everInvolveTorture'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everInvolveTorture"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everInvolveTorture',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everKillAnyPerson'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Killing any person?<em v-if="beneficiaryInfo.everKillAnyPerson">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everKillAnyPerson'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everKillAnyPerson'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everKillAnyPerson'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everKillAnyPerson"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everKillAnyPerson',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSeverInjuAnyPerson'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Intentionally and severely injuring any person?<em v-if="beneficiaryInfo.everSeverInjuAnyPerson">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSeverInjuAnyPerson'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSeverInjuAnyPerson'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSeverInjuAnyPerson'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSeverInjuAnyPerson"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSeverInjuAnyPerson',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEngAnySexualContent'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?<em v-if="beneficiaryInfo.everEngAnySexualContent">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEngAnySexualContent'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEngAnySexualContent'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEngAnySexualContent'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEngAnySexualContent"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEngAnySexualContent',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everLimitReligBnf'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Limiting or denying any person's ability to exercise religious beliefs?<em v-if="beneficiaryInfo.everLimitReligBnf">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everLimitReligBnf'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everLimitReligBnf'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everLimitReligBnf'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everLimitReligBnf"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everLimitReligBnf',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everUsedBelow15yrsPerson'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?<em v-if="beneficiaryInfo.everUsedBelow15yrsPerson">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everUsedBelow15yrsPerson'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everUsedBelow15yrsPerson'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everUsedBelow15yrsPerson'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everUsedBelow15yrsPerson"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everUsedBelow15yrsPerson',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everHelpUnder15yrsPerson'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?<em v-if="beneficiaryInfo.everHelpUnder15yrsPerson">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everHelpUnder15yrsPerson'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everHelpUnder15yrsPerson'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everHelpUnder15yrsPerson'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everHelpUnder15yrsPerson"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everHelpUnder15yrsPerson',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'genEligAndInadmisGroundsQ52To60AddiInfo'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Additional Information
                            <em v-if="beneficiaryInfo.genEligAndInadmisGroundsQ52To60AddiInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ52To60AddiInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ52To60AddiInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'genEligAndInadmisGroundsQ52To60AddiInfo'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.genEligAndInadmisGroundsQ52To60AddiInfo"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'genEligAndInadmisGroundsQ52To60AddiInfo',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <h3 class="small-header">Public Assistance</h3>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everRcvPublicAssiInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?<em v-if="beneficiaryInfo.everRcvPublicAssiInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everRcvPublicAssiInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everRcvPublicAssiInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everRcvPublicAssiInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everRcvPublicAssiInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everRcvPublicAssiInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everFutureRcvPublicAssiInUs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?<em v-if="beneficiaryInfo.everFutureRcvPublicAssiInUs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everFutureRcvPublicAssiInUs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everFutureRcvPublicAssiInUs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everFutureRcvPublicAssiInUs'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everFutureRcvPublicAssiInUs"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everFutureRcvPublicAssiInUs',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAttenRmvProcFiledAfter010497'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?<em v-if="beneficiaryInfo.everAttenRmvProcFiledAfter010497">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAttenRmvProcFiledAfter010497'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAttenRmvProcFiledAfter010497'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAttenRmvProcFiledAfter010497'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAttenRmvProcFiledAfter010497"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAttenRmvProcFiledAfter010497',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everRmvProcFiledReason'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?<em v-if="beneficiaryInfo.everRmvProcFiledReason">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everRmvProcFiledReason'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everRmvProcFiledReason'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everRmvProcFiledReason'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everRmvProcFiledReason"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everRmvProcFiledReason',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'rmvProcFiledResonWriteStmt'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Please mention Receipt Number and other information
                            <em v-if="beneficiaryInfo.rmvProcFiledResonWriteStmt">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'rmvProcFiledResonWriteStmt'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'rmvProcFiledResonWriteStmt'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'rmvProcFiledResonWriteStmt'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.rmvProcFiledResonWriteStmt"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'rmvProcFiledResonWriteStmt',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSubmitFraudDocUSGov'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?<em v-if="beneficiaryInfo.everSubmitFraudDocUSGov">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSubmitFraudDocUSGov'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSubmitFraudDocUSGov'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSubmitFraudDocUSGov'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSubmitFraudDocUSGov"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSubmitFraudDocUSGov',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everLiedMisrepreInfoEnterUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?<em v-if="beneficiaryInfo.everLiedMisrepreInfoEnterUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everLiedMisrepreInfoEnterUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everLiedMisrepreInfoEnterUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everLiedMisrepreInfoEnterUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everLiedMisrepreInfoEnterUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everLiedMisrepreInfoEnterUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everClaimFlaslyUSCitizen'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?<em v-if="beneficiaryInfo.everClaimFlaslyUSCitizen">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everClaimFlaslyUSCitizen'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everClaimFlaslyUSCitizen'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everClaimFlaslyUSCitizen'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everClaimFlaslyUSCitizen"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everClaimFlaslyUSCitizen',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everStowawayOnVessel'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?<em v-if="beneficiaryInfo.everStowawayOnVessel">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everStowawayOnVessel'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everStowawayOnVessel'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everStowawayOnVessel'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everStowawayOnVessel"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everStowawayOnVessel',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everTrytoEnterUsIllegaly'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?<em v-if="beneficiaryInfo.everTrytoEnterUsIllegaly">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everTrytoEnterUsIllegaly'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everTrytoEnterUsIllegaly'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everTrytoEnterUsIllegaly'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everTrytoEnterUsIllegaly"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everTrytoEnterUsIllegaly',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everFinalOrderCivilPenalty'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?<em v-if="beneficiaryInfo.everFinalOrderCivilPenalty">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everFinalOrderCivilPenalty'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everFinalOrderCivilPenalty'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everFinalOrderCivilPenalty'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everFinalOrderCivilPenalty"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everFinalOrderCivilPenalty',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everRemovedfromUs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?<em v-if="beneficiaryInfo.everRemovedfromUs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everRemovedfromUs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everRemovedfromUs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everRemovedfromUs'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everRemovedfromUs"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everRemovedfromUs',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everEnterUSWithoutInspAdmit'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER entered the United States without being inspected and admitted or paroled?<em v-if="beneficiaryInfo.everEnterUSWithoutInspAdmit">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everEnterUSWithoutInspAdmit'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everEnterUSWithoutInspAdmit'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everEnterUSWithoutInspAdmit'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everEnterUSWithoutInspAdmit"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everEnterUSWithoutInspAdmit',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSince010497More180DLessYrULFStayUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">For more than 180 days but less than a year, and thendeparted the United States?<em v-if="beneficiaryInfo.everSince010497More180DLessYrULFStayUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSince010497More180DLessYrULFStayUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497More180DLessYrULFStayUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497More180DLessYrULFStayUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSince010497More180DLessYrULFStayUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSince010497More180DLessYrULFStayUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSince010497YrOrMoreULFDepartUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">For one year or more and then departed the United States?<em v-if="beneficiaryInfo.everSince010497YrOrMoreULFDepartUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSince010497YrOrMoreULFDepartUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497YrOrMoreULFDepartUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497YrOrMoreULFDepartUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSince010497YrOrMoreULFDepartUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSince010497YrOrMoreULFDepartUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSince010497ReEntMoreYrULFStayUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Having been unlawfully present in the United States for more than one year in the aggregate?<em v-if="beneficiaryInfo.everSince010497ReEntMoreYrULFStayUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSince010497ReEntMoreYrULFStayUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497ReEntMoreYrULFStayUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497ReEntMoreYrULFStayUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSince010497ReEntMoreYrULFStayUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSince010497ReEntMoreYrULFStayUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everSince010497RmvFromUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Having been deported, excluded, or removed from the United States?<em v-if="beneficiaryInfo.everSince010497RmvFromUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everSince010497RmvFromUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497RmvFromUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everSince010497RmvFromUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everSince010497RmvFromUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everSince010497RmvFromUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <h3 class="small-header">Miscellaneous Conduct</h3>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'planForPractPolyInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you plan to practice polygamy in the United States?<em v-if="beneficiaryInfo.planForPractPolyInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'planForPractPolyInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'planForPractPolyInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'planForPractPolyInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.planForPractPolyInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'planForPractPolyInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'AreYouAccomOtherCountry'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?<em v-if="beneficiaryInfo.planForPractPolyInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'AreYouAccomOtherCountry'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'AreYouAccomOtherCountry'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'AreYouAccomOtherCountry'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.AreYouAccomOtherCountry"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'AreYouAccomOtherCountry',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAnyUsChildUnderCustody'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?<em v-if="beneficiaryInfo.everAnyUsChildUnderCustody">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAnyUsChildUnderCustody'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAnyUsChildUnderCustody'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAnyUsChildUnderCustody'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAnyUsChildUnderCustody"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAnyUsChildUnderCustody',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everVoilationAnyFedaral'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?<em v-if="beneficiaryInfo.everVoilationAnyFedaral">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everVoilationAnyFedaral'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everVoilationAnyFedaral'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everVoilationAnyFedaral'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everVoilationAnyFedaral"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everVoilationAnyFedaral',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everUsCtzshipAvoidTax'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?<em v-if="beneficiaryInfo.everUsCtzshipAvoidTax">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everUsCtzshipAvoidTax'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everUsCtzshipAvoidTax'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everUsCtzshipAvoidTax'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everUsCtzshipAvoidTax"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everUsCtzshipAvoidTax',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everAppliedForExemptServiceUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?<em v-if="beneficiaryInfo.everAppliedForExemptServiceUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAppliedForExemptServiceUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedForExemptServiceUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedForExemptServiceUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everAppliedForExemptServiceUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everAppliedForExemptServiceUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everReliServTrainAreYouForeignNation'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Been relieved or discharged from such training or serviceon the ground that you are a foreign national?<em v-if="beneficiaryInfo.everReliServTrainAreYouForeignNation">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everReliServTrainAreYouForeignNation'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everReliServTrainAreYouForeignNation'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everReliServTrainAreYouForeignNation'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everReliServTrainAreYouForeignNation"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everReliServTrainAreYouForeignNation',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everConvictDestUSArmedForce'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Been convicted of desertion from the U.S. armed forces?<em v-if="beneficiaryInfo.everConvictDestUSArmedForce">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everConvictDestUSArmedForce'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everConvictDestUSArmedForce'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everConvictDestUSArmedForce'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everConvictDestUSArmedForce"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everConvictDestUSArmedForce',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'everRemOutsideUSAviodTrainArmedForce'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?<em v-if="beneficiaryInfo.everRemOutsideUSAviodTrainArmedForce">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everRemOutsideUSAviodTrainArmedForce'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everRemOutsideUSAviodTrainArmedForce'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everRemOutsideUSAviodTrainArmedForce'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.everRemOutsideUSAviodTrainArmedForce"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'everRemOutsideUSAviodTrainArmedForce',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'nationImgrstaIfAviodTrainArmForcUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">What was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)
                            <em v-if="beneficiaryInfo.nationImgrstaIfAviodTrainArmForcUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'nationImgrstaIfAviodTrainArmForcUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'nationImgrstaIfAviodTrainArmForcUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'nationImgrstaIfAviodTrainArmForcUS'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.nationImgrstaIfAviodTrainArmForcUS"
                                @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'nationImgrstaIfAviodTrainArmForcUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      
                    </template>









                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--Educations-->
            <div v-if="currentTab=='Educational Info'">
              <form>
               
                <div class="vx-col w-full mb-5 mt-5" style="padding-left:50px;" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasMasterDegreeInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you have Masters degree in United States?<em v-if="beneficiaryInfo.hasMasterDegreeInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.hasMasterDegreeInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'hasMasterDegreeInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    After your 12th grade – Starting from the most recent degree first
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <h3 class="small-header">Education Information 
                      
                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'educations'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.educations"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'educations',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="form-container questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="vx-row delete-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'name'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >University/College/School Name<em v-if="beneficiaryInfo.educations.name">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'name'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.name"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'name',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                                      </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'highestDegree'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.educations.highestDegree">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.highestDegree"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'highestDegree',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <selectField
                                      wrapclass=""
                                      placeholder="Highest Degree"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'majorFieldOfStudy'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Major Field of Study<em v-if="beneficiaryInfo.educations.majorFieldOfStudy">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                              <vs-checkbox
                             
                              v-model="
                                          beneficiaryInfo.educations.majorFieldOfStudy
                                        "
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'majorFieldOfStudy',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'graduatedYear'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Year of Graduation<em v-if="beneficiaryInfo.educations.graduatedYear">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.graduatedYear"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'graduatedYear',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <selectField
                                      wrapclass=""
                                      placeholder="Highest Degree"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedFrom'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Course Started On<em v-if="beneficiaryInfo.educations.attendedFrom">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.attendedFrom"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'attendedFrom',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedTo'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Course Completed On<em v-if="beneficiaryInfo.educations.attendedTo">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.attendedTo"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'attendedTo',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'graduatedDate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Date of Graduation<em v-if="beneficiaryInfo.educations.graduatedDate">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'graduatedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.graduatedDate"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'graduatedDate',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'address'})">
                                  <h3 class="small-header">
                                    University/College/School Address<em v-if="beneficiaryInfo.educations.address">*</em>
                                    <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.address"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo.educations',
                                          key: 'address',
                                        })
                                      "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    
                                  </h3>

                                  <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Street Address</label>
                                        </div>
                                        <vs-input
                                          class="w-full"
                                          v-validate="'required'"
                                          data-vv-as="Street Address"
                                        />
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Apt, Suite</label>
                                        </div>
                                        <div class="address-suite">
                                          <ul
                                            class="demo-alignment custom-radio"
                                            vs-type="flex"
                                            vs-align="center"
                                          >
                                            <li>
                                              <vs-checkbox name="aptType1"
                                                >Apt</vs-checkbox
                                              >
                                            </li>
                                            <li>
                                              <vs-checkbox name="aptType2"
                                                >Ste</vs-checkbox
                                              >
                                            </li>
                                            <li>
                                              <vs-checkbox name="aptType3"
                                                >Flr</vs-checkbox
                                              >
                                            </li>
                                          </ul>
                                          <vs-input class="" data-vv-as="Apt, Suite" />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Country</label>
                                          </div>
                                          <multiselect
                                            name="Status"
                                            :multiple="false"
                                            :options="[]"
                                            :hideSelected="true"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Select Country"
                                            :preselect-first="false"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"> State</label>
                                          </div>
                                          <multiselect
                                            name="Status"
                                            :multiple="false"
                                            :options="[]"
                                            :hideSelected="true"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Select State"
                                            :preselect-first="false"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"> City</label>
                                          </div>

                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select City"
                                              :preselect-first="false"
                                            />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label for class="form_label">Zip Code</label>
                                        </div>
                                        <vs-input class="w-full" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isAccredited'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Accredited at the time of your
                                        graduation?<em v-if="beneficiaryInfo.educations.isAccredited">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.isAccredited"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'isAccredited',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isForProfit'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Profit University?<em v-if="beneficiaryInfo.educations.isForProfit">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.isForProfit"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'isForProfit',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                               <!-- <div class="delete">
                                  <a>
                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                  </a>
                                </div> -->
                              </div>
                            </div>
                          </div>
                          <div
                            class="m-auto"
                            vs-type="flex"
                            vs-align="center"
                            vs-lg="2"
                            vs-sm="2"
                          >
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--employment-->
            <div v-if="currentTab=='Employement Info'">
              
              <form
                data-vv-scope="employmentform"
                @submit.prevent=""
                @keydown.enter.prevent=""
              >
             
              <div class="vx-col w-full mb-5 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed?<em v-if="beneficiaryInfo.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Please write the following information about your current and past employment for the past five years in the U.S and abroad starting with your most current Job.
                  </vs-alert>
                </vs-col>
                
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          beneficiaryInfo.prevEmploymentInfo.prevEmploymentInfo
                        "
                        @change="
                          selectCheck({
                            section: 'beneficiaryInfo.prevEmploymentInfo',
                            key: 'prevEmploymentInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Employer Name<em v-if="beneficiaryInfo.prevEmploymentInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      beneficiaryInfo.prevEmploymentInfo.employerName
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'employerName',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3"> Current Employer? </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model=" 
                                    beneficiaryInfo.prevEmploymentInfo.currentEmployer
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.prevEmploymentInfo',
                                      key: 'currentEmployer',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                            </div>
                            
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Job Title<em v-if="beneficiaryInfo.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.jobTitle"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'jobTitle',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Employer Business E.g., IT<em v-if="beneficiaryInfo.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      beneficiaryInfo.prevEmploymentInfo.businessType
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'businessType',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Salary<em v-if="beneficiaryInfo.prevEmploymentInfo.salary">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.salary"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Pay Frequency<em v-if="beneficiaryInfo.prevEmploymentInfo.payFrequency">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.payFrequency"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobDuties'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed<em v-if="beneficiaryInfo.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip H1-140">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.jobDuties"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'jobDuties',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="beneficiaryInfo.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="beneficiaryInfo.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'address'})">
                              <h3 class="small-header">
                                Work Address<em v-if="beneficiaryInfo.prevEmploymentInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.address"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.prevEmploymentInfo',

                                      key: 'address',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverEmployed'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed  Outside US?<em v-if="beneficiaryInfo.haveYouEverEmployed">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.haveYouEverEmployed"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'haveYouEverEmployed',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0 mt-6">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Last Employer outside of the United States for more than one year.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment Outside US
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <vs-checkbox
                          
                            v-model="
                          beneficiaryInfo.prevEmploymentOutsideUS.prevEmploymentOutsideUS
                        "
                        @change="
                          selectCheck({
                            section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                            key: 'prevEmploymentOutsideUS',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

<div class="vx-col w-full">
  <div class="form-container alt-rows-bg questionnaire_hb">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'employerName'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Employer Name<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.employerName">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})">
                  <vs-checkbox
                
                  v-model="
                beneficiaryInfo.prevEmploymentOutsideUS.employerName
              "
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'employerName',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentEmployer'})">
        <div class="d-flex align-center">
          <a class="switch-label mr-3"> Current Employer? </a>
          <vs-switch>
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <vs-checkbox
                
                  v-model=" 
              beneficiaryInfo.prevEmploymentOutsideUS.currentEmployer
            "
            @change="
              selectCheck({
                section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                key: 'currentEmployer',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </div>
      </div>
      
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'jobTitle'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Job Title<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.jobTitle">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobTitle"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'jobTitle',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'businessType'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label"
              >Employer Business E.g., IT<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.businessType">*</em></label
            >
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})">
                  <vs-checkbox
                
                  v-model="
                beneficiaryInfo.prevEmploymentOutsideUS.businessType
              "
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'businessType',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Salary<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.salary">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentOutsideUS.salary"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Pay Frequency<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.payFrequency">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentOutsideUS.payFrequency"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'jobDuties'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label class="form_label"
              >Description of Duties Performed<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties">*</em>
              <div class="IB_tooltip H1-140">
                <span
                  ><info-icon
                    size="1.5x"
                    class="custom-class"
                  ></info-icon
                ></span>
                <div class="tooltip_cnt">
                  <p>
                    Please fill in your Job Duties only.Avoid
                    inserting all project details.
                  </p>
                </div>
              </div>
            </label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'jobDuties',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-textarea w-full vs-textarea-primary">
            <textarea class="vs-textarea"></textarea>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'startDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">Start Date<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.startDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.startDate"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'startDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'endDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">End Date<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.endDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.endDate"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'endDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <!--   

       -->
      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'address'})">
        <h3 class="small-header">
          Work Address<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.address">*</em>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.address"
            @change="
              selectCheck({
                section: 'beneficiaryInfo.prevEmploymentOutsideUS',

                key: 'address',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </h3>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Street Address</label>
              </div>
              <vs-input
                class="w-full"
                v-validate="'required'"
                data-vv-as="Street Address"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Apt, Suite</label>
              </div>
              <div class="address-suite">
                <ul
                  class="demo-alignment custom-radio"
                  vs-type="flex"
                  vs-align="center"
                >
                  <li>
                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                  </li>
                </ul>
                <vs-input class="" data-vv-as="Apt, Suite" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label">Country</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Country"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> State</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select State"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> City</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select City"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label for class="form_label">Zip Code</label>
              </div>
              <vs-input class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
                  </div>
                </vs-col>
              </form>
            </div>
            
            <!--Parents Info-->
            <div v-if="currentTab=='Parents Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your father details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Father Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'fatherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'fatherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'fatherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          fatherInfo.fatherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'fatherInfo',
                            key: 'fatherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="fatherInfo.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="fatherInfo.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="fatherInfo.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'fatherInfo',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.otherNames"
                            @change="
                              selectCheck({
                                section: 'fatherInfo',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                            </div>
                            <div class="vx-col w-full">
                                <div class="form_group w-full">
                                  <label class="form_label"
                                    ><h3 class="small-header">Name at Birth</h3>
                                  </label>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="fatherInfo.nameAtBirth.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo.nameAtBirth',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="fatherInfo.nameAtBirth.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo.nameAtBirth',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="fatherInfo.nameAtBirth.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'fatherInfo.nameAtBirth',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'dateOfBirth'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date of Birth<em v-if="fatherInfo.dateOfBirth">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'dateOfBirth'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'dateOfBirth'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'dateOfBirth'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'dateOfBirth',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'provinceOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'locationOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.locationOfBirth"
                              @change="
                                selectCheck({ section: 'fatherInfo', key: 'locationOfBirth' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'deceasedCity'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Deceased City<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'deceasedCity'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'deceasedCity'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'deceasedCity'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.deceasedCity"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'deceasedCity',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'deceasedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Deceased Date<em v-if="fatherInfo.deceasedDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'deceasedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'deceasedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'deceasedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.deceasedDate"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'deceasedDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'isUSCitizen'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Is your father now or was he ever a U.S. citizen?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'isUSCitizen'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'isUSCitizen'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'isUSCitizen'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.isUSCitizen"
                              @change="
                              selectCheck({
                                section: 'fatherInfo',
                                key: 'isUSCitizen',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'dateFromUSCitizen'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> Dates from US citizen<em v-if="fatherInfo.dateFromUSCitizen">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'dateFromUSCitizen'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'dateFromUSCitizen'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'dateFromUSCitizen'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.dateFromUSCitizen"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'dateFromUSCitizen',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Residence  <em v-if="currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'fatherInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'fatherInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                 <vs-col class="w-full p-0 mt-5">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your mother details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Mother Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'motherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'motherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'motherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          motherInfo.motherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'motherInfo',
                            key: 'motherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="motherInfo.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="motherInfo.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="motherInfo.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'motherInfo',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.otherNames"
                            @change="
                              selectCheck({
                                section: 'motherInfo',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                            </div>
                            <div class="vx-col w-full">
                                <div class="form_group w-full">
                                  <label class="form_label"
                                    ><h3 class="small-header">Name at Birth</h3>
                                  </label>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="motherInfo.nameAtBirth.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo.nameAtBirth',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="motherInfo.nameAtBirth.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo.nameAtBirth',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="motherInfo.nameAtBirth.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'motherInfo.nameAtBirth',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'dateOfBirth'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date of Birth<em v-if="motherInfo.dateOfBirth">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'dateOfBirth'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'dateOfBirth'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'dateOfBirth'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'dateOfBirth',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'provinceOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'locationOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.locationOfBirth"
                              @change="
                                selectCheck({ section: 'motherInfo', key: 'locationOfBirth' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'deceasedCity'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Deceased City<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'deceasedCity'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'deceasedCity'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'deceasedCity'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.deceasedCity"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'deceasedCity',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'deceasedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Deceased Date<em v-if="motherInfo.deceasedDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'deceasedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'deceasedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'deceasedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.deceasedDate"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'deceasedDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'isUSCitizen'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Is your mother now or was she ever a U.S. citizen?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'isUSCitizen'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'isUSCitizen'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'isUSCitizen'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.isUSCitizen"
                              @change="
                              selectCheck({
                                section: 'motherInfo',
                                key: 'isUSCitizen',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'dateFromUSCitizen'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> Dates from US citizen<em v-if="motherInfo.dateFromUSCitizen">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'dateFromUSCitizen'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'dateFromUSCitizen'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'dateFromUSCitizen'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.dateFromUSCitizen"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'dateFromUSCitizen',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'motherInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="address">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'motherInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'motherInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                          </div>
                        </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col> 
              </form>
              
            </div>
            <!-- documents-->
            <div v-if="currentTab=='Documents Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          List of documents needs to be updated
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                          </span>
                        </h3>
                        <div class="documents_group case_documents" >
                          <template v-for="(tempItem, inde) in fields">
                            <template v-if="checkProperty(tempItem, 'section') == 'documents'">
                              <QuestTempDocumentComp :id="inde+tempItem['key']" :key="inde+tempItem['key']" :tooltip="fields[inde]&&fields[inde]['tooltip']?fields[inde]['tooltip']:''"  v-model="fields[inde]" :dbFields="dbFields" :tagsMasterList="eFileTagsList" :isEdit="isEdit" @updateFields="updateFields" />
                            </template>
                          </template>
                        </div>
                        <div class="documents_group case_documents" v-if="false">
                          
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'resume'}) && false ">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Resume<em v-if="documents.resume">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'resume'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'resume'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'resume'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.resume"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'resume',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgOfferLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Unsigned Offer Letter<em v-if="documents.slgOfferLetter">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgOfferLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgOfferLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgOfferLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.slgOfferLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'slgOfferLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgSignedOfferLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Signed Offer Letter<em v-if="documents.slgSignedOfferLetter">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgSignedOfferLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgSignedOfferLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgSignedOfferLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.slgSignedOfferLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'slgSignedOfferLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'marriageCertificate'}) && false">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Copy of the marriage certificate, with certified translation if required<em v-if="documents.marriageCertificate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'marriageCertificate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'marriageCertificate'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'marriageCertificate'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.marriageCertificate"
                                    @change="
                                      selectCheck({
                                        section: 'documents',
                                        key: 'marriageCertificate',
                                      })
                                    "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'bnfSpouseLatestI797'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)<em v-if="documents.bnfSpouseLatestI797">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'bnfSpouseLatestI797'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'bnfSpouseLatestI797'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'bnfSpouseLatestI797'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.bnfSpouseLatestI797"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'bnfSpouseLatestI797',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'bnfSpousePassport'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Spouse’s Passport- First page with photo, Visa page and last page with address<em v-if="documents.bnfSpousePassport">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'bnfSpousePassport'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'bnfSpousePassport'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'bnfSpousePassport'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.bnfSpousePassport"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'bnfSpousePassport',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'bnfSpouseRecentPayStubs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Three recent pay stubs (if spouse is on H-1B or L-1 status)<em v-if="documents.bnfSpouseRecentPayStubs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'bnfSpouseRecentPayStubs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'bnfSpouseRecentPayStubs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'bnfSpouseRecentPayStubs'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.bnfSpouseRecentPayStubs"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'bnfSpouseRecentPayStubs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'bnfSpouseFormAllI20'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Spouse’s all Form I-20s (if spouse is on F-1 status)<em v-if="documents.bnfSpouseFormAllI20">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'bnfSpouseFormAllI20'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'bnfSpouseFormAllI20'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'bnfSpouseFormAllI20'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.bnfSpouseFormAllI20"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'bnfSpouseFormAllI20',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'underlyingLaborApplications'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of the underlying Labor Certification (PERM) if applicable.<em v-if="documents.underlyingLaborApplications">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'underlyingLaborApplications'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'underlyingLaborApplications'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'underlyingLaborApplications'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.underlyingLaborApplications"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'underlyingLaborApplications',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'mostRecentTaxTranscrips'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >A copy of Most Recent Year’s Tax Transcripts – can be obtained from<em v-if="documents.mostRecentTaxTranscrips">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'mostRecentTaxTranscrips'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'mostRecentTaxTranscrips'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'mostRecentTaxTranscrips'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.mostRecentTaxTranscrips"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'mostRecentTaxTranscrips',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'education'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Master’s/ Bachelor’s degree certificate, transcripts,
                                  12th and 10th certificates<em v-if="documents.education">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'education'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'education'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'education'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.education"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'education',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'expLetters'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Experience Letters<em v-if="documents.expLetters">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'expLetters'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'expLetters'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'expLetters'})">
                <vs-checkbox
              
                v-model="documents.expLetters"
          @change="
            selectCheck({
              section: 'documents',
              key: 'expLetters',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'INSNotices'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >I-797, Notice of Approval granting the current nonimmigrant status (if applicable)<em v-if="documents.INSNotices">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'INSNotices'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'INSNotices'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'INSNotices'})">
                <vs-checkbox
              
                v-model="documents.INSNotices"
          @change="
            selectCheck({
              section: 'documents',
              key: 'INSNotices',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'passport'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Passport- First page with photo and last page with address<em v-if="documents.passport">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'passport'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'passport'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'passport'})">
                <vs-checkbox
              
                v-model="documents.passport"
          @change="
            selectCheck({
              section: 'documents',
              key: 'passport',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'passportVisaI94'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Passport- First page with photo, Visa page and last
                                  page with address<em v-if="documents.passportVisaI94">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'passportVisaI94'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'passportVisaI94'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'passportVisaI94'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.passportVisaI94"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'passportVisaI94',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'formI20'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >All Form I-20s if applicable<em v-if="documents.formI20">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'formI20'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'formI20'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'formI20'})">
                <vs-checkbox
              
                v-model="documents.formI20"
          @change="
            selectCheck({
              section: 'documents',
              key: 'formI20',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'socialSecurityCardAndProfLicense'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security Card<em v-if="documents.socialSecurityCardAndProfLicense">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'socialSecurityCardAndProfLicense'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'socialSecurityCardAndProfLicense'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'socialSecurityCardAndProfLicense'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.socialSecurityCardAndProfLicense"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'socialSecurityCardAndProfLicense',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>                     
                           <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'other'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Other Documents, if any<em v-if="documents.other">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'other'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'other'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'other'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.other"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'other' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'payStubs'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Three recent pay stubs<em v-if="documents.payStubs">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'payStubs'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'payStubs'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'payStubs'})">
                <vs-checkbox
              
                v-model="documents.payStubs"
          @change="
            selectCheck({
              section: 'documents',
              key: 'payStubs',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                         </div>           
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'offerLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Employment Offer Letter<em v-if="documents.offerLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'offerLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'offerLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'offerLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.offerLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'offerLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'clientLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Client Letter<em v-if="documents.clientLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'clientLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'clientLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'clientLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.clientLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'clientLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'vendorLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Vendor Letter if applicable<em v-if="documents.vendorLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'vendorLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'vendorLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'vendorLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.vendorLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'vendorLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'msa'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >MSA/Service Agreement and PO/SOW<em v-if="documents.msa">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'msa'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'msa'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'msa'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.msa"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'msa' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'po'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >PO<em v-if="documents.po">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'po'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'po'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'po'})">
                <vs-checkbox
              
                v-model="documents.po"
          @change="
            selectCheck({
              section: 'documents',
              key: 'po',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'beneficiaryDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Beneficiary Documents<em v-if="documents.beneficiaryDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'beneficiaryDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'beneficiaryDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'beneficiaryDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.beneficiaryDocs"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'beneficiaryDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'h1bRegSelectionNotice'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >H-1B Registration Selection Notice<em v-if="documents.h1bRegSelectionNotice">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'h1bRegSelectionNotice'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'h1bRegSelectionNotice'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'h1bRegSelectionNotice'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.h1bRegSelectionNotice"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'h1bRegSelectionNotice',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'employmentAgreement'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Employment Agreement<em v-if="documents.employmentAgreement">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'employmentAgreement'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'employmentAgreement'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'employmentAgreement'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.employmentAgreement"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'employmentAgreement',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'primeVendor'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Prime Vendor Letter if applicable<em v-if="documents.primeVendor">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'primeVendor'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'primeVendor'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'primeVendor'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.primeVendor"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'primeVendor',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'formI94'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Copy of I-94<em v-if="documents.formI94">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'formI94'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'formI94'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'formI94'})">
                <vs-checkbox
              
                v-model="documents.formI94"
          @change="
            selectCheck({
              section: 'documents',
              key: 'formI94',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'priorFormI797'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Copy of I-797, Notice of Approvals for granting of legal status in the US<em v-if="documents.priorFormI797">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'priorFormI797'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'priorFormI797'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'priorFormI797'})">
                <vs-checkbox
              
                v-model="documents.priorFormI797"
          @change="
            selectCheck({
              section: 'documents',
              key: 'priorFormI797',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'I797NoticeofApprovalforI140'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >I-797, Notice of Approval for I-140 if available<em v-if="documents.I797NoticeofApprovalforI140">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'I797NoticeofApprovalforI140'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'I797NoticeofApprovalforI140'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'I797NoticeofApprovalforI140'})">
                <vs-checkbox
              
                v-model="documents.I797NoticeofApprovalforI140"
          @change="
            selectCheck({
              section: 'documents',
              key: 'I797NoticeofApprovalforI140',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'ead'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >EADs (if on OPT or STEM OPT Extension)<em v-if="documents.ead">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'ead'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'ead'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'ead'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.ead"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'ead' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'w2'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Copy of W-2 Forms issued for all tax years till present<em v-if="documents.w2">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'w2'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'w2'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'w2'})">
                <vs-checkbox
              
                v-model="documents.w2"
          @change="
            selectCheck({
              section: 'documents',
              key: 'w2',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'photographs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Photographs<em v-if="documents.photographs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'photographs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'photographs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'photographs'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.photographs"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'photographs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'birthCertificate'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Birth Certificate<em v-if="documents.birthCertificate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'birthCertificate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'birthCertificate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'birthCertificate'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.birthCertificate"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'birthCertificate',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>    
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'offerLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Employment Offer Letter<em v-if="documents.offerLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'offerLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'offerLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'offerLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.offerLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'offerLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'clientLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Client Letter<em v-if="documents.clientLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'clientLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'clientLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'clientLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.clientLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'clientLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'vendorLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Vendor Letter<em v-if="documents.vendorLetter">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'vendorLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'vendorLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'vendorLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.vendorLetter"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'vendorLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'msa'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >MSA/Service Agreement and PO/SOW<em v-if="documents.msa">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'msa'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'msa'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'msa'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.msa"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'msa' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>                      -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'beneficiaryDocs'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Beneficiary Documents<em v-if="documents.beneficiaryDocs">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'beneficiaryDocs'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'beneficiaryDocs'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'beneficiaryDocs'})">
                <vs-checkbox
              
                v-model="documents.beneficiaryDocs"
          @change="
            selectCheck({
              section: 'documents',
              key: 'beneficiaryDocs',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'h1bRegSelectionNotice'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >H-1B Registration Selection Notice<em v-if="documents.h1bRegSelectionNotice">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'h1bRegSelectionNotice'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'h1bRegSelectionNotice'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'h1bRegSelectionNotice'})">
                <vs-checkbox
              
                v-model="documents.h1bRegSelectionNotice"
          @change="
            selectCheck({
              section: 'documents',
              key: 'h1bRegSelectionNotice',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'employmentAgreement'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Employment Agreement Letter<em v-if="documents.employmentAgreement">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'employmentAgreement'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'employmentAgreement'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'employmentAgreement'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.employmentAgreement"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'employmentAgreement',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'primeVendor'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Prime Vendor Letter<em v-if="documents.primeVendor">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'primeVendor'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'primeVendor'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'primeVendor'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.primeVendor"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'primeVendor',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'formI94'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Form I-94<em v-if="documents.formI94">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'formI94'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'formI94'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'formI94'})">
                <vs-checkbox
              
                v-model="documents.formI94"
          @change="
            selectCheck({
              section: 'documents',
              key: 'formI94',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'priorFormI797'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Copy of I-797, Notice of Approvals for granting of legal status in the US<em v-if="documents.priorFormI797">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'priorFormI797'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'priorFormI797'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'priorFormI797'})">
                <vs-checkbox
              
                v-model="documents.priorFormI797"
          @change="
            selectCheck({
              section: 'documents',
              key: 'priorFormI797',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'I797NoticeofApprovalforI140'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >I-797, Notice of Approval for I-140 if available<em v-if="documents.I797NoticeofApprovalforI140">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'I797NoticeofApprovalforI140'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'I797NoticeofApprovalforI140'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'I797NoticeofApprovalforI140'})">
                <vs-checkbox
              
                v-model="documents.I797NoticeofApprovalforI140"
          @change="
            selectCheck({
              section: 'documents',
              key: 'I797NoticeofApprovalforI140',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'ead'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >EADs (if on OPT or STEM OPT Extension)<em v-if="documents.ead">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'ead'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'ead'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'ead'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.ead"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'ead' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div> -->
                          <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'w2'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          ><Copy of W-2 Forms issued for all tax years till presentem v-if="documents.w2">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'w2'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'w2'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'w2'})">
                <vs-checkbox
              
                v-model="documents.w2"
          @change="
            selectCheck({
              section: 'documents',
              key: 'w2',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <!-- <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'birthCertificate'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Birth Certificate<em v-if="documents.birthCertificate">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'birthCertificate'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'birthCertificate'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'birthCertificate'})">
                <vs-checkbox
              
                v-model="documents.birthCertificate"
          @change="
            selectCheck({
              section: 'documents',
              key: 'birthCertificate',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> -->
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'sponsorInfo.documents',key: 'photographs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Two (2) photographs of the Petitioner – Only if filing I-130 for spouse<em v-if="sponsorInfo.documents.photographs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.documents',key:'photographs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.documents',key:'photographs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.documents',key:'photographs'})">
                                        <vs-checkbox
                                     
                                        v-model="sponsorInfo.documents.photographs"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.documents',
                                      key: 'photographs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                               
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'medicalExamins'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Medical Examins<em v-if="documents.medicalExamins">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'medicalExamins'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'medicalExamins'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'medicalExamins'})">
                <vs-checkbox
              
                v-model="documents.medicalExamins"
          @change="
            selectCheck({
              section: 'documents',
              key: 'medicalExamins',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'dependentForI134'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Dependent For I-134<em v-if="documents.dependentForI134">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'dependentForI134'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'dependentForI134'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'dependentForI134'})">
                <vs-checkbox
              
                v-model="documents.dependentForI134"
          @change="
            selectCheck({
              section: 'documents',
              key: 'dependentForI134',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'dependentTaxReturns'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Dependent Tax Returns<em v-if="documents.dependentTaxReturns">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'dependentTaxReturns'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'dependentTaxReturns'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'dependentTaxReturns'})">
                <vs-checkbox
              
                v-model="documents.dependentTaxReturns"
          @change="
            selectCheck({
              section: 'documents',
              key: 'dependentTaxReturns',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'bankStatements'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Bank Statements<em v-if="documents.bankStatements">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'bankStatements'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'bankStatements'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'bankStatements'})">
                <vs-checkbox
              
                v-model="documents.bankStatements"
          @change="
            selectCheck({
              section: 'documents',
              key: 'bankStatements',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'evidenceOfContinuVisaStatus'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Evidence of Continue Visa Status<em v-if="documents.evidenceOfContinuVisaStatus">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'evidenceOfContinuVisaStatus'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'evidenceOfContinuVisaStatus'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'evidenceOfContinuVisaStatus'})">
                <vs-checkbox
              
                v-model="documents.evidenceOfContinuVisaStatus"
          @change="
            selectCheck({
              section: 'documents',
              key: 'evidenceOfContinuVisaStatus',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'evidenceOfFilePetitionBefore30Apr2001'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Evidence of File Petition Before 30-Apr-2001<em v-if="documents.evidenceOfFilePetitionBefore30Apr2001">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'evidenceOfFilePetitionBefore30Apr2001'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'evidenceOfFilePetitionBefore30Apr2001'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'evidenceOfFilePetitionBefore30Apr2001'})">
                <vs-checkbox
              
                v-model="documents.evidenceOfFilePetitionBefore30Apr2001"
          @change="
            selectCheck({
              section: 'documents',
              key: 'evidenceOfFilePetitionBefore30Apr2001',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'proofOfIncomeOrAsset'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Proof of Income or Asset<em v-if="documents.proofOfIncomeOrAsset">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'proofOfIncomeOrAsset'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'proofOfIncomeOrAsset'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'proofOfIncomeOrAsset'})">
                <vs-checkbox
              
                v-model="documents.proofOfIncomeOrAsset"
          @change="
            selectCheck({
              section: 'documents',
              key: 'proofOfIncomeOrAsset',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'proofOfMedicalInsurence'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Proof of Medical Insurence<em v-if="documents.proofOfMedicalInsurence">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'proofOfMedicalInsurence'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'proofOfMedicalInsurence'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'proofOfMedicalInsurence'})">
                <vs-checkbox
              
                v-model="documents.proofOfMedicalInsurence"
          @change="
            selectCheck({
              section: 'documents',
              key: 'proofOfMedicalInsurence',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'recentCreditReport'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Recent Credit Report<em v-if="documents.recentCreditReport">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'recentCreditReport'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'recentCreditReport'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'recentCreditReport'})">
                <vs-checkbox
              
                v-model="documents.recentCreditReport"
          @change="
            selectCheck({
              section: 'documents',
              key: 'recentCreditReport',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'permResidence'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Permanent Residence<em v-if="documents.permResidence">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'permResidence'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'permResidence'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'permResidence'})">
                <vs-checkbox
              
                v-model="documents.permResidence"
          @change="
            selectCheck({
              section: 'documents',
              key: 'permResidence',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'empAuth'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Employment Auth<em v-if="documents.empAuth">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'empAuth'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'empAuth'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'empAuth'})">
                <vs-checkbox
              
                v-model="documents.empAuth"
          @change="
            selectCheck({
              section: 'documents',
              key: 'empAuth',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgResume'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >  Current Resume- Please mention the accurate names of the employer and periods of employment. Do not state the client names<em v-if="documents.slgResume">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgResume'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgResume'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgResume'})">
                <vs-checkbox
              
                v-model="documents.slgResume"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgResume',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgCollegeDegreesCert'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > All College Degrees<em v-if="documents.slgCollegeDegreesCert">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgCollegeDegreesCert'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgCollegeDegreesCert'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgCollegeDegreesCert'})">
                <vs-checkbox
              
                v-model="documents.slgCollegeDegreesCert"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgCollegeDegreesCert',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgTransScripts'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copies of all education documents including Certificates and Transcripts/Marks Memos<em v-if="documents.slgTransScripts">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgTransScripts'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgTransScripts'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgTransScripts'})">
                <vs-checkbox
              
                v-model="documents.slgTransScripts"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgTransScripts',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgExpLetters'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Letters of Experience<em v-if="documents.slgExpLetters">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgExpLetters'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgExpLetters'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgExpLetters'})">
                <vs-checkbox
              
                v-model="documents.slgExpLetters"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgExpLetters',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgPassportAndVisa'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of New and Old Passport along with Visa<em v-if="documents.slgPassportAndVisa">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPassportAndVisa'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPassportAndVisa'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPassportAndVisa'})">
                <vs-checkbox
              
                v-model="documents.slgPassportAndVisa"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgPassportAndVisa',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgI94'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > I-94<em v-if="documents.slgI94">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgI94'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgI94'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgI94'})">
                <vs-checkbox
              
                v-model="documents.slgI94"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgI94',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgPrevNonimmApprovalNotices'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 etc.,)<em v-if="documents.slgPrevNonimmApprovalNotices">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPrevNonimmApprovalNotices'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPrevNonimmApprovalNotices'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPrevNonimmApprovalNotices'})">
                <vs-checkbox
              
                v-model="documents.slgPrevNonimmApprovalNotices"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgPrevNonimmApprovalNotices',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgPrevImmApprovalNotices'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copies of all prior Notice of Approvals/Receipts (if any) for legal status in the US<em v-if="documents.slgPrevImmApprovalNotices">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPrevImmApprovalNotices'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPrevImmApprovalNotices'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPrevImmApprovalNotices'})">
                <vs-checkbox
              
                v-model="documents.slgPrevImmApprovalNotices"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgPrevImmApprovalNotices',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgI140OrPermNoties'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of any I-140 approval notices or PERM filing Notices (if applicable)<em v-if="documents.slgI140OrPermNoties">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgI140OrPermNoties'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgI140OrPermNoties'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgI140OrPermNoties'})">
                <vs-checkbox
              
                v-model="documents.slgI140OrPermNoties"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgI140OrPermNoties',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgPrevLaborApplications'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of the previously filed Labor Application, if applicable.<em v-if="documents.slgPrevLaborApplications">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPrevLaborApplications'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPrevLaborApplications'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPrevLaborApplications'})">
                <vs-checkbox
              
                v-model="documents.slgPrevLaborApplications"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgPrevLaborApplications',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgAckOfPrevLaborApplications'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of the Acknowledgement letter for the previously filed Labor application, if applicable.<em v-if="documents.slgAckOfPrevLaborApplications">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgAckOfPrevLaborApplications'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgAckOfPrevLaborApplications'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgAckOfPrevLaborApplications'})">
                <vs-checkbox
              
                v-model="documents.slgAckOfPrevLaborApplications"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgAckOfPrevLaborApplications',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgPaystubs'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copies of most recent four paystubs to the present salary drawn.<em v-if="documents.slgPaystubs">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPaystubs'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPaystubs'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPaystubs'})">
                <vs-checkbox
              
                v-model="documents.slgPaystubs"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgPaystubs',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgI20'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copies of all I-20’s.<em v-if="documents.slgI20">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgI20'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgI20'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgI20'})">
                <vs-checkbox
              
                v-model="documents.slgI20"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgI20',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgEad'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copies of EAD cards.<em v-if="documents.slgEad">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgEad'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgEad'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgEad'})">
                <vs-checkbox
              
                v-model="documents.slgEad"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgEad',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div> 
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgEvalOfEduCredentials'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          > Copy of Educational Evaluation, if any (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.)<em v-if="documents.slgEvalOfEduCredentials">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgEvalOfEduCredentials'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgEvalOfEduCredentials'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgEvalOfEduCredentials'})">
                <vs-checkbox
              
                v-model="documents.slgEvalOfEduCredentials"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgEvalOfEduCredentials',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>
  <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'slgEvalOfEduExpCredentials'})">
    <div class="form_group">
      <div class="d-flex align-end mb-1">
        <label class="form_label"
          >Education+Experience Evaluation<em v-if="documents.slgEvalOfEduExpCredentials">*</em></label
        >
        <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgEvalOfEduExpCredentials'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgEvalOfEduExpCredentials'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgEvalOfEduExpCredentials'})">
                <vs-checkbox
              
                v-model="documents.slgEvalOfEduExpCredentials"
          @change="
            selectCheck({
              section: 'documents',
              key: 'slgEvalOfEduExpCredentials',
            })
          "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>
        
      </div>
      <span
        class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
      >
        <img
          src="@/assets/images/main/file-upload.svg"
          class="file-icon"
        />Upload
        <input
          type="file"
          name="false"
          id="null"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </span>
    </div>
  </div>

  <!------
                // formI797H4ApprovalNotice: true,
               // formI797H1BApprovalNoticePrinNonCtzn: true,
              // passportOfPrinNonCtzn: true,
             // last3MonthsPayslipsOfPrinNonCtzn: true,
            // marriageCertificate: true,
              // h4Ead: true,
             -->
              <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'formI797H4ApprovalNotice'})">
                <div class="form_group">
                <div class="d-flex align-end mb-1">
                <label class="form_label"
                > {{'formI797H4ApprovalNotice' | formatdoctype}}<em v-if="documents.formI797H4ApprovalNotice">*</em></label
                >
                <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'documents',key:'formI797H4ApprovalNotice'})">
                  
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'formI797H4ApprovalNotice'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'formI797H4ApprovalNotice'})">
                  <vs-checkbox

                  v-model="documents.formI797H4ApprovalNotice"
                @change="
                selectCheck({
                section: 'documents',
                key: 'formI797H4ApprovalNotice',
                })
                "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>

                </div>
                <span
                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                <img
                src="@/assets/images/main/file-upload.svg"
                class="file-icon"
                />Upload
                <input
                type="file"
                name="false"
                id="null"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                </span>
                </div>
              </div>

              <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'formI797H1BApprovalNoticePrinNonCtzn'})">
                <div class="form_group">
                <div class="d-flex align-end mb-1">
                <label class="form_label"
                > {{'formI797H1BApprovalNoticePrinNonCtzn' | formatdoctype}}<em v-if="documents.formI797H1BApprovalNoticePrinNonCtzn">*</em></label
                >
                <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'documents',key:'formI797H1BApprovalNoticePrinNonCtzn'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'formI797H1BApprovalNoticePrinNonCtzn'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'formI797H1BApprovalNoticePrinNonCtzn'})">
                  <vs-checkbox

                  v-model="documents.formI797H1BApprovalNoticePrinNonCtzn"
                @change="
                selectCheck({
                section: 'documents',
                key: 'formI797H1BApprovalNoticePrinNonCtzn',
                })
                "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>

                </div>
                <span
                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                <img
                src="@/assets/images/main/file-upload.svg"
                class="file-icon"
                />Upload
                <input
                type="file"
                name="false"
                id="null"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                </span>
                </div>
              </div>

              <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'passportOfPrinNonCtzn'})">
                <div class="form_group">
                <div class="d-flex align-end mb-1">
                <label class="form_label"
                > {{'passportOfPrinNonCtzn' | formatdoctype}}<em v-if="documents.passportOfPrinNonCtzn">*</em></label
                >
                <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'documents',key:'passportOfPrinNonCtzn'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'passportOfPrinNonCtzn'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'passportOfPrinNonCtzn'})">
                  <vs-checkbox

                  v-model="documents.passportOfPrinNonCtzn"
                @change="
                selectCheck({
                section: 'documents',
                key: 'passportOfPrinNonCtzn',
                })
                "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>

                </div>
                <span
                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                <img
                src="@/assets/images/main/file-upload.svg"
                class="file-icon"
                />Upload
                <input
                type="file"
                name="false"
                id="null"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                </span>
                </div>
              </div>

              <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'last3MonthsPayslipsOfPrinNonCtzn'})">
                <div class="form_group">
                <div class="d-flex align-end mb-1">
                <label class="form_label"
                > {{'last3MonthsPayslipsOfPrinNonCtzn' | formatdoctype}}<em v-if="documents.last3MonthsPayslipsOfPrinNonCtzn">*</em></label
                >
                <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'documents',key:'last3MonthsPayslipsOfPrinNonCtzn'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'last3MonthsPayslipsOfPrinNonCtzn'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'last3MonthsPayslipsOfPrinNonCtzn'})">
                  <vs-checkbox

                  v-model="documents.last3MonthsPayslipsOfPrinNonCtzn"
                @change="
                selectCheck({
                section: 'documents',
                key: 'last3MonthsPayslipsOfPrinNonCtzn',
                })
                "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>

                </div>
                <span
                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                <img
                src="@/assets/images/main/file-upload.svg"
                class="file-icon"
                />Upload
                <input
                type="file"
                name="false"
                id="null"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                </span>
                </div>
             </div>

             <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'marriageCertificate'})">
              <div class="form_group">
              <div class="d-flex align-end mb-1">
              <label class="form_label"
              > {{'marriageCertificate' | formatdoctype}}<em v-if="documents.marriageCertificate">*</em></label
              >
              <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'marriageCertificate'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'marriageCertificate'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'marriageCertificate'})">
                <vs-checkbox

                v-model="documents.marriageCertificate"
              @change="
              selectCheck({
              section: 'documents',
              key: 'marriageCertificate',
              })
              "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>

              </div>
              <span
              class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
              >
              <img
              src="@/assets/images/main/file-upload.svg"
              class="file-icon"
              />Upload
              <input
              type="file"
              name="false"
              id="null"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              />
              </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'h4Ead'})">
              <div class="form_group">
              <div class="d-flex align-end mb-1">
              <label class="form_label"
              > {{'h4Ead' | formatdoctype}}<em v-if="documents.h4Ead">*</em></label
              >
              <div class="check_box_container"  v-if="isEdit">
              <div class="check_box_list" @click="toogleFields({section:'documents',key:'h4Ead'})">
                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'h4Ead'})}" >
                  <span class="checkmark" >
                    <i class="material-icons">check</i>
                  </span>
                </span>
                <div class="tooltip_cnt">
                  <p>Field is required</p>
                </div>
              </div>
              <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'h4Ead'})">
                <vs-checkbox

                v-model="documents.h4Ead"
              @change="
              selectCheck({
              section: 'documents',
              key: 'h4Ead',
              })
              "
                ></vs-checkbox>
                <div class="tooltip_cnt">
                  <p>Validation is required</p>
                </div>
              </div>
              </div>

              </div>
              <span
              class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
              >
              <img
              src="@/assets/images/main/file-upload.svg"
              class="file-icon"
              />Upload
              <input
              type="file"
              name="false"
              id="null"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              />
              </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'capSelectNotice'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >CAP Selection Notice<em v-if="documents.capSelectNotice">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'capSelectNotice'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'capSelectNotice'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'capSelectNotice'})">
                          <vs-checkbox
                        
                          v-model="documents.capSelectNotice"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'capSelectNotice',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <!-- New I-130 documents -->
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpousePassport'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of all the pages of the passport of your spouse (including the blank pages)<em v-if="documents.sponsorSpousePassport">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpousePassport'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpousePassport'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpousePassport'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpousePassport"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpousePassport',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpouseMarriageCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of the Marriage Certificate<em v-if="documents.sponsorSpouseMarriageCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpouseMarriageCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpouseMarriageCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpouseMarriageCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpouseMarriageCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpouseMarriageCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpouseBirthCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of the Birth Certificate of the Spouse<em v-if="documents.sponsorSpouseBirthCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpouseBirthCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpouseBirthCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpouseBirthCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpouseBirthCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpouseBirthCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpouseMarriagePhotographs'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Photographs of the marriage and after marriage photographs of the couples<em v-if="documents.sponsorSpouseMarriagePhotographs">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpouseMarriagePhotographs'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpouseMarriagePhotographs'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpouseMarriagePhotographs'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpouseMarriagePhotographs"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpouseMarriagePhotographs',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpouseAffidavits'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Affidavits from the parents of you and your spouse confirming your bona fide marital relationship<em v-if="documents.sponsorSpouseAffidavits">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpouseAffidavits'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpouseAffidavits'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpouseAffidavits'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpouseAffidavits"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpouseAffidavits',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpouseMartialRelationship'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Any other document that show the ongoing martial relationship<em v-if="documents.sponsorSpouseMartialRelationship">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpouseMartialRelationship'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpouseMartialRelationship'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpouseMartialRelationship'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpouseMartialRelationship"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpouseMartialRelationship',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSpousePhotographs'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Two (2) passport sized photographs of your spouse<em v-if="documents.sponsorSpousePhotographs">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSpousePhotographs'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSpousePhotographs'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSpousePhotographs'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSpousePhotographs"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSpousePhotographs',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorFatherPassport'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of all the pages of the passport of your father (including the blank pages)<em v-if="documents.sponsorFatherPassport">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorFatherPassport'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorFatherPassport'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorFatherPassport'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorFatherPassport"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorFatherPassport',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorFatherBirthCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your birth certificate showing your name and your parents’ names<em v-if="documents.sponsorFatherBirthCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorFatherBirthCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorFatherBirthCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorFatherBirthCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorFatherBirthCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorFatherBirthCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorFatherParentsMarriageCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth<em v-if="documents.sponsorFatherParentsMarriageCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorFatherParentsMarriageCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorFatherParentsMarriageCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorFatherParentsMarriageCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorFatherParentsMarriageCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorFatherParentsMarriageCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorMotherPassport'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of all the pages of the passport of your mother (including the blank pages)<em v-if="documents.sponsorMotherPassport">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorMotherPassport'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorMotherPassport'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorMotherPassport'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorMotherPassport"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorMotherPassport',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorMotherBirthCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your birth certificate showing your name and your mother’s<em v-if="documents.sponsorMotherBirthCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorMotherBirthCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorMotherBirthCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorMotherBirthCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorMotherBirthCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorMotherBirthCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSiblingPassport'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of all the pages of the passport of your sibling (including the blank pages)<em v-if="documents.sponsorSiblingPassport">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSiblingPassport'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSiblingPassport'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSiblingPassport'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSiblingPassport"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSiblingPassport',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSiblingBirthCertWithParents'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your birth certificate showing your name and your parents’ names<em v-if="documents.sponsorSiblingBirthCertWithParents">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSiblingBirthCertWithParents'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSiblingBirthCertWithParents'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSiblingBirthCertWithParents'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSiblingBirthCertWithParents"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSiblingBirthCertWithParents',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSiblingBirthCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your sibling’s birth certificate <em v-if="documents.sponsorSiblingBirthCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSiblingBirthCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSiblingBirthCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSiblingBirthCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSiblingBirthCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSiblingBirthCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorSiblingBffidavits'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office) <em v-if="documents.sponsorSiblingBffidavits">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorSiblingBffidavits'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorSiblingBffidavits'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorSiblingBffidavits'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorSiblingBffidavits"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorSiblingBffidavits',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorChildPassport'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of all the pages of the passport of your child (including the blank pages) <em v-if="documents.sponsorChildPassport">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorChildPassport'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorChildPassport'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorChildPassport'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorChildPassport"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorChildPassport',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorChildBirthCertWithParents'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father <em v-if="documents.sponsorChildBirthCertWithParents">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorChildBirthCertWithParents'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorChildBirthCertWithParents'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorChildBirthCertWithParents'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorChildBirthCertWithParents"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorChildBirthCertWithParents',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'sponsorChildBirthCertificate'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copy of your child’s birth certificate showing child’s name and your name- if you are the child’s mother <em v-if="documents.sponsorChildBirthCertificate">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'sponsorChildBirthCertificate'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'sponsorChildBirthCertificate'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'sponsorChildBirthCertificate'})">
                          <vs-checkbox
                        
                          v-model="documents.sponsorChildBirthCertificate"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'sponsorChildBirthCertificate',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <!-- L1 case Documents Starts -->
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'last12MonthsPayslips'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Beneficiary’s Pay Slips<em v-if="documents.last12MonthsPayslips">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'last12MonthsPayslips'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'last12MonthsPayslips'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'last12MonthsPayslips'})">
                          <vs-checkbox
                        
                          v-model="documents.last12MonthsPayslips"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'last12MonthsPayslips',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'proExecOrmanagerial'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.)<em v-if="documents.proExecOrmanagerial">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'proExecOrmanagerial'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'proExecOrmanagerial'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'proExecOrmanagerial'})">
                          <vs-checkbox
                        
                          v-model="documents.proExecOrmanagerial"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'proExecOrmanagerial',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'copyOfVeriPoliBenfApproved'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copies of various policies Beneficiary approved<em v-if="documents.copyOfVeriPoliBenfApproved">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'copyOfVeriPoliBenfApproved'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'copyOfVeriPoliBenfApproved'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'copyOfVeriPoliBenfApproved'})">
                          <vs-checkbox
                        
                          v-model="documents.copyOfVeriPoliBenfApproved"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'copyOfVeriPoliBenfApproved',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'copyOfContExecByBeneficiary'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copies of Contracts executed by Beneficiary<em v-if="documents.copyOfContExecByBeneficiary">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'copyOfContExecByBeneficiary'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'copyOfContExecByBeneficiary'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'copyOfContExecByBeneficiary'})">
                          <vs-checkbox
                        
                          v-model="documents.copyOfContExecByBeneficiary"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'copyOfContExecByBeneficiary',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'copyOfBoardMinBenfPlayRole'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Copies of Board Minutes where Beneficiary played a role<em v-if="documents.copyOfBoardMinBenfPlayRole">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'copyOfBoardMinBenfPlayRole'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'copyOfBoardMinBenfPlayRole'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'copyOfBoardMinBenfPlayRole'})">
                          <vs-checkbox
                        
                          v-model="documents.copyOfBoardMinBenfPlayRole"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'copyOfBoardMinBenfPlayRole',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'payRevisionLetters'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Pay Revision Letters (Exhibit 14)<em v-if="documents.payRevisionLetters">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'payRevisionLetters'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'payRevisionLetters'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'payRevisionLetters'})">
                          <vs-checkbox
                        
                          v-model="documents.payRevisionLetters"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'payRevisionLetters',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'leaveAppliForms'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Leave Application Forms (Exhibit 14)<em v-if="documents.leaveAppliForms">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'leaveAppliForms'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'leaveAppliForms'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'leaveAppliForms'})">
                          <vs-checkbox
                        
                          v-model="documents.leaveAppliForms"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'leaveAppliForms',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'manageManPowerReq'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Manage Manpower Request (Exhibit 14)<em v-if="documents.manageManPowerReq">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'manageManPowerReq'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'manageManPowerReq'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'manageManPowerReq'})">
                          <vs-checkbox
                        
                          v-model="documents.manageManPowerReq"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'manageManPowerReq',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'offerLetterFromUSComp'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Offer letter from the US Company<em v-if="documents.offerLetterFromUSComp">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'offerLetterFromUSComp'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'offerLetterFromUSComp'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'offerLetterFromUSComp'})">
                          <vs-checkbox
                        
                          v-model="documents.offerLetterFromUSComp"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'offerLetterFromUSComp',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'empAgreementFromUSComp'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Employment Agreement from the US Company <em v-if="documents.empAgreementFromUSComp">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'empAgreementFromUSComp'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'empAgreementFromUSComp'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'empAgreementFromUSComp'})">
                          <vs-checkbox
                        
                          v-model="documents.empAgreementFromUSComp"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'empAgreementFromUSComp',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'offerLetterFromForeComp'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Offer letter from the Foreign Company<em v-if="documents.offerLetterFromForeComp">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'offerLetterFromForeComp'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'offerLetterFromForeComp'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'offerLetterFromForeComp'})">
                          <vs-checkbox
                        
                          v-model="documents.offerLetterFromForeComp"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'offerLetterFromForeComp',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'empAgreementFromForeComp'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Employment Agreement from the Foreign Company<em v-if="documents.empAgreementFromForeComp">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'empAgreementFromForeComp'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'empAgreementFromForeComp'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'empAgreementFromForeComp'})">
                          <vs-checkbox
                        
                          v-model="documents.empAgreementFromForeComp"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'empAgreementFromForeComp',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'trainingCert'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Training Certificate<em v-if="documents.trainingCert">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'trainingCert'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'trainingCert'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'trainingCert'})">
                          <vs-checkbox
                        
                          v-model="documents.trainingCert"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'trainingCert',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'proofOfSpecKnowledge'})">
              <div class="form_group">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"
                    >Proof of specialized knowledge (Note: Technical and functional knowledge)<em v-if="documents.proofOfSpecKnowledge">*</em></label
                  >
                  <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'proofOfSpecKnowledge'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'proofOfSpecKnowledge'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'proofOfSpecKnowledge'})">
                          <vs-checkbox
                        
                          v-model="documents.proofOfSpecKnowledge"
                    @change="
                      selectCheck({
                        section: 'documents',
                        key: 'proofOfSpecKnowledge',
                      })
                    "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                  
                </div>
                <span
                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                >
                  <img
                    src="@/assets/images/main/file-upload.svg"
                    class="file-icon"
                  />Upload
                  <input
                    type="file"
                    name="false"
                    id="null"
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </span>
              </div>
            </div>
            <!-- L1 case Documents Ends -->
            


                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--dependends(spouse)-->
            <div v-if="currentTab=='Dependents Info'">
              <form>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasAnyDependetsinUStoFileH4'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you have any dependents currently in USA for whom you wish to file H4 Visa?<em v-if="beneficiaryInfo.hasAnyDependetsinUStoFileH4">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.hasAnyDependetsinUStoFileH4"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'hasAnyDependetsinUStoFileH4',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4Required'}) || showOrHideField({section: 'dependentsInfo.spouse',key: 'hasSpouse'})
                  || showOrHideField({section: 'dependentsInfo.spouse',key: 'l2Required'})">
                    <div class="vx-row">
                      
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4Required'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">H4 required for spouse?<em v-if="dependentsInfo.spouse.h4Required">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'h4Required'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4Required'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'h4Required'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.h4Required"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'h4Required',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hasSpouse'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you want to fill spouse information?<em v-if="dependentsInfo.spouse.hasSpouse">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'hasSpouse'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hasSpouse'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hasSpouse'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.hasSpouse"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'hasSpouse',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'l2Required'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">L2 required for spouse?<em v-if="dependentsInfo.spouse.l2Required">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'l2Required'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'l2Required'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'l2Required'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.l2Required"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'l2Required',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <template v-if="dependentsInfo.spouse.h4Required || dependentsInfo.spouse.hasSpouse || dependentsInfo.spouse.l2Required">
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'adjustmentOfI485Status'})">
                        <h3  class="small-header">Spouse Information</h3>
                        <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Adjustment of Status (I-485)
                            <p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green Card</p>  
                          </vs-checkbox>
                        </div>
                          <div class="check_box_container mart30" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.adjustmentOfI485Status"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'adjustmentOfI485Status',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'consularProcessing'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Consular Processing 
                            <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                            abroad to apply for an immigrant visa to get your Green Card</p>
                          </vs-checkbox>
                        </div>
                          <div class="check_box_container mart30" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'consularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'consularProcessing'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'consularProcessing'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.consularProcessing"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'consularProcessing',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!---h4EadPhotoEmailStmt-->
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4EadPhotoEmailStmt'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <b>Note:</b> <p style="padding-left:5px;">TWO US style photographs are required for H4 EAD filing, please mail the copies to our office address: Somireddy Law Group PLLC, 20745 Williamsport Place, Suite 390, Ashburn, Virginia 20147</p>
                          
                        </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="false && checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.h4EadPhotoEmailStmt"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'h4EadPhotoEmailStmt',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentlyInUS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Are you currently in USA? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentlyInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentlyInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentlyInUS'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.currentlyInUS"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'currentlyInUS',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'adjustmentStatusToPermResidenceI485'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Adjustment of status to Permanent Residency (Form I-485) required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.adjustmentStatusToPermResidenceI485"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'adjustmentStatusToPermResidenceI485',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >H4 EAD required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'h4EADRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EADRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EADRequired'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.h4EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'h4EADRequired',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'doYouAlreadyH4EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Do you already have H4 EAD?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'doYouAlreadyH4EAD'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouAlreadyH4EAD'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouAlreadyH4EAD'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.doYouAlreadyH4EAD"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'doYouAlreadyH4EAD',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'l2EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >L2 EAD required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'l2EADRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'l2EADRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'l2EADRequired'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.l2EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'l2EADRequired',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'doYouAlreadyL2EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Do you already have L2 EAD?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'doYouAlreadyL2EAD'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouAlreadyL2EAD'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouAlreadyL2EAD'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.doYouAlreadyL2EAD"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'doYouAlreadyL2EAD',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="dependentsInfo.spouse.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.spouse.gender"
                             @change="
                             selectCheck({ section: 'dependentsInfo.spouse', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                     </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full mb-10">
                        <div class="vx-input-group flex form-input-group FML">
                          <div class="vx-input-group-default flex-grow">
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'firstName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">First Name<em v-if="dependentsInfo.spouse.firstName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'middleName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.middleName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.lastName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.lastName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'lastName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.otherNames"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                      </div>
                     
                     
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'nameDiffFromBirthCert'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> if your name is different from that stated on your birth certificate, have you had it legally changes? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.nameDiffFromBirthCert"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'nameDiffFromBirthCert',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'birthCertHaveNamePobDob'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.birthCertHaveNamePobDob"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'birthCertHaveNamePobDob',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> 
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'have2AffidavitsOfBirthFamily'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Do you have two (2) affidavits of birth from family members?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.have2AffidavitsOfBirthFamily"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'have2AffidavitsOfBirthFamily',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="dependentsInfo.spouse.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10 md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="dependentsInfo.spouse.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'email'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.email"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'email',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'dateOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.spouse.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.phoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'phoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.spouse.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'countryOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="dependentsInfo.spouse.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'provinceOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="dependentsInfo.spouse.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.locationOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'locationOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Citizenship<em v-if="dependentsInfo.spouse.countryOfCitizenship">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'countryOfCitizenship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.height',key: 'feet'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Feet<em v-if="dependentsInfo.spouse.height.feet">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.height',key:'feet'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.height',key:'feet'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.height',key:'feet'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.height.feet"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.height',
                                  key: 'feet',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.height',key: 'inches'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Inches<em v-if="dependentsInfo.spouse.height.inches">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.height',key:'inches'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.height',key:'inches'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.height',key:'inches'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.height.inches"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.height',
                                  key: 'inches',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'weight'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Weight<em v-if="dependentsInfo.spouse.weight">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'weight'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'weight'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'weight'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.weight"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'weight',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'race'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Ethnicity/Race<em v-if="dependentsInfo.spouse.race">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'race'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'race'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'race'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.race"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'race',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'eyeColor'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EYE COLOR<em v-if="dependentsInfo.spouse.eyeColor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'eyeColor'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'eyeColor'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'eyeColor'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.eyeColor"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'eyeColor',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hairColor'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">HAIR COLOR<em v-if="dependentsInfo.spouse.hairColor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'hairColor'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hairColor'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hairColor'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.hairColor"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'hairColor',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'maritalStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Marital Status<em v-if="dependentsInfo.spouse.maritalStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'maritalStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'maritalStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'maritalStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.maritalStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'maritalStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.dateOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriage'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.dateOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'dateOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfMarriageEnd'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage End<em v-if="dependentsInfo.spouse.dateOfMarriageEnd">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.dateOfMarriageEnd"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'dateOfMarriageEnd',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Marriage<em v-if="dependentsInfo.spouse.countryOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.countryOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'countryOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'provinceOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Marriage<em v-if="dependentsInfo.spouse.provinceOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.provinceOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'provinceOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'locationOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Marriage<em v-if="dependentsInfo.spouse.locationOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'locationOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.locationOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'locationOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentSpouseName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Spouse Name<em v-if="dependentsInfo.spouse.currentSpouseName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentSpouseName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentSpouseName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentSpouseName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.currentSpouseName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'currentSpouseName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverTravelledToUS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever travelled to the United States?<em v-if="dependentsInfo.spouse.haveYouEverTravelledToUS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.haveYouEverTravelledToUS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'haveYouEverTravelledToUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'stateOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              > State of recent entry into the USA<em v-if="dependentsInfo.spouse.stateOfLastEntryInUS">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.stateOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'stateOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'placeOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Place of recent entry into the USA<em v-if="dependentsInfo.spouse.placeOfLastEntryInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.placeOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'placeOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastArrivalDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date of most recent entry into the USA<em v-if="dependentsInfo.spouse.lastArrivalDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.lastArrivalDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'lastArrivalDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'applyingWithYou'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Applying with you?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'applyingWithYou'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'applyingWithYou'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'applyingWithYou'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.applyingWithYou"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'applyingWithYou',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'enterInUSUnderCaseWaiverProgram'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Did you enter the U.S. under the Visa waiver program?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.enterInUSUnderCaseWaiverProgram"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'enterInUSUnderCaseWaiverProgram',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      
                  
                      
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'inspectedByAnyImmOfficer'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Were you inspected by an immigration officer?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.inspectedByAnyImmOfficer"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'inspectedByAnyImmOfficer',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'issuedAnyEADFromUSCIS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever been issued an Employement Authorization Document(EAD) from the USCIS?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.issuedAnyEADFromUSCIS"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'issuedAnyEADFromUSCIS',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'eadCard'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Please provide a copy of the EAD CARD(S), front and  back<em v-if="dependentsInfo.spouse.documents.eadCard">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'eadCard'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'eadCard'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'eadCard'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.documents.eadCard"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'eadCard',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hasPermResidencyInOtherCountry'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Do you hold Permanent residence in any other country? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.hasPermResidencyInOtherCountry"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'hasPermResidencyInOtherCountry',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'permResidencyCountryDetails'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Permanent Residency Country<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.permResidencyCountryDetails"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'permResidencyCountryDetails',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouArrestedBefore'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been arrested,cited, charged or detained for any reason by an law enforcement official? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouArrestedBefore"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouArrestedBefore',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouArrestedBeforeDocs'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >documents, if any<em>*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.haveYouArrestedBeforeDocs"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'haveYouArrestedBeforeDocs',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>                  
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'everAppliedAOSInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever applied AOS in the united states or an immigrant visa at the US Embassy/Consulate to obatain permanent resident status before? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.everAppliedAOSInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'everAppliedAOSInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'appliedAOSInUSDocs'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >documents, if any<em>*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.appliedAOSInUSDocs"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'appliedAOSInUSDocs',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverReceivedPublicAssistendeInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever received public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouEverReceivedPublicAssistendeInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouEverReceivedPublicAssistendeInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverlikelyReceivePublicAssistendeInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Have you ever likely to receive public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)?
 </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouEverlikelyReceivePublicAssistendeInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouEverlikelyReceivePublicAssistendeInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isVisaDenieedTOUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been denied a visa to the United States?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.isVisaDenieedTOUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'isVisaDenieedTOUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'visaDeniedReason'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Reason<em v-if="dependentsInfo.spouse.visaDeniedReason">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'visaDeniedReason'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'visaDeniedReason'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'visaDeniedReason'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.visaDeniedReason"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'visaDeniedReason',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYoueverPresntUnlawfully'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been present in the united states unlawfully for more than 180 days?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYoueverPresntUnlawfully"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYoueverPresntUnlawfully',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'presntUnlawfullyReason'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Reason<em v-if="dependentsInfo.spouse.presntUnlawfullyReason">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.presntUnlawfullyReason"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'presntUnlawfullyReason',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                     
                      
                     
                      






                    
                      
                      <div class="vx-col w-full" v-if="checkPassportLabel({section:'dependentsInfo.spouse'})" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Number<em v-if="dependentsInfo.spouse.passportNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportNumber',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.spouse.passportIssuedDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportIssuedDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportIssuedDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.spouse.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportExpiryDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportExpiryDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedCountry'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Passport Issued<em v-if="dependentsInfo.spouse.passportIssuedCountry">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.passportIssuedCountry"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'passportIssuedCountry',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'curNonImmigrantVisaNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current nonimmigrant visa number<em v-if="dependentsInfo.spouse.curNonImmigrantVisaNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.curNonImmigrantVisaNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'curNonImmigrantVisaNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                    
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status<em v-if="dependentsInfo.spouse.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.currentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'currentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'statusExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.spouse.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- <div class="vx-col w-full md:w-1/2 mart20" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'statusExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.spouse.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',
                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'I94'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Number<em v-if="dependentsInfo.spouse.I94">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'I94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'I94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'I94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.I94"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'I94',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'I94ExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isI94DSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="dependentsInfo.spouse.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'doYouHaveSSN'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Do you have SSN?<em v-if="dependentsInfo.spouse.doYouHaveSSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'doYouHaveSSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouHaveSSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouHaveSSN'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.doYouHaveSSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'doYouHaveSSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'SSN'})">
                        <div class="vx-row">
                          <div class="vx-col  w-full mb-5">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security number (if applicable)<em v-if="dependentsInfo.spouse.SSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'SSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.SSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'SSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                        
                        </div>
                      </div>
                      <div class="vx-col  w-full md:w-1/2 "  v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'alienNumber'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Your Alien Number (if applicable)<em v-if="dependentsInfo.spouse.alienNumber">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'alienNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'alienNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'alienNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.alienNumber"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'alienNumber',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'sevisNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">SEVIS Number<em v-if="dependentsInfo.spouse.sevisNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'sevisNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'sevisNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'sevisNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.sevisNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'sevisNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'eadNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EAD Number<em v-if="dependentsInfo.spouse.eadNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'eadNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'eadNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'eadNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.eadNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'eadNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'doYouWantTheSsaToIssueYouSS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Do you want the SSA to issue you a Social Security card?<em v-if="dependentsInfo.spouse.doYouWantTheSsaToIssueYouSS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'doYouWantTheSsaToIssueYouSS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouWantTheSsaToIssueYouSS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'doYouWantTheSsaToIssueYouSS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.doYouWantTheSsaToIssueYouSS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'doYouWantTheSsaToIssueYouSS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnFather',key: 'familyName'}) ||
                      showOrHideField({section: 'dependentsInfo.spouse.ssnFather',key: 'givenName'}) ">
                      <div class="vx-col w-full">
                        <div class="form_group w-full">
                          <label class="form_label">
                            <h3 class="small-header" style="margin-bottom: 10px !important;padding-bottom: 0px !important;">Father Name</h3>
                          </label>
                        </div>
                      </div>
                      </template>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnFather',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="dependentsInfo.spouse.ssnFather.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.ssnFather',key:'familyName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.ssnFather',key:'familyName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.ssnFather',key:'familyName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.ssnFather.familyName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.ssnFather',

                                  key: 'familyName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnFather',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Given Name<em v-if="dependentsInfo.spouse.ssnFather.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.ssnFather',key:'givenName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.ssnFather',key:'givenName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.ssnFather',key:'givenName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.ssnFather.givenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.ssnFather',

                                  key: 'givenName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <template v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnMother',key: 'familyName'}) ||
                      showOrHideField({section: 'dependentsInfo.spouse.ssnMother',key: 'givenName'}) ">
                        <div class="vx-col w-full">
                          <div class="form_group w-full">
                            <label class="form_label">
                              <h3 class="small-header" style="margin-bottom: 10px !important;padding-bottom: 0px !important;">Mother Name</h3>
                            </label>
                          </div>
                        </div>
                      </template>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnMother',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="dependentsInfo.spouse.ssnMother.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.ssnMother',key:'familyName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.ssnMother',key:'familyName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.ssnMother',key:'familyName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.ssnMother.familyName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.ssnMother',

                                  key: 'familyName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.ssnMother',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Given Name<em v-if="dependentsInfo.spouse.ssnMother.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.ssnMother',key:'givenName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.ssnMother',key:'givenName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.ssnMother',key:'givenName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.ssnMother.givenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.ssnMother',

                                  key: 'givenName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                     
                    
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'immigStatusLastArrival'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Immigration Status at Your Last Arrival<em v-if="dependentsInfo.spouse.immigStatusLastArrival">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'immigStatusLastArrival'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'immigStatusLastArrival'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'immigStatusLastArrival'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.immigStatusLastArrival"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'immigStatusLastArrival',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-0 mb-5">
                              <div class="d-flex">
                              <h3 class="small-header mt-0">Dates of Stay in USA<em v-if="dependentsInfo.spouse.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.priorPeriodOfStayInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'priorPeriodOfStayInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                          </div>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa Status</label>
                                </div>
                                <selectField wrapclass="" placeholder="Visa Status" />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="mx-input-wrapper">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete">
                              <a>
                                <img src="@/assets/images/main/delete-row-img.svg">
                              </a>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                     
                        <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="dependentsInfo.spouse.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.currentAddress"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'physicalAddress'})">
                        <h3 class="small-header">
                          Mailing Address <em v-if="dependentsInfo.spouse.physicalAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'physicalAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'physicalAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'physicalAddress'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.physicalAddress"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'physicalAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S<em v-if="dependentsInfo.spouse.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.addressOutsideUS"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',
                                        key: 'addressOutsideUS',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                      
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUSMoreThanYear'})">
                        <h3 class="small-header">
                          Last Address outside Of the United States for more than one year<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'addressOutsideUSMoreThanYear' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.addressOutsideUSMoreThanYear.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.addressOutsideUSMoreThanYear.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                      <div class="divider full-divider mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUSMoreThanYear'})"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOfLastNYears'})">
                        <h3 class="small-header">
                          Your Residence starting with most current for the Past Five Years in the U.S and Aboard<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.addressOfLastNYears"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'addressOfLastNYears' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOfLastNYears',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.addressOfLastNYears.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOfLastNYears.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOfLastNYears',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOfLastNYears',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.addressOfLastNYears.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOfLastNYears.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOfLastNYears',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                      <div class="divider full-divider mb-10"v-if="checkSpouseLabel({section:'dependentsInfo.spouse.previousSpouse'})"></div>
                      <div class="vx-col w-full" v-if="checkSpouseLabel({section:'dependentsInfo.spouse.previousSpouse'})" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Previous Spouse
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              dependentsInfo.spouse.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                            </h3>
                          </label>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'firstName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.previousSpouse.firstName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.firstName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'firstName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.previousSpouse.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.middleName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'lastName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.previousSpouse.lastName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.lastName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'lastName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="dependentsInfo.spouse.previousSpouse.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.previousSpouse.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.dateOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>  
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfMarriageEnd'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.dateOfMarriageEnd">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfMarriageEnd"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfMarriageEnd',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'countryOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.countryOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.countryOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'countryOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'provinceOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.provinceOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.provinceOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'provinceOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'locationOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.locationOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.locationOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'locationOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'countryOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Termination<em v-if="dependentsInfo.spouse.previousSpouse.countryOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.countryOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'countryOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'provinceOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Termination<em v-if="dependentsInfo.spouse.previousSpouse.provinceOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.provinceOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'provinceOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'locationOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Termination<em v-if="dependentsInfo.spouse.previousSpouse.locationOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.locationOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'locationOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'marriageEndedDueTo'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Marriage Ended Due To<em v-if="dependentsInfo.spouse.previousSpouse.marriageEndedDueTo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.marriageEndedDueTo"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'marriageEndedDueTo',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'marriageEndedOtherInfo'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">If, Marriage Ended<em v-if="dependentsInfo.spouse.previousSpouse.marriageEndedOtherInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.marriageEndedOtherInfo"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'marriageEndedOtherInfo',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                       <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.previousSpouse.obtainPermResidenceThroughSpouse"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.previousSpouse',
                                    key: 'obtainPermResidenceThroughSpouse',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    </div>
                  </div>
                </vs-col>
                
                <template v-if="dependentsInfo.spouse.h4Required || dependentsInfo.spouse.hasSpouse || dependentsInfo.spouse.l2Required">
                  <vs-col class="w-full p-0 mt-5" v-if="checkParentLabel({section:'dependentsInfo.spouse.fatherInfo'})" >
                    <vs-alert
                      color="warning"
                      class="warning-alert top-warning-alert"
                      icon-pack="IntakePortal"
                      icon="IP-information-button"
                      active="true"
                    >
                      Provide your father details, starting from
                      the most recent first.
                    </vs-alert>
                  </vs-col>
                  <vs-col v-if="checkParentLabel({section:'dependentsInfo.spouse.fatherInfo'})"
                    class="m-auto float-none"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="12"
                    vs-sm="12"
                  >
                    <div class="form-container pt-10 form-container_QT">
                              <h3 class="small-header" v-if="checkParentLabel({section:'dependentsInfo.spouse.fatherInfo'})">Father Information 
                                
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})">
                              <vs-checkbox
                            
                              v-model="
                            dependentsInfo.spouse.fatherInfo.fatherInfo
                          "
                          @change="
                            selectCheck({
                              section: 'dependentsInfo.spouse.fatherInfo',
                              key: 'fatherInfo',
                            })
                          "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                      <div class="vx-row">

                        <div class="vx-col w-full">
                          <div class="form-container alt-rows-bg questionnaire_hb">
                            <div class="vx-row">
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'firstName'})">
                                <div class="vx-input-group flex form-input-group FML">
                                  <div class="vx-input-group-default flex-grow">
                                    <div class="vx-col w-full md:w-1/2">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">First Name<em v-if="dependentsInfo.spouse.fatherInfo.firstName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'firstName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>

                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'middleName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.fatherInfo.middleName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'middleName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'lastName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.fatherInfo.lastName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})}"  >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.lastName"
                                            @change="
                                              selectCheck({
                                                section: 'dependentsInfo.spouse.fatherInfo',
                                                key: 'lastName',
                                              })
                                            "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'firstName'})">
                                  <div class="form_group w-full">
                                    <label class="form_label"
                                      ><h3 class="small-header">Name at Birth</h3>
                                    </label>
                                  </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'firstName'})">
                                <div class="vx-input-group flex form-input-group FML">
                                  <div class="vx-input-group-default flex-grow">
                                    <div class="vx-col w-full md:w-1/2">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">First Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.firstName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                          key: 'firstName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>

                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'middleName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.middleName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                          key: 'middleName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'lastName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.lastName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})}"  >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.lastName"
                                            @change="
                                              selectCheck({
                                                section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                                key: 'lastName',
                                              })
                                            "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'dateOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.fatherInfo.dateOfBirth">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})">
                                          <vs-checkbox
                                        
                                          v-model="dependentsInfo.spouse.fatherInfo.dateOfBirth"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'dateOfBirth',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'countryOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.countryOfBirth"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'countryOfBirth',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'provinceOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Province of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.provinceOfBirth"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'provinceOfBirth',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'locationOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Location of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.locationOfBirth"
                                @change="
                                  selectCheck({ section: 'dependentsInfo.spouse.fatherInfo', key: 'locationOfBirth' })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            </div>
                            <div class="vs-con-input">
                              <input type="text" class="vs-inputx vs-input--input normal" />
                            </div>
                          </div>
                          </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'currentAddress'})">
                          <h3 class="small-header">
                            Current Address <em v-if="currentAddress">*</em>
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.currentAddress"
                              @change="
                                selectCheck({ section: 'dependentsInfo.spouse.fatherInfo', key: 'currentAddress' })
                              "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            
                          </h3>
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Street Address</label>
                                </div>
                                <vs-input
                                  class="w-full"
                                  v-validate="'required'"
                                  data-vv-as="Street Address"
                                />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Apt, Suite</label>
                                </div>
                                <div class="address-suite">
                                  <ul
                                    class="demo-alignment custom-radio"
                                    vs-type="flex"
                                    vs-align="center"
                                  >
                                    <li>
                                      <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                    </li>
                                    <li>
                                      <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                    </li>
                                    <li>
                                      <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                    </li>
                                  </ul>
                                  <vs-input class="" data-vv-as="Apt, Suite" />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Country</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select Country"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"> State</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select State"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"> City</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select City"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Zip Code</label>
                                </div>
                                <vs-input class="w-full" />
                              </div>
                            </div>
                          </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'deceasedCity'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Deceased City<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.deceasedCity"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'deceasedCity',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'deceasedDate'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Deceased Date<em v-if="dependentsInfo.spouse.fatherInfo.deceasedDate">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})">
                                          <vs-checkbox
                                        
                                          v-model="dependentsInfo.spouse.fatherInfo.deceasedDate"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'deceasedDate',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'isUSCitizen'})">
                          <div class="d-flex align-center">
                            <a class="switch-label mr-3">
                              Is your father now or was he ever a U.S. citizen?
                            </a>
                            <vs-switch>
                              <span slot="on">Yes</span>
                              <span slot="off">No</span>
                            </vs-switch>
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.isUSCitizen"
                                @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.fatherInfo',
                                  key: 'isUSCitizen',
                                })
                              "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                          </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'dateFromUSCitizen'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> Dates from US citizen<em v-if="dependentsInfo.spouse.fatherInfo.dateFromUSCitizen">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.fatherInfo.dateFromUSCitizen"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'dateFromUSCitizen',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-col>                     
                  <vs-col class="w-full p-0 mt-5"v-if="checkParentLabel({section:'dependentsInfo.spouse.motherInfo'})">
                    <vs-alert
                      color="warning"
                      class="warning-alert top-warning-alert"
                      icon-pack="IntakePortal"
                      icon="IP-information-button"
                      active="true"
                    >
                      Provide your mother details, starting from
                      the most recent first.
                    </vs-alert>
                  </vs-col>
                  <vs-col
                      class="m-auto float-none"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="12"
                      v-if="checkParentLabel({section:'dependentsInfo.spouse.motherInfo'})"
                    >
                      <div class="form-container pt-10 form-container_QT">
                                <h3 class="small-header" v-if="checkParentLabel({section:'dependentsInfo.spouse.motherInfo'})">Mother Information 
                                  
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})">
                                <vs-checkbox
                              
                                v-model="
                              dependentsInfo.spouse.motherInfo.motherInfo
                            "
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse.motherInfo',
                                key: 'motherInfo',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                                </h3>
                        <div class="vx-row">

                          <div class="vx-col w-full">
                            <div class="form-container alt-rows-bg questionnaire_hb">
                              <div class="vx-row">
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'firstName'})">
                                  <div class="vx-input-group flex form-input-group FML">
                                    <div class="vx-input-group-default flex-grow">
                                      <div class="vx-col w-full md:w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.motherInfo.firstName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.firstName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'firstName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>

                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'middleName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.motherInfo.middleName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.middleName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'middleName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'lastName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.motherInfo.lastName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})}"  >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.lastName"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse.motherInfo',
                                                  key: 'lastName',
                                                })
                                              "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'firstName'})">
                                    <div class="form_group w-full">
                                      <label class="form_label"
                                        ><h3 class="small-header">Name at Birth</h3>
                                      </label>
                                    </div>
                                </div>
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'firstName'})">
                                  <div class="vx-input-group flex form-input-group FML">
                                    <div class="vx-input-group-default flex-grow">
                                      <div class="vx-col w-full md:w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.firstName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.firstName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                            key: 'firstName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>

                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'middleName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.middleName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.middleName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                            key: 'middleName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'lastName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.lastName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})}"  >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.lastName"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                                  key: 'lastName',
                                                })
                                              "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'dateOfBirth'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.motherInfo.dateOfBirth">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.motherInfo.dateOfBirth"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'dateOfBirth',
                                          })
                                        "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'countryOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Country of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.countryOfBirth"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'countryOfBirth',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'provinceOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Province of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.provinceOfBirth"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'provinceOfBirth',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'locationOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Location of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.locationOfBirth"
                                  @change="
                                    selectCheck({ section: 'dependentsInfo.spouse.motherInfo', key: 'locationOfBirth' })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" />
                              </div>
                            </div>
                            </div>
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'currentAddress'})">
                            <h3 class="small-header">
                              Current Address <em v-if="address">*</em>
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.currentAddress"
                                @change="
                                  selectCheck({ section: 'dependentsInfo.spouse.motherInfo', key: 'currentAddress' })
                                "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              
                            </h3>
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Street Address</label>
                                  </div>
                                  <vs-input
                                    class="w-full"
                                    v-validate="'required'"
                                    data-vv-as="Street Address"
                                  />
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Apt, Suite</label>
                                  </div>
                                  <div class="address-suite">
                                    <ul
                                      class="demo-alignment custom-radio"
                                      vs-type="flex"
                                      vs-align="center"
                                    >
                                      <li>
                                        <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                      </li>
                                    </ul>
                                    <vs-input class="" data-vv-as="Apt, Suite" />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Country</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select Country"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> State</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select State"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> City</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select City"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label">Zip Code</label>
                                  </div>
                                  <vs-input class="w-full" />
                                </div>
                              </div>
                            </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'deceasedCity'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Deceased City<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.deceasedCity"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'deceasedCity',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'deceasedDate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Deceased Date<em v-if="dependentsInfo.spouse.motherInfo.deceasedDate">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.motherInfo.deceasedDate"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'deceasedDate',
                                          })
                                        "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'isUSCitizen'})">
                            <div class="d-flex align-center">
                              <a class="switch-label mr-3">
                                Is your father now or was he ever a U.S. citizen?
                              </a>
                              <vs-switch>
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                              </vs-switch>
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.isUSCitizen"
                                  @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.motherInfo',
                                    key: 'isUSCitizen',
                                  })
                                "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'dateFromUSCitizen'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> Dates from US citizen<em v-if="dependentsInfo.spouse.motherInfo.dateFromUSCitizen">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.motherInfo.dateFromUSCitizen"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.motherInfo',
                                    key: 'dateFromUSCitizen',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </vs-col>

                  <vs-col class="w-full p-0 mt-5" v-if="checkAssociationLabel({section:'dependentsInfo.spouse.associations'})">
                      <vs-alert
                      color="warning"
                      class="warning-alert top-warning-alert"
                      icon-pack="IntakePortal"
                      icon="IP-information-button"
                      active="true"
                      >
                      All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None".
                      </vs-alert>
                  </vs-col>
                  <vs-col v-if="checkAssociationLabel({section:'dependentsInfo.spouse.associations'})"
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  >
                  <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header" v-if="checkAssociationLabel({section:'dependentsInfo.spouse.associations'})">ASSOCIATIONS/GROUPS 
                  <div class="check_box_container"  v-if="isEdit">
                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'associations'})">
                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'associations'})}" >
                      <span class="checkmark" >
                        <i class="material-icons">check</i>
                      </span>
                    </span>
                    <div class="tooltip_cnt">
                      <p>Field is required</p>
                    </div>
                  </div>
                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'associations'})">
                    <vs-checkbox
                        v-model="
                      dependentsInfo.spouse.associations.associations
                    "
                    @change="
                      selectCheck({
                        section: 'dependentsInfo.spouse.associations',
                        key: 'associations',
                      })
                    "
                    ></vs-checkbox>
                    <div class="tooltip_cnt">
                        <p>Validation is required</p>
                    </div>
                  </div>
                  </div>
                  </h3>
                  <div class="vx-row">
                  <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                            <div class="vx-row">
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'name'})">
                                  <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Name of the associations and groups<em v-if="dependentsInfo.spouse.associations.name">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'name'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'name'})}">
                                                    <span class="checkmark" >
                                                      <i class="material-icons">check</i>
                                                    </span>
                                                  </span>
                                                  <div class="tooltip_cnt">
                                                    <p>Field is required</p>
                                                  </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'name'})">
                                                <vs-checkbox
                          
                                                      v-model="dependentsInfo.spouse.associations.name"
                                                      @change="
                                                        selectCheck({
                                                          section: 'dependentsInfo.spouse.associations',
                                                          key: 'name',
                                                        })
                                                      "
                                                  ></vs-checkbox>
                                                  <div class="tooltip_cnt">
                                                    <p>Validation is required</p>
                                                  </div>
                                              </div>
                                        </div>
                                      </div>
                                      <div class="vs-con-input">
                                          <input type="text" class="vs-inputx vs-input--input normal" />
                                      </div>
                                  </div>
                              </div>
                            
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'address'})">
                    <h3 class="small-header">
                      Address<em v-if="dependentsInfo.spouse.associations.address">*</em>
                    <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'address'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'address'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'address'})">
                          <vs-checkbox
                        
                          v-model="dependentsInfo.spouse.associations.address"
                      @change="
                        selectCheck({
                          section: 'dependentsInfo.spouse.associations',
                          key: 'address',
                        })
                      "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                    </h3>
                  
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Country"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> State</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select State"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> City</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select City"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                            
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'startDate'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.associations.startDate">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'startDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'startDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'startDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.associations.startDate"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.associations',
                                    key: 'startDate',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                            
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'endDate'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">End Date<em v-if="dependentsInfo.spouse.associations.endDate">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'endDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'endDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'endDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.associations.endDate"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.associations',
                                    key: 'endDate',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                            
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'natureofAssociations'})">
                                  <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Nature of associations and groups<em v-if="dependentsInfo.spouse.associations.natureofAssociations">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})}">
                                                    <span class="checkmark" >
                                                      <i class="material-icons">check</i>
                                                    </span>
                                                  </span>
                                                  <div class="tooltip_cnt">
                                                    <p>Field is required</p>
                                                  </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})">
                                                <vs-checkbox
                          
                                                      v-model="dependentsInfo.spouse.associations.natureofAssociations"
                                                      @change="
                                                        selectCheck({
                                                          section: 'dependentsInfo.spouse.associations',
                                                          key: 'natureofAssociations',
                                                        })
                                                      "
                                                  ></vs-checkbox>
                                                  <div class="tooltip_cnt">
                                                    <p>Validation is required</p>
                                                  </div>
                                              </div>
                                        </div>
                                      </div>
                                      <div class="vs-con-input">
                                          <input type="text" class="vs-inputx vs-input--input normal" />
                                      </div>
                                  </div>
                              </div>

                            </div>

                      </div>
                    </div>

                  </div>
                  </div>
                  </vs-col>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;"  v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you been employed in the United States since last admitted or granted an extension or change of status?<em v-if="dependentsInfo.spouse.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                </div>
                <vs-col class="w-full p-0 mt-5" v-if="checkEmploymentLabel({section:'dependentsInfo.spouse.prevEmploymentInfo'})">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Please write the following information about your current and past employment for the past five years in the U.S and abroad starting with your most current Job.
                  </vs-alert>
                </vs-col>
                
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  v-if="checkEmploymentLabel({section:'dependentsInfo.spouse.prevEmploymentInfo'})"
                >
                
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header" v-if="checkEmploymentLabel({section:'dependentsInfo.spouse.prevEmploymentInfo'})">Employment 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          dependentsInfo.spouse.prevEmploymentInfo.prevEmploymentInfo
                        "
                        @change="
                          selectCheck({
                            section: 'dependentsInfo.spouse.prevEmploymentInfo',
                            key: 'prevEmploymentInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Employer Name<em v-if="dependentsInfo.spouse.prevEmploymentInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.employerName
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'employerName',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3"> Current Employer? </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model=" 
                                    dependentsInfo.spouse.prevEmploymentInfo.currentEmployer
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                      key: 'currentEmployer',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                            </div>
                            
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Job Title<em v-if="dependentsInfo.spouse.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.jobTitle"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'jobTitle',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Employer Business E.g., IT<em v-if="dependentsInfo.spouse.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.businessType
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'businessType',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div> 
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Salary<em v-if="dependentsInfo.spouse.prevEmploymentInfo.salary">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.salary
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Pay Frequency<em v-if="dependentsInfo.spouse.prevEmploymentInfo.payFrequency">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.payFrequency
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'jobDuties'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed<em v-if="dependentsInfo.spouse.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip H1-140">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.jobDuties"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'jobDuties',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'address'})">
                              <h3 class="small-header">
                                Work Address<em v-if="dependentsInfo.spouse.prevEmploymentInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.address"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.prevEmploymentInfo',

                                      key: 'address',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverEmployed'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed Outside US?<em v-if="dependentsInfo.spouse.haveYouEverEmployed">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.haveYouEverEmployed"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'haveYouEverEmployed',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                </div>
                <vs-col class="w-full p-0 mt-6" v-if="checkEmploymentOutsideUsLabel({section:'dependentsInfo.spouse.prevEmploymentOutsideUS'})">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Last Employer outside of the United States for more than one year.
                  </vs-alert>
                </vs-col>
                <vs-col v-if="checkEmploymentOutsideUsLabel({section:'dependentsInfo.spouse.prevEmploymentOutsideUS'})"
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header" v-if="checkEmploymentOutsideUsLabel({section:'dependentsInfo.spouse.prevEmploymentOutsideUS'})">Employment Outside US
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <vs-checkbox
                          
                            v-model="
                          dependentsInfo.spouse.prevEmploymentOutsideUS.prevEmploymentOutsideUS
                        "
                        @change="
                          selectCheck({
                            section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                            key: 'prevEmploymentOutsideUS',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

<div class="vx-col w-full">
  <div class="form-container alt-rows-bg questionnaire_hb">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'employerName'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Employer Name<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.employerName">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})">
                  <vs-checkbox
                
                  v-model="
                dependentsInfo.spouse.prevEmploymentOutsideUS.employerName
              "
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'employerName',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'currentEmployer'})">
        <div class="d-flex align-center">
          <a class="switch-label mr-3"> Current Employer? </a>
          <vs-switch>
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <vs-checkbox
                
                  v-model=" 
              dependentsInfo.spouse.prevEmploymentOutsideUS.currentEmployer
            "
            @change="
              selectCheck({
                section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                key: 'currentEmployer',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </div>
      </div>
      
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'jobTitle'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Job Title<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.jobTitle">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.jobTitle"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'jobTitle',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'businessType'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label"
              >Employer Business E.g., IT<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.businessType">*</em></label
            >
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})">
                  <vs-checkbox
                
                  v-model="
                dependentsInfo.spouse.prevEmploymentOutsideUS.businessType
              "
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'businessType',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Salary<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.salary">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentOutsideUS.salary
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Pay Frequency<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.payFrequency">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentOutsideUS.payFrequency
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'jobDuties'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label class="form_label"
              >Description of Duties Performed<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.jobDuties">*</em>
              <div class="IB_tooltip H1-140">
                <span
                  ><info-icon
                    size="1.5x"
                    class="custom-class"
                  ></info-icon
                ></span>
                <div class="tooltip_cnt">
                  <p>
                    Please fill in your Job Duties only.Avoid
                    inserting all project details.
                  </p>
                </div>
              </div>
            </label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'jobDuties',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-textarea w-full vs-textarea-primary">
            <textarea class="vs-textarea"></textarea>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'startDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.startDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.startDate"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'startDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'endDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">End Date<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.endDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.endDate"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'endDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <!--   

       -->
      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'address'})">
        <h3 class="small-header">
          Work Address<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.address">*</em>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.address"
            @change="
              selectCheck({
                section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',

                key: 'address',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </h3>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Street Address</label>
              </div>
              <vs-input
                class="w-full"
                v-validate="'required'"
                data-vv-as="Street Address"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Apt, Suite</label>
              </div>
              <div class="address-suite">
                <ul
                  class="demo-alignment custom-radio"
                  vs-type="flex"
                  vs-align="center"
                >
                  <li>
                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                  </li>
                </ul>
                <vs-input class="" data-vv-as="Apt, Suite" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label">Country</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Country"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> State</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select State"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> City</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select City"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label for class="form_label">Zip Code</label>
              </div>
              <vs-input class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
                  </div>
                </vs-col>

                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                
                <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header">Public Charge</h3>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'inadmissibility'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Are you subject to the public charge ground of inadmissibility under INA section 212(a)(4)?<em v-if="dependentsInfo.spouse.inadmissibility">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'inadmissibility'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'inadmissibility'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'inadmissibility'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.inadmissibility"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse',
                                                  key: 'inadmissibility',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'highestDegreeCompleted'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">What is the highest degree or level of school you have completed?<em v-if="dependentsInfo.spouse.highestDegreeCompleted">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'highestDegreeCompleted'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'highestDegreeCompleted'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'highestDegreeCompleted'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.highestDegreeCompleted"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'highestDegreeCompleted',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'listOfCertifications'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">List your certifications, licenses, skills obtained through work experience, and educational certificates.
                                <em v-if="dependentsInfo.spouse.listOfCertifications">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'listOfCertifications'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'listOfCertifications'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'listOfCertifications'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.listOfCertifications"
                                    @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse',
                                          key: 'listOfCertifications',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="vs-con-textarea w-full vs-textarea-primary">
                                <textarea class="vs-textarea" :disabled="true"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'SSI'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> Have you ever received Supplemental Security Income (SSI), Temporary Assistance for Needy Families 
                          (TANF), or State, Tribal, territorial, or local, cash benefit programs for income maintenance (often called 
“General Assistance” in the State context, but which also exist under other names)? <em v-if="dependentsInfo.spouse.SSI">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'SSI'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'SSI'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'SSI'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.SSI"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse',
                                                  key: 'SSI',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>

                          <h3 class="small-header">list the specific benefit(s) you received, the start and end dates of each period of receipt, and the dollar amount of benefits received</h3>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.benefitsRecAmounts',key: 'benefitReceived'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Benefit Received<em v-if="dependentsInfo.spouse.benefitsRecAmounts.benefitReceived">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'benefitReceived'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'benefitReceived'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'benefitReceived'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.benefitsRecAmounts.benefitReceived"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.benefitsRecAmounts',
                                      key: 'benefitReceived',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.benefitsRecAmounts',key: 'startDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Start Date<em v-if="dependentsInfo.spouse.benefitsRecAmounts.startDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'startDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'startDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'startDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.benefitsRecAmounts.startDate"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.benefitsRecAmounts',
                                      key: 'startDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.benefitsRecAmounts',key: 'endDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >End Date<em v-if="dependentsInfo.spouse.benefitsRecAmounts.endDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'endDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'endDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'endDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.benefitsRecAmounts.endDate"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.benefitsRecAmounts',
                                      key: 'endDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.benefitsRecAmounts',key: 'amount'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Amount($)<em v-if="dependentsInfo.spouse.benefitsRecAmounts.amount">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'amount'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'amount'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.benefitsRecAmounts',key:'amount'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.benefitsRecAmounts.amount"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.benefitsRecAmounts',
                                      key: 'amount',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'longTermInstiAtGovtExpense'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Have you ever received long-term institutionalization at government expense?<em v-if="dependentsInfo.spouse.longTermInstiAtGovtExpense">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'longTermInstiAtGovtExpense'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'longTermInstiAtGovtExpense'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'longTermInstiAtGovtExpense'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.longTermInstiAtGovtExpense"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse',
                                                  key: 'longTermInstiAtGovtExpense',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'institutionName'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Institution Name<em v-if="dependentsInfo.spouse.periodOfInstutions.institutionName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'institutionName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'institutionName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'institutionName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.institutionName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'institutionName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'stateDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >State<em v-if="dependentsInfo.spouse.periodOfInstutions.stateDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'stateDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'stateDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'stateDetails'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.stateDetails"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'stateDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'locationDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Location<em v-if="dependentsInfo.spouse.periodOfInstutions.locationDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'locationDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'locationDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'locationDetails'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.locationDetails"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'locationDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'dateFrom'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date From<em v-if="dependentsInfo.spouse.periodOfInstutions.dateFrom">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateFrom'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateFrom'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateFrom'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.dateFrom"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'dateFrom',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'dateTo'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date To<em v-if="dependentsInfo.spouse.periodOfInstutions.dateTo">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateTo'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateTo'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'dateTo'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.dateTo"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'dateTo',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.periodOfInstutions',key: 'reason'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Reason<em v-if="dependentsInfo.spouse.periodOfInstutions.reason">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.periodOfInstutions',key:'reason'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'reason'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.periodOfInstutions',key:'reason'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.periodOfInstutions.reason"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.periodOfInstutions',
                                      key: 'reason',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>



                <vs-col  v-if="checkSpouseDocsLabel({section:'dependentsInfo.spouse.documents'})"
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-0 form-container_QT" v-if="dependentsInfo.spouse.h4Required || dependentsInfo.spouse.hasSpouse || dependentsInfo.spouse.l2Required">
                    <div class="vx-row">
                      <div class="vx-col w-full" v-if="dependentsInfo.spouse.h4Required || dependentsInfo.spouse.hasSpouse || dependentsInfo.spouse.l2Required ">
                        <h3 class="small-header" v-if="checkSpouseDocsLabel({section:'dependentsInfo.spouse.documents'})" >
                            List of documents needs to be updated
                            <span class="file-type">
                              (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                            </span>
                          </h3>
                          <div class="documents_group case_documents">
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'passport'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport- First page with photo, Visa page and last
                                    page with address</label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.passport"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'passport',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'visa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa</label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'visa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'visa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'visa'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.visa"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'visa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI94'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">I94<em v-if="dependentsInfo.spouse.documents.formI94">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI797'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Latest I-797, Notice of Approval of the spouse (if
                                    spouse is on H-1B or L-1 status)<em v-if="dependentsInfo.spouse.documents.formI797">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI797'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI797'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI797'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI797"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI797',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI20'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Spouse’s all Form I-20s (if spouse is on F-1
                                    status)<em v-if="dependentsInfo.spouse.documents.formI20">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI20'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI20'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI20'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI20"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI20',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                 
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'payStubs'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Three Recent Pay Stubs<em v-if="dependentsInfo.spouse.documents.payStubs">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'payStubs'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'payStubs'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'payStubs'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.payStubs"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'payStubs',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                 
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'marriageCertificate'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >{{'marriageCertificate' | formatdoctype}} <em v-if="dependentsInfo.spouse.documents.marriageCertificate">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.spouse.documents.marriageCertificate
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'marriageCertificate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>


                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'slgApprovalNoticeOfPrevH4'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current and Previous H4 Approval Copies<em v-if="dependentsInfo.spouse.documents.slgApprovalNoticeOfPrevH4">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.spouse.documents.slgApprovalNoticeOfPrevH4
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'slgApprovalNoticeOfPrevH4',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'other'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Others<em v-if="dependentsInfo.spouse.documents.other">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'other'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.other"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'other',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </vs-col>  
              </template>
              </form>
            </div>
            <!--child -->
            <div v-if="currentTab=='Dependents Info'">
              <form>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'h4Required'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">H4 required for Child?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'h4Required'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'h4Required'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'h4Required'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.h4Required"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'h4Required',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'hasChildren'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you want to fill children information?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.hasChildren"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'hasChildren',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'l2Required'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">L2 required for Child?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'l2Required'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'l2Required'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'l2Required'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.l2Required"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'l2Required',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                    <template v-if="dependentsInfo.childrens.h4Required || dependentsInfo.childrens.hasChildren || dependentsInfo.childrens.l2Required">
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'adjustmentOfI485Status'})">
                        <h3 class="small-header">Child Information</h3>
                        <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Adjustment of Status (I-485)
                            <p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green Card</p> </vs-checkbox>
                            </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.adjustmentOfI485Status"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'adjustmentOfI485Status',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'consularProcessing'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Consular Processing
                            <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                            abroad to apply for an immigrant visa to get your Green Card</p> </vs-checkbox>
                            </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'consularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'consularProcessing'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'consularProcessing'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.consularProcessing"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'consularProcessing',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentlyInUS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Are you currently in USA? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentlyInUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentlyInUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentlyInUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentlyInUS"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'currentlyInUS',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div> 
                      
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'h4EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">H4 EAD required for Child?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'h4EADRequired'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'h4EADRequired'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'h4EADRequired'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.h4EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'h4EADRequired',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'doYouAlreadyH4EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you already have H4 EAD?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'doYouAlreadyH4EAD'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouAlreadyH4EAD'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouAlreadyH4EAD'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.doYouAlreadyH4EAD"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'doYouAlreadyH4EAD',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'l2EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">L2 EAD required for Child?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'l2EADRequired'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'l2EADRequired'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'l2EADRequired'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.l2EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'l2EADRequired',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'doYouAlreadyL2EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you already have L2 EAD?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'doYouAlreadyL2EAD'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouAlreadyL2EAD'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouAlreadyL2EAD'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.doYouAlreadyL2EAD"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'doYouAlreadyL2EAD',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="dependentsInfo.childrens.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.childrens.gender"
                             @change="
                             selectCheck({ section: 'dependentsInfo.childrens', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                     </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'firstName'})">
                        <div class="vx-col w-full mb-10">
                          <div class="vx-input-group flex form-input-group FML">
                            <div class="vx-input-group-default flex-grow">
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">First Name<em v-if="dependentsInfo.childrens.firstName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'firstName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                    
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Middle Name<em v-if="dependentsInfo.childrens.middleName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'middleName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                    
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Last Name<em v-if="dependentsInfo.childrens.lastName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.lastName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'lastName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                   
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full md:w-1/2 mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="dependentsInfo.childrens.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'email'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})">
                              
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.email"
                              @change="
                                selectCheck({ section: 'dependentsInfo.childrens', key: 'email' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.childrens.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.phoneNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'phoneNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'hasOtherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'hasOtherNames'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'hasOtherNames'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'hasOtherNames'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.hasOtherNames"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'hasOtherNames',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'relationship'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Your Relationship with the dependent<em v-if="dependentsInfo.childrens.relationship">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'relationship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'relationship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'relationship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.relationship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'relationship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <selectField
                            wrapclass=""
                            placeholder="Your Relationship with the dependent"
                          />
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="dependentsInfo.childrens.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.childrens.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'dateOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.childrens.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.countryOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'countryOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      
                      
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="dependentsInfo.childrens.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'provinceOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="dependentsInfo.childrens.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.locationOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'locationOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Citizenship<em v-if="dependentsInfo.childrens.countryOfCitizenship">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'countryOfCitizenship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'maritalStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Marital Status<em v-if="dependentsInfo.childrens.maritalStatus">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'maritalStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'maritalStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'maritalStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.maritalStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'maritalStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'applyingWithYou'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Applying with you? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.applyingWithYou"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'applyingWithYou',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div>
                      <!-- <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'applyingWithYou'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Applying with you? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.applyingWithYou"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'applyingWithYou',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div> -->
                      
                      <!-- <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'I94ExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isI94DSExpiryDate'})">
                       <div class="d-flex align-center">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="dependentsInfo.childrens.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                          
                        </div>
                      </div> -->
                     
                     
                      
                      
                      <div class="vx-col w-full" v-if="checkPassportLabel({section:'dependentsInfo.childrens'})">
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Number<em v-if="dependentsInfo.childrens.passportNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'passportNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.childrens.passportIssuedDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportIssuedDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'passportIssuedDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportExpiryDate'})" >
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.childrens.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'passportExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedCountry'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Passport Issued<em v-if="dependentsInfo.childrens.passportIssuedCountry">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.passportIssuedCountry"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'passportIssuedCountry',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                     
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status<em v-if="dependentsInfo.childrens.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'currentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="vx-col w-full md:w-1/2 mart20" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'statusExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.childrens.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'statusExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isDSExpiryDate'})">
                       <div class="d-flex align-center">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox>If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.childrens.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'I94'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Number<em v-if="dependentsInfo.childrens.I94">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'I94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'I94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'I94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.I94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'I94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'I94ExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isI94DSExpiryDate'})">
                       <div class="d-flex align-center">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox>If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="dependentsInfo.childrens.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'sevisNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">SEVIS Number<em v-if="dependentsInfo.childrens.sevisNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'sevisNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'sevisNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'sevisNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.sevisNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'sevisNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'eadNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EAD Number<em v-if="dependentsInfo.childrens.eadNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'eadNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'eadNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'eadNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.eadNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'eadNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'doYouHaveSSN'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Do you have SSN?<em v-if="dependentsInfo.childrens.doYouHaveSSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'doYouHaveSSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouHaveSSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouHaveSSN'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.doYouHaveSSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'doYouHaveSSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'SSN'})">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full mb-5">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security number (if applicable)<em v-if="dependentsInfo.childrens.SSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'SSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.SSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'SSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'alienNumber'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Your Alien Number (if applicable)<em v-if="dependentsInfo.childrens.alienNumber">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'alienNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'alienNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'alienNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.alienNumber"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'alienNumber',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'doYouWantTheSsaToIssueYouSS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Do you want the SSA to issue you a Social Security card?<em v-if="dependentsInfo.childrens.doYouWantTheSsaToIssueYouSS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'doYouWantTheSsaToIssueYouSS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouWantTheSsaToIssueYouSS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'doYouWantTheSsaToIssueYouSS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.doYouWantTheSsaToIssueYouSS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'doYouWantTheSsaToIssueYouSS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address<em v-if="dependentsInfo.childrens.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentAddress"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'currentAddress',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'physicalAddress'})">
                        <h3 class="small-header">
                          Mailing Address<em v-if="dependentsInfo.childrens.physicalAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'physicalAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'physicalAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'physicalAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.physicalAddress"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'physicalAddress',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S<em v-if="dependentsInfo.childrens.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.addressOutsideUS"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',
                                        key: 'addressOutsideUS',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                      
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnFather',key: 'familyName'})|| showOrHideField({section: 'dependentsInfo.childrens.ssnFather',key: 'givenName'})">
                        <div class="vx-col w-full">
                          <div class="form_group w-full">
                            <label class="form_label">
                              <h3 class="small-header" style="margin-bottom: 10px !important;padding-bottom: 0px !important;">Father Name</h3>
                            </label>
                          </div>
                        </div>
                      </template>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnFather',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="dependentsInfo.childrens.ssnFather.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.ssnFather',key:'familyName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.ssnFather',key:'familyName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.ssnFather',key:'familyName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.ssnFather.familyName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens.ssnFather',

                                  key: 'familyName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnFather',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"> Given Name<em v-if="dependentsInfo.childrens.ssnFather.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.ssnFather',key:'givenName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.ssnFather',key:'givenName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.ssnFather',key:'givenName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.ssnFather.givenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens.ssnFather',

                                  key: 'givenName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <template  v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnMother',key: 'familyName'}) || showOrHideField({section: 'dependentsInfo.childrens.ssnMother',key: 'givenName'}) ">
                        <div class="vx-col w-full">
                          <div class="form_group w-full">
                            <label class="form_label">
                              <h3 class="small-header" style="margin-bottom: 10px !important;padding-bottom: 0px !important;">Mother Name</h3>
                            </label>
                          </div>
                        </div>
                      </template>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnMother',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="dependentsInfo.childrens.ssnMother.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.ssnMother',key:'familyName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.ssnMother',key:'familyName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.ssnMother',key:'familyName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.ssnMother.familyName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens.ssnMother',

                                  key: 'familyName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.ssnMother',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Given Name<em v-if="dependentsInfo.childrens.ssnMother.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.ssnMother',key:'givenName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.ssnMother',key:'givenName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.ssnMother',key:'givenName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.ssnMother.givenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens.ssnMother',

                                  key: 'givenName',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'haveYouEverTravelledToUS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever travelled to the United States?<em v-if="dependentsInfo.childrens.haveYouEverTravelledToUS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})">
                              <vs-checkbox
                              
                              v-model="dependentsInfo.childrens.haveYouEverTravelledToUS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'haveYouEverTravelledToUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'stateOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              > State of recent entry into the USA<em v-if="dependentsInfo.childrens.stateOfLastEntryInUS">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.stateOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'stateOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'placeOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Place of recent entry into the USA<em v-if="dependentsInfo.childrens.placeOfLastEntryInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.placeOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'placeOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'lastArrivalDate'})" >
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of most recent entry into the USA<em v-if="dependentsInfo.childrens.lastArrivalDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'lastArrivalDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'lastArrivalDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'lastArrivalDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.lastArrivalDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'lastArrivalDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'immigStatusLastArrival'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Immigration Status at Your Last Arrival<em v-if="dependentsInfo.childrens.immigStatusLastArrival">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'immigStatusLastArrival'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'immigStatusLastArrival'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'immigStatusLastArrival'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.immigStatusLastArrival"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'immigStatusLastArrival',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-5 mb-5">
                              <div class="d-flex">
                              <h3 class="small-header">Dates of Stay in USA<em v-if="dependentsInfo.childrens.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.priorPeriodOfStayInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.childrens',
                                    key: 'priorPeriodOfStayInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                          </div>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa Status</label>
                                </div>
                                <selectField wrapclass="" placeholder="Visa Status" />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="mx-input-wrapper">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete">
                              <a>
                                <img src="@/assets/images/main/delete-row-img.svg">
                              </a>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                      <div class="vx-col w-full mb-0" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you been employed in the United States since last admitted or granted an extension or change of status?<em v-if="dependentsInfo.childrens.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <vs-col v-if="checkEmploymentLabel({section:'dependentsInfo.childrens.prevEmploymentInfo'})"
                        class="m-auto float-none"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-lg="12"
                        vs-sm="12"
                      >
                        <div class="form-container pt-5">
                                  <h3 class="small-header">Employment 
                                    
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                                  <vs-checkbox
                                
                                  v-model="
                                dependentsInfo.childrens.prevEmploymentInfo.prevEmploymentInfo
                              "
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                  key: 'prevEmploymentInfo',
                                })
                              "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                  </h3>
                          <div class="vx-row">

                            <div class="vx-col w-full">
                              <div class="form-container alt-rows-bg questionnaire_hb">
                                <div class="vx-row">
                                  <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'employerName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label">Employer Name<em v-if="dependentsInfo.childrens.prevEmploymentInfo.employerName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})">
                                              <vs-checkbox
                                            
                                              v-model="
                                            dependentsInfo.childrens.prevEmploymentInfo.employerName
                                          "
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'employerName',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-input">
                                        <input
                                          type="text"
                                          class="vs-inputx vs-input--input normal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'currentEmployer'})">
                                    <div class="d-flex align-center">
                                      <a class="switch-label mr-3"> Current Employer? </a>
                                      <vs-switch>
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                      </vs-switch>
                                      <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})">
                                              <vs-checkbox
                                            
                                              v-model=" 
                                          dependentsInfo.childrens.prevEmploymentInfo.currentEmployer
                                        "
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                            key: 'currentEmployer',
                                          })
                                        "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                      
                                    </div>
                                  </div>
                            
                                  <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'jobTitle'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label">Job Title<em v-if="dependentsInfo.childrens.prevEmploymentInfo.jobTitle">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})">
                                              <vs-checkbox
                                            
                                              v-model="dependentsInfo.childrens.prevEmploymentInfo.jobTitle"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'jobTitle',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-input">
                                        <input
                                          type="text"
                                          class="vs-inputx vs-input--input normal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'businessType'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label"
                                          >Employer Business E.g., IT<em v-if="dependentsInfo.childrens.prevEmploymentInfo.businessType">*</em></label
                                        >
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})">
                                              <vs-checkbox
                                            
                                              v-model="
                                            dependentsInfo.childrens.prevEmploymentInfo.businessType
                                          "
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'businessType',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-input">
                                        <input
                                          type="text"
                                          class="vs-inputx vs-input--input normal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'salary'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label"
                                          >Salary<em v-if="dependentsInfo.childrens.prevEmploymentInfo.salary">*</em></label
                                        >
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})">
                                              <vs-checkbox
                                            
                                              v-model="
                                            dependentsInfo.childrens.prevEmploymentInfo.salary
                                          "
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'salary',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-input">
                                        <input
                                          type="text"
                                          class="vs-inputx vs-input--input normal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'payFrequency'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label"
                                          >Pay Frequency<em v-if="dependentsInfo.childrens.prevEmploymentInfo.payFrequency">*</em></label
                                        >
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})">
                                              <vs-checkbox
                                            
                                              v-model="
                                            dependentsInfo.childrens.prevEmploymentInfo.payFrequency
                                          "
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'payFrequency',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-input">
                                        <input
                                          type="text"
                                          class="vs-inputx vs-input--input normal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'jobDuties'})"> 
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"
                                          >Description of Duties Performed<em v-if="dependentsInfo.childrens.prevEmploymentInfo.jobDuties">*</em>
                                          <div class="IB_tooltip H1-140">
                                            <span
                                              ><info-icon
                                                size="1.5x"
                                                class="custom-class"
                                              ></info-icon
                                            ></span>
                                            <div class="tooltip_cnt">
                                              <p>
                                                Please fill in your Job Duties only.Avoid
                                                inserting all project details.
                                              </p>
                                            </div>
                                          </div>
                                        </label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})">
                                              <vs-checkbox
                                            
                                              v-model="dependentsInfo.childrens.prevEmploymentInfo.jobDuties"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'jobDuties',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div class="vs-con-textarea w-full vs-textarea-primary">
                                        <textarea class="vs-textarea"></textarea>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'startDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Start Date<em v-if="dependentsInfo.childrens.prevEmploymentInfo.startDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})">
                                              <vs-checkbox
                                            
                                              v-model="dependentsInfo.childrens.prevEmploymentInfo.startDate"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'startDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'endDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">End Date<em v-if="dependentsInfo.childrens.prevEmploymentInfo.endDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})">
                                              <vs-checkbox
                                            
                                              v-model="dependentsInfo.childrens.prevEmploymentInfo.endDate"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                              key: 'endDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'address'})">
                                    <h3 class="small-header">
                                      Work Address<em v-if="dependentsInfo.spouse.prevEmploymentInfo.address">*</em>
                                      <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})">
                                              <vs-checkbox
                                            
                                              v-model="dependentsInfo.childrens.prevEmploymentInfo.address"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.childrens.prevEmploymentInfo',

                                            key: 'address',
                                          })
                                        "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                      
                                    </h3>
                                    <div class="vx-row">
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Street Address</label>
                                          </div>
                                          <vs-input
                                            class="w-full"
                                            v-validate="'required'"
                                            data-vv-as="Street Address"
                                          />
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Apt, Suite</label>
                                          </div>
                                          <div class="address-suite">
                                            <ul
                                              class="demo-alignment custom-radio"
                                              vs-type="flex"
                                              vs-align="center"
                                            >
                                              <li>
                                                <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                              </li>
                                            </ul>
                                            <vs-input class="" data-vv-as="Apt, Suite" />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Country</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select Country"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> State</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select State"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> City</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select City"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label for class="form_label">Zip Code</label>
                                          </div>
                                          <vs-input class="w-full" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </vs-col>
                    </template>
                  </div>
                  </div>
                </vs-col>
                <vs-col v-if="(dependentsInfo.childrens.h4Required || dependentsInfo.childrens.hasChildren || dependentsInfo.childrens.l2Required)"
                class="m-auto float-none"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                >

                  <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header">Public Charge</h3>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'inadmissibility'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Are you subject to the public charge ground of inadmissibility under INA section 212(a)(4)?<em v-if="dependentsInfo.childrens.inadmissibility">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'inadmissibility'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'inadmissibility'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'inadmissibility'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.childrens.inadmissibility"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.childrens',
                                                  key: 'inadmissibility',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'highestDegreeCompleted'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">What is the highest degree or level of school you have completed?<em v-if="dependentsInfo.childrens.highestDegreeCompleted">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'highestDegreeCompleted'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'highestDegreeCompleted'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'highestDegreeCompleted'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.highestDegreeCompleted"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'highestDegreeCompleted',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'listOfCertifications'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">List your certifications, licenses, skills obtained through work experience, and educational certificates.
                                <em v-if="dependentsInfo.childrens.listOfCertifications">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'listOfCertifications'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'listOfCertifications'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'listOfCertifications'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.listOfCertifications"
                                    @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',
                                          key: 'listOfCertifications',
                                        })
                                      "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="vs-con-textarea w-full vs-textarea-primary">
                                <textarea class="vs-textarea" :disabled="true"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'SSI'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> Have you ever received Supplemental Security Income (SSI), Temporary Assistance for Needy Families 
                          (TANF), or State, Tribal, territorial, or local, cash benefit programs for income maintenance (often called 
“General Assistance” in the State context, but which also exist under other names)? <em v-if="dependentsInfo.childrens.SSI">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'SSI'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'SSI'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'SSI'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.childrens.SSI"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.childrens',
                                                  key: 'SSI',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>

                          <h3 class="small-header">list the specific benefit(s) you received, the start and end dates of each period of receipt, and the dollar amount of benefits received</h3>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.benefitsRecAmounts',key: 'benefitReceived'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Benefit Received<em v-if="dependentsInfo.childrens.benefitsRecAmounts.benefitReceived">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'benefitReceived'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'benefitReceived'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'benefitReceived'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.benefitsRecAmounts.benefitReceived"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.benefitsRecAmounts',
                                      key: 'benefitReceived',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.benefitsRecAmounts',key: 'startDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Start Date<em v-if="dependentsInfo.childrens.benefitsRecAmounts.startDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'startDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'startDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'startDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.benefitsRecAmounts.startDate"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.benefitsRecAmounts',
                                      key: 'startDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.benefitsRecAmounts',key: 'endDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >End Date<em v-if="dependentsInfo.childrens.benefitsRecAmounts.endDate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'endDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'endDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'endDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.benefitsRecAmounts.endDate"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.benefitsRecAmounts',
                                      key: 'endDate',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.benefitsRecAmounts',key: 'amount'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Amount($)<em v-if="dependentsInfo.childrens.benefitsRecAmounts.amount">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'amount'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'amount'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.benefitsRecAmounts',key:'amount'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.benefitsRecAmounts.amount"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.benefitsRecAmounts',
                                      key: 'amount',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'longTermInstiAtGovtExpense'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Have you ever received long-term institutionalization at government expense?<em v-if="dependentsInfo.childrens.longTermInstiAtGovtExpense">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'longTermInstiAtGovtExpense'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'longTermInstiAtGovtExpense'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'longTermInstiAtGovtExpense'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.childrens.longTermInstiAtGovtExpense"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.childrens',
                                                  key: 'longTermInstiAtGovtExpense',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'institutionName'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Institution Name<em v-if="dependentsInfo.childrens.periodOfInstutions.institutionName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'institutionName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'institutionName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'institutionName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.institutionName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'institutionName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'stateDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >State<em v-if="dependentsInfo.childrens.periodOfInstutions.stateDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'stateDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'stateDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'stateDetails'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.stateDetails"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'stateDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'locationDetails'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Location<em v-if="dependentsInfo.childrens.periodOfInstutions.locationDetails">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'locationDetails'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'locationDetails'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'locationDetails'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.locationDetails"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'locationDetails',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select" :disabled="true">
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'dateFrom'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date From<em v-if="dependentsInfo.childrens.periodOfInstutions.dateFrom">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateFrom'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateFrom'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateFrom'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.dateFrom"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'dateFrom',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'dateTo'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Date To<em v-if="dependentsInfo.childrens.periodOfInstutions.dateTo">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateTo'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateTo'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'dateTo'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.dateTo"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'dateTo',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens.periodOfInstutions',key: 'reason'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Reason<em v-if="dependentsInfo.childrens.periodOfInstutions.reason">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens.periodOfInstutions',key:'reason'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'reason'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.periodOfInstutions',key:'reason'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.periodOfInstutions.reason"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.periodOfInstutions',
                                      key: 'reason',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </vs-col>
                <vs-col   v-if="(dependentsInfo.childrens.h4Required || dependentsInfo.childrens.hasChildren || dependentsInfo.childrens.l2Required) && checkChildDocsLabel({section:'dependentsInfo.childrens.documents'})"
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-0 form-container_QT"  v-if="(dependentsInfo.childrens.h4Required || dependentsInfo.childrens.hasChildren|| dependentsInfo.childrens.l2Required) && checkChildDocsLabel({section:'dependentsInfo.childrens.documents'})">
                    <div class="vx-row">
                      <div class="vx-col w-full" >
                        <h3 class="small-header">
                            List of documents needs to be updated
                            <span class="file-type">
                              (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                            </span>
                          </h3>
                          <div class="documents_group case_documents">
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'passport'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport- First page with photo, Visa page and last
                                    page with address<em v-if="dependentsInfo.childrens.documents.passport">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'passport'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'passport'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'passport'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.passport"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'passport',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'visa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa<em v-if="dependentsInfo.childrens.documents.visa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'visa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'visa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'visa'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.visa"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'visa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'formI94'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">I94<em v-if="dependentsInfo.childrens.documents.formI94">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'formI94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'formI94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'formI94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.formI94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'formI94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'approvalNotice'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Approval Notice<em v-if="dependentsInfo.childrens.documents.approvalNotice">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.approvalNotice
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'approvalNotice',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'birthCertificate'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Birth Certificate<em v-if="dependentsInfo.childrens.documents.birthCertificate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.birthCertificate
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'birthCertificate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'slgApprovalNoticeOfPrevH4'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current and Previous H4 Approval Copies<em v-if="dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevH4">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevH4"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'slgApprovalNoticeOfPrevH4',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'other'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Others<em v-if="dependentsInfo.childrens.documents.other">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'other'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'other'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'other'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.other"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'other',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </vs-col> 
              </form>
            </div>
            <div v-if="currentTab=='Sponsor Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT"> 
                    <div class="vx-row">

                      <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'sponsorInfo',key: 'gender'})">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Gender<em v-if="sponsorInfo.gender">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'gender'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'gender'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'gender'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.gender"
                              @change="
                              selectCheck({ section: 'sponsorInfo', key: 'gender' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        <vx-input-group class="form-input-group FML">
                          <vs-button
                            class="btn male-btn"
                            icon-pack="IntakePortal"
                            icon=" IP-femenine-1"
                            type="border"
                            :disabled="true"
                            >Male</vs-button
                          >
                          <vs-button
                            class="btn female-btn"
                            icon-pack="IntakePortal"
                            icon=" IP-femenine-1"
                            type="border"
                            :disabled="true"
                            >Female</vs-button
                          >
                          <vs-button
                            class="btn others-btn"
                            icon-pack="feather"
                            icon="icon-circle"
                            type="border"
                            :disabled="true"
                            >Others</vs-button
                          >
                        </vx-input-group>
                      </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'firstName'})">
                        <div class="vx-input-group flex form-input-group FML">
                          <div class="vx-input-group-default flex-grow">
                            <div class="vx-col w-full md:w-1/2">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">First Name<em v-if="sponsorInfo.firstName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'firstName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'firstName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'firstName'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.firstName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'firstName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>

                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal" :disabled="true"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'middleName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Middle Name<em v-if="sponsorInfo.middleName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'middleName'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.middleName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal" :disabled="true"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'lastName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Last Name<em v-if="sponsorInfo.lastName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'lastName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'lastName'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'lastName'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.lastName"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo',
                                        key: 'lastName',
                                      })
                                    "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal" :disabled="true"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'otherNames'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.otherNames"
                            @change="
                              selectCheck({
                                section: 'sponsorInfo',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'birthCertHaveNamePobDob'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'birthCertHaveNamePobDob'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'birthCertHaveNamePobDob'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'birthCertHaveNamePobDob'})">
                              <vs-checkbox
                              
                                v-model="sponsorInfo.birthCertHaveNamePobDob"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'birthCertHaveNamePobDob',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> 
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'have2AffidavitsOfBirthFamily'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Do you have two (2) affidavits of birth from family members?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'have2AffidavitsOfBirthFamily'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'have2AffidavitsOfBirthFamily'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'have2AffidavitsOfBirthFamily'})">
                              <vs-checkbox
                              
                                v-model="sponsorInfo.have2AffidavitsOfBirthFamily"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'have2AffidavitsOfBirthFamily',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'nameDiffFromBirthCert'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> if your name is different from that stated on your birth certificate, have you had it legally changes? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'nameDiffFromBirthCert'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'nameDiffFromBirthCert'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'nameDiffFromBirthCert'})">
                              <vs-checkbox
                              
                                v-model="sponsorInfo.nameDiffFromBirthCert"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'nameDiffFromBirthCert',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="sponsorInfo.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'email'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'email'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'email'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.email"
                              @change="
                                selectCheck({ section: 'sponsorInfo', key: 'email' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal" :disabled="true"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'sponsorInfo',key: 'cellPhoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="sponsorInfo.cellPhoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'cellPhoneNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'cellPhoneNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'cellPhoneNumber'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.cellPhoneNumber"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'cellPhoneNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                              :disabled="true"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'sponsorInfo',key: 'alienNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Your Alien Number (if applicable)<em v-if="sponsorInfo.alienNumber">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'alienNumber'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'alienNumber'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'alienNumber'})">
                          <vs-checkbox
                        
                          v-model="sponsorInfo.alienNumber"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'alienNumber',
                                })
                              "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              name="0"
                              placeholder="123 - 45 - 6789"
                              data-vv-as="123 - 45 - 6789"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'sponsorInfo',key: 'SSN'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Social Security number<em v-if="sponsorInfo.SSN">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'SSN'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'SSN'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'SSN'})">
                          <vs-checkbox
                        
                          v-model="sponsorInfo.SSN"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'SSN',
                                })
                              "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              name="0"
                              placeholder="123 - 45 - 6789"
                              data-vv-as="123 - 45 - 6789"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="sponsorInfo.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateOfBirth'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'dateOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="sponsorInfo.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'countryOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="sponsorInfo.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'provinceOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="sponsorInfo.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'locationOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.locationOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'locationOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'maritalStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Marital Status<em v-if="sponsorInfo.maritalStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'maritalStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'maritalStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'maritalStatus'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.maritalStatus"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'maritalStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateOfMarriage'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Date of Marriage<em v-if="sponsorInfo.dateOfMarriage">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateOfMarriage'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateOfMarriage'})}"  >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateOfMarriage'})">
                                <vs-checkbox
                              
                                v-model="sponsorInfo.dateOfMarriage"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'dateOfMarriage',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                  :disabled="true"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'countryOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Marriage<em v-if="sponsorInfo.countryOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'countryOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'countryOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'countryOfMarriage'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.countryOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'countryOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'provinceOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Marriage<em v-if="sponsorInfo.provinceOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'provinceOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'provinceOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'provinceOfMarriage'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.provinceOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'provinceOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'locationOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Marriage<em v-if="sponsorInfo.locationOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'locationOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'locationOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'locationOfMarriage'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.locationOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'locationOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'countryOfCitizenship'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Country of Citizenship<em v-if="sponsorInfo.countryOfCitizenship">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'countryOfCitizenship'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'countryOfCitizenship'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'countryOfCitizenship'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.countryOfCitizenship"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'countryOfCitizenship',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="sponsorInfo.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'currentAddress'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'sponsorInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo',key: 'address'})">
                        <h3 class="small-header">
                          Mailing Address <em v-if="sponsorInfo.address">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'address'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'address'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'address'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.address"
                            @change="
                              selectCheck({ section: 'sponsorInfo', key: 'address' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'filingThisPetitionerFor'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I’M filing this petition for<em v-if="sponsorInfo.filingThisPetitionerFor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'filingThisPetitionerFor'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'filingThisPetitionerFor'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'filingThisPetitionerFor'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.filingThisPetitionerFor"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'filingThisPetitionerFor',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'fillThisPetiChildOrParentRelation'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Select the box that describes your relationship with beneficiary<em v-if="sponsorInfo.haveUSCitizenOrPermResident">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'fillThisPetiChildOrParentRelation'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'fillThisPetiChildOrParentRelation'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'fillThisPetiChildOrParentRelation'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.fillThisPetiChildOrParentRelation"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'fillThisPetiChildOrParentRelation',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns form_radio_btns_v2">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Child was born to parents who were married to each other at the time of the child's birth </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Stepchild/Stepparent </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Child was born to parents who were not married to each other at the time of the child's birth </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Child was adopted (not an Orphan or Hague Convention adoptee)</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'fillThisBroOrSisRelatedByAdoption'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Are you related to your brother/sister by adoption? <em v-if="sponsorInfo.fillThisBroOrSisRelatedByAdoption">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'fillThisBroOrSisRelatedByAdoption'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'fillThisBroOrSisRelatedByAdoption'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'fillThisBroOrSisRelatedByAdoption'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.fillThisBroOrSisRelatedByAdoption"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'fillThisBroOrSisRelatedByAdoption',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                 Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'haveUSCitizenOrPermResident'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >I am filing this petition as<em v-if="sponsorInfo.haveUSCitizenOrPermResident">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'haveUSCitizenOrPermResident'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'haveUSCitizenOrPermResident'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'haveUSCitizenOrPermResident'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.haveUSCitizenOrPermResident"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'haveUSCitizenOrPermResident',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  US Citizen</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Lawful Permanent Resident</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'sponsorInfo',key: 'usCitizen'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> If you are a U.S. Citizen? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'usCitizen'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'usCitizen'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'usCitizen'})">
                              <vs-checkbox
                            
                                v-model="sponsorInfo.usCitizen"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'usCitizen',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- key pending dateReceivedLPR address  -->
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'citizenshipAcquiredThrough'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Citizenship was acquired through<em v-if="sponsorInfo.citizenshipAcquiredThrough">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'citizenshipAcquiredThrough'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'citizenshipAcquiredThrough'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'citizenshipAcquiredThrough'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.citizenshipAcquiredThrough"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'citizenshipAcquiredThrough',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Birth</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Naturalization</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Parents</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'certOfCitizenNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Certificate of Citizenship Number<em v-if="sponsorInfo.certOfCitizenNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'certOfCitizenNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'certOfCitizenNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'certOfCitizenNumber'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.certOfCitizenNumber"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'certOfCitizenNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'placeOfIssuance'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Place of Issuance<em v-if="sponsorInfo.placeOfIssuance">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'placeOfIssuance'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'placeOfIssuance'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'placeOfIssuance'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.placeOfIssuance"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'placeOfIssuance',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateOfIssuance'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Issuance<em v-if="sponsorInfo.dateOfIssuance">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateOfIssuance'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateOfIssuance'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateOfIssuance'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dateOfIssuance"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'dateOfIssuance',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'sponsorInfo',key: 'lawfulPerResident'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> If you are a Lawful Permanent Resident  </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'lawfulPerResident'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'lawfulPerResident'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'lawfulPerResident'})">
                              <vs-checkbox
                            
                                v-model="sponsorInfo.lawfulPerResident"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo',
                                    key: 'lawfulPerResident',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'gainLawPermResidentThroughAdoption'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Did you gain lawful permanent resident status or citizenship through adoption? <em v-if="sponsorInfo.gainLawPermResidentThroughAdoption">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'gainLawPermResidentThroughAdoption'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'gainLawPermResidentThroughAdoption'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'gainLawPermResidentThroughAdoption'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.gainLawPermResidentThroughAdoption"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'gainLawPermResidentThroughAdoption',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                 Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.lawFulPermanentResident',key: 'classOfAdmission'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Class of Admission <em v-if="sponsorInfo.lawFulPermanentResident.classOfAdmission">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.lawFulPermanentResident',key:'classOfAdmission'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.lawFulPermanentResident',key:'classOfAdmission'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.lawFulPermanentResident',key:'classOfAdmission'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.lawFulPermanentResident.classOfAdmission"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.lawFulPermanentResident',
                                  key: 'classOfAdmission',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.lawFulPermanentResident',key: 'dateOfAdmission'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Admission <em v-if="sponsorInfo.lawFulPermanentResident.dateOfAdmission">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.lawFulPermanentResident',key:'dateOfAdmission'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.lawFulPermanentResident',key:'dateOfAdmission'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.lawFulPermanentResident',key:'dateOfAdmission'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.lawFulPermanentResident.dateOfAdmission"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.lawFulPermanentResident',
                                  key: 'dateOfAdmission',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'stateOfAdmission'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">State of Admission<em v-if="sponsorInfo.stateOfAdmission">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'stateOfAdmission'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'stateOfAdmission'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'stateOfAdmission'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.stateOfAdmission"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'stateOfAdmission',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'cityOfAdmission'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">City or Town of Admission<em v-if="sponsorInfo.cityOfAdmission">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'cityOfAdmission'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'cityOfAdmission'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'cityOfAdmission'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.cityOfAdmission"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'cityOfAdmission',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                  
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'sponsorInfo',key: 'lprRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">LPR was acquired through<em v-if="sponsorInfo.lprRequired">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'lprRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'lprRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'lprRequired'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.lprRequired"
                                @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'lprRequired',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateReceivedLPR'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date received LPR<em v-if="sponsorInfo.dateReceivedLPR">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateReceivedLPR'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateReceivedLPR'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateReceivedLPR'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dateReceivedLPR"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'dateReceivedLPR',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'usCitizenOrLPR'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Did you gain LPR through marriage to a U.S. citizen or a LPR? <em v-if="sponsorInfo.usCitizenOrLPR">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'usCitizenOrLPR'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'usCitizenOrLPR'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'usCitizenOrLPR'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.usCitizenOrLPR"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'usCitizenOrLPR',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                   
                     
                     
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.height',key: 'feet'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Feet<em v-if="sponsorInfo.height.feet">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.height',key:'feet'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.height',key:'feet'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.height',key:'feet'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.height.feet"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.height',
                                 key: 'feet',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.height',key: 'inches'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Inches<em v-if="sponsorInfo.height.inches">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.height',key:'inches'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.height',key:'inches'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.height',key:'inches'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.height.inches"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.height',
                                 key: 'inches',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'weight'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Weight<em v-if="sponsorInfo.weight">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'weight'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'weight'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'weight'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.weight"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'weight',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'race'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Ethnicity/Race<em v-if="sponsorInfo.race">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'race'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'race'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'race'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.race"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'race',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'eyeColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">EYE COLOR<em v-if="sponsorInfo.eyeColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'eyeColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'eyeColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'eyeColor'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.eyeColor"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'eyeColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'hairColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">HAIR COLOR<em v-if="sponsorInfo.hairColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'hairColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'hairColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'hairColor'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.hairColor"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'hairColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section: 'sponsorInfo',key: 'nationality'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Citizenship/Nationality<em v-if="sponsorInfo.nationality">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'nationality'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'nationality'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'nationality'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.nationality"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'nationality',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateFromUSCitizen'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"> Date from which you have resided in the USA<em v-if="sponsorInfo.dateFromUSCitizen">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateFromUSCitizen'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateFromUSCitizen'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateFromUSCitizen'})">
                                <vs-checkbox
                              
                                v-model="sponsorInfo.dateFromUSCitizen"
                            @change="
                              selectCheck({
                                section: 'sponsorInfo',
                                key: 'dateFromUSCitizen',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div> 
                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'filedOnAnyOtherPerOrPetitioner'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever filed a petition for this beneficiary or any other person <em v-if="sponsorInfo.filedOnAnyOtherPerOrPetitioner">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'filedOnAnyOtherPerOrPetitioner'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'filedOnAnyOtherPerOrPetitioner'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'filedOnAnyOtherPerOrPetitioner'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.filedOnAnyOtherPerOrPetitioner"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'filedOnAnyOtherPerOrPetitioner',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'filedName'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Name<em v-if="sponsorInfo.filedName">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'filedName'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'filedName'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'filedName'})">
                            <vs-checkbox
                          
                            v-model="sponsorInfo.filedName"
                            @change="
                              selectCheck({
                                section: 'sponsorInfo',
                                key: 'filedName',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'filedPlace'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Place<em v-if="sponsorInfo.filedPlace">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'filedPlace'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'filedPlace'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'filedPlace'})">
                            <vs-checkbox
                          
                            v-model="sponsorInfo.filedPlace"
                            @change="
                              selectCheck({
                                section: 'sponsorInfo',
                                key: 'filedPlace',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'fileDateOfFiling'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Filing<em v-if="sponsorInfo.fileDateOfFiling">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'fileDateOfFiling'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'fileDateOfFiling'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'fileDateOfFiling'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.fileDateOfFiling"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'fileDateOfFiling',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'filedStatus'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Filled status<em v-if="sponsorInfo.filedStatus">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'filedStatus'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'filedStatus'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'filedStatus'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.filedStatus"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo',
                                 key: 'filedStatus',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'anyOtherElseFiledPetitionForBnf'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Has anyone else ever filed a petition for the beneficiary? <em v-if="sponsorInfo.anyOtherElseFiledPetitionForBnf">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'anyOtherElseFiledPetitionForBnf'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'anyOtherElseFiledPetitionForBnf'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'anyOtherElseFiledPetitionForBnf'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.anyOtherElseFiledPetitionForBnf"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'anyOtherElseFiledPetitionForBnf',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Unknown</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'benfEverInImmigrationProceedings'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Was the beneficiary EVER in immigration proceedings?<em v-if="sponsorInfo.benfEverInImmigrationProceedings">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'benfEverInImmigrationProceedings'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'benfEverInImmigrationProceedings'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'benfEverInImmigrationProceedings'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.benfEverInImmigrationProceedings"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'benfEverInImmigrationProceedings',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'typeOfProceedings'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Select the type of proceedings and provide the location and date of the proceedings. <em v-if="sponsorInfo.haveUSCitizenOrPermResident">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'typeOfProceedings'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'typeOfProceedings'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'typeOfProceedings'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.typeOfProceedings"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'typeOfProceedings',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Removal  </vs-button
                                >
                                <vs-button class="no mr-5" color="danger" type="border"
                                  >Exclusion/Deportation  </vs-button
                                >
                                <vs-button class="no mr-5" color="danger" type="border"
                                  >Rescission</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >Other Judicial Proceedings</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'dateOfProceedings'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of proceedings<em v-if="sponsorInfo.dateOfProceedings">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'dateOfProceedings'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'dateOfProceedings'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'dateOfProceedings'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dateOfProceedings"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'dateOfProceedings',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'stateOfProceedings'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">State of proceedings<em v-if="sponsorInfo.stateOfProceedings">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo',key:'stateOfProceedings'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'stateOfProceedings'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'stateOfProceedings'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.stateOfProceedings"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'stateOfProceedings',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo',key: 'cityOfProceedings'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">City or Town of proceedings<em v-if="sponsorInfo.cityOfProceedings">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'cityOfProceedings'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'cityOfProceedings'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'cityOfProceedings'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.cityOfProceedings"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo',
                                  key: 'cityOfProceedings',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>




                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'hasSubmitSepPetiForOtherRelation'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Are you are also submitting separate petitions for other relatives? <em v-if="sponsorInfo.hasSubmitSepPetiForOtherRelation">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'hasSubmitSepPetiForOtherRelation'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'hasSubmitSepPetiForOtherRelation'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'hasSubmitSepPetiForOtherRelation'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.hasSubmitSepPetiForOtherRelation"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'hasSubmitSepPetiForOtherRelation',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes  </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No  </vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.submitSupPetiForOtherRelative',key: 'relative'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Relative <em v-if="sponsorInfo.submitSupPetiForOtherRelative.relative">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relative'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relative'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relative'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.submitSupPetiForOtherRelative.relative"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.submitSupPetiForOtherRelative',
                                      key: 'relative',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes  </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No  </vs-button
                                >
                                
                              </div>
                            </div>
                          </div>
                        </div>
                    </div> -->
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.submitSupPetiForOtherRelative',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="sponsorInfo.submitSupPetiForOtherRelative.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'familyName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'familyName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'familyName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.submitSupPetiForOtherRelative.familyName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.submitSupPetiForOtherRelative',
                                  key: 'familyName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.submitSupPetiForOtherRelative',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Given Name<em v-if="sponsorInfo.submitSupPetiForOtherRelative.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'givenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'givenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'givenName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.submitSupPetiForOtherRelative.givenName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.submitSupPetiForOtherRelative',
                                  key: 'givenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.submitSupPetiForOtherRelative',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="sponsorInfo.submitSupPetiForOtherRelative.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'middleName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.submitSupPetiForOtherRelative.middleName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.submitSupPetiForOtherRelative',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.submitSupPetiForOtherRelative',key: 'relationShip'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Relationship <em v-if="sponsorInfo.submitSupPetiForOtherRelative.relationShip">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relationShip'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relationShip'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.submitSupPetiForOtherRelative',key:'relationShip'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.submitSupPetiForOtherRelative.relationShip"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.submitSupPetiForOtherRelative',
                                  key: 'relationShip',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>

                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'haveYouPrevFiledAnyPetitionForBnf'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you EVER previously filed a petition for this beneficiary or any other alien?<em v-if="sponsorInfo.haveYouPrevFiledAnyPetitionForBnf">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'haveYouPrevFiledAnyPetitionForBnf'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'haveYouPrevFiledAnyPetitionForBnf'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'haveYouPrevFiledAnyPetitionForBnf'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.haveYouPrevFiledAnyPetitionForBnf"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo',
                                      key: 'haveYouPrevFiledAnyPetitionForBnf',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes  </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No  </vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'familyName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Family Name<em v-if="sponsorInfo.bnfPrevPetitionInfo.familyName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'familyName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'familyName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'familyName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.familyName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'familyName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'givenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Given Name<em v-if="sponsorInfo.bnfPrevPetitionInfo.givenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'givenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'givenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'givenName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.givenName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'givenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="sponsorInfo.bnfPrevPetitionInfo.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'middleName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.middleName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'stateOfFiling'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">State<em v-if="sponsorInfo.bnfPrevPetitionInfo.stateOfFiling">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'stateOfFiling'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'stateOfFiling'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'stateOfFiling'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.stateOfFiling"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'stateOfFiling',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'cityOfFiling'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">City or Town<em v-if="sponsorInfo.bnfPrevPetitionInfo.cityOfFiling">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'cityOfFiling'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'cityOfFiling'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'cityOfFiling'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.cityOfFiling"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'cityOfFiling',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'dateOfFiling'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date<em v-if="sponsorInfo.bnfPrevPetitionInfo.dateOfFiling">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'dateOfFiling'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'dateOfFiling'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'dateOfFiling'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.dateOfFiling"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'dateOfFiling',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.bnfPrevPetitionInfo',key: 'status'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Result <em v-if="sponsorInfo.bnfPrevPetitionInfo.status">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.bnfPrevPetitionInfo',key:'status'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'status'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.bnfPrevPetitionInfo',key:'status'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.bnfPrevPetitionInfo.status"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.bnfPrevPetitionInfo',
                                  key: 'status',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>

                   






                     <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOfLastNYears',key: 'addressOfLastNYears'})">
                      <h3 class="small-header">
                        Your Residence starting with most current for the Past Five Years in the U.S and Aboard<em>*</em>
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.addressOfLastNYears',key:'addressOfLastNYears'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'addressOfLastNYears'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'addressOfLastNYears'})">
                            <vs-checkbox
                          
                            v-model="sponsorInfo.addressOfLastNYears"
                          @change="
                            selectCheck({ section: 'sponsorInfo.addressOfLastNYears', key: 'addressOfLastNYears' })
                          "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                        
                      </h3>
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Street Address</label>
                            </div>
                            <vs-input
                              class="w-full"
                              v-validate="'required'"
                              data-vv-as="Street Address"
                            />
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Apt, Suite</label>
                            </div>
                            <div class="address-suite">
                              <ul
                                class="demo-alignment custom-radio"
                                vs-type="flex"
                                vs-align="center"
                              >
                                <li>
                                  <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                </li>
                              </ul>
                              <vs-input class="" data-vv-as="Apt, Suite" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Country</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select Country"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> State</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select State"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> City</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select City"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label for class="form_label">Zip Code</label>
                            </div>
                            <vs-input class="w-full" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOfLastNYears',key: 'startDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Start Date<em v-if="sponsorInfo.addressOfLastNYears.startDate">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.addressOfLastNYears',key:'startDate'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'startDate'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'startDate'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.addressOfLastNYears.startDate"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.addressOfLastNYears',
                                      key: 'startDate',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOfLastNYears',key: 'endDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">End Date<em v-if="sponsorInfo.addressOfLastNYears.endDate">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.addressOfLastNYears',key:'endDate'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'endDate'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOfLastNYears',key:'endDate'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.addressOfLastNYears.endDate"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.addressOfLastNYears',
                                      key: 'endDate',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                    </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOutsideUSMoreThanYear',key: 'addressOutsideUSMoreThanYear'})">
                        <h3 class="small-header">
                          Last Address outside Of the United States for more than one year<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'addressOutsideUSMoreThanYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'addressOutsideUSMoreThanYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'addressOutsideUSMoreThanYear'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.addressOutsideUSMoreThanYear.addressOutsideUSMoreThanYear"
                            @change="
                              selectCheck({ section: 'sponsorInfo.addressOutsideUSMoreThanYear', key: 'addressOutsideUSMoreThanYear' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOutsideUSMoreThanYear',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="sponsorInfo.addressOutsideUSMoreThanYear.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.addressOutsideUSMoreThanYear.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.addressOutsideUSMoreThanYear',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.addressOutsideUSMoreThanYear',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="sponsorInfo.addressOutsideUSMoreThanYear.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.addressOutsideUSMoreThanYear.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.addressOutsideUSMoreThanYear',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                      </div>
                      </div>
                    
                    <!-- filedName: true,// GIVE NAME, PLACE AND DATE OF FILING
        filedPlace: true,
        fileDateOfFiling: true,
        filedStatus: true,
                     -->


<!-- previous spouse section starts  filedOnAnyOtherPerOrPetitioner-->
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo',key: 'previouslyMarried'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Were you married previously? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'previouslyMarried'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'previouslyMarried'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'previouslyMarried'})">
                             <vs-checkbox
                            
                               v-model="sponsorInfo.previouslyMarried"
                               @change="
                                 selectCheck({
                                   section: 'sponsorInfo',
                                   key: 'previouslyMarried',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="divider full-divider mb-10"></div>
                     <!-- v-if="checkSpouseLabel({section:'sponsorInfo.previousSpouse'})" -->
                     <div class="vx-col w-full"  >
                       <div class="form_group w-full">
                         <label class="form_label"
                           ><h3 class="small-header">Previous Spouse
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              sponsorInfo.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'sponsorInfo.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                           </h3> 
                         </label>
                       </div>
                     </div>  
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'firstName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">First Name<em v-if="sponsorInfo.previousSpouse.firstName">*</em></label>

                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'firstName'})">
                            
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.firstName"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'middleName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Middle Name<em v-if="sponsorInfo.previousSpouse.middleName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.middleName"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'lastName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Last Name<em v-if="sponsorInfo.previousSpouse.lastName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'lastName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.lastName"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'lastName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'maidenName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Maiden Name<em v-if="sponsorInfo.previousSpouse.maidenName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'maidenName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'maidenName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'maidenName'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.maidenName"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'maidenName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="sponsorInfo.previousSpouse.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="sponsorInfo.previousSpouse.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'dateOfMarriageEnd'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage End<em v-if="sponsorInfo.previousSpouse.dateOfMarriageEnd">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.dateOfMarriageEnd"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'dateOfMarriageEnd',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="sponsorInfo.previousSpouse.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Marriage<em v-if="sponsorInfo.previousSpouse.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="sponsorInfo.previousSpouse.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'countryOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Termination<em v-if="sponsorInfo.previousSpouse.countryOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'countryOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.countryOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'countryOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'provinceOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Termination<em v-if="sponsorInfo.previousSpouse.provinceOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.provinceOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'provinceOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'locationOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Termination<em v-if="sponsorInfo.previousSpouse.locationOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'locationOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.locationOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'locationOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'marriageEndedDueTo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Marriage Ended Due To<em v-if="sponsorInfo.previousSpouse.marriageEndedDueTo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'marriageEndedDueTo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.marriageEndedDueTo"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'marriageEndedDueTo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'marriageEndedOtherInfo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">If, Marriage Ended<em v-if="sponsorInfo.previousSpouse.marriageEndedOtherInfo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.previousSpouse.marriageEndedOtherInfo"
                             @change="
                               selectCheck({
                                 section: 'sponsorInfo.previousSpouse',
                                 key: 'marriageEndedOtherInfo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <vs-checkbox
                            
                               v-model="sponsorInfo.previousSpouse.obtainPermResidenceThroughSpouse"
                               @change="
                                 selectCheck({
                                   section: 'sponsorInfo.previousSpouse',
                                   key: 'obtainPermResidenceThroughSpouse',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                    
                     <!-- previous spouse section ends -->
                     <div class="divider full-divider mb-10"></div>
                     <div class="vx-col w-full" v-if="checkSpouseLabel({section:'sponsorInfo.dependentsInfo.spouse'})" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Spouse
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'hasSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'hasSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'hasSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              sponsorInfo.dependentsInfo.spouse.hasSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'sponsorInfo.dependentsInfo.spouse',
                                key: 'hasSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                            </h3> 
                          </label>
                        </div>
                      </div>   
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'firstName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">First Name<em v-if="sponsorInfo.dependentsInfo.spouse.firstName">*</em></label>

                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'firstName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'firstName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'firstName'})">
                            
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.firstName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'firstName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="sponsorInfo.dependentsInfo.spouse.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'middleName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.middleName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'lastName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Last Name<em v-if="sponsorInfo.dependentsInfo.spouse.lastName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'lastName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'lastName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'lastName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.lastName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'lastName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="sponsorInfo.dependentsInfo.spouse.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'maidenName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.maidenName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="sponsorInfo.dependentsInfo.spouse.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'dateOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'dateOfBirth'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'dateOfBirth'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'dateOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="sponsorInfo.dependentsInfo.spouse.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'countryOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.spouse.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="sponsorInfo.dependentsInfo.spouse.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'provinceOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.spouse.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="sponsorInfo.dependentsInfo.spouse.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'locationOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.spouse.locationOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'locationOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'alienNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Your Alien Number (if applicable)<em v-if="sponsorInfo.dependentsInfo.spouse.alienNumber">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'alienNumber'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'alienNumber'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'alienNumber'})">
                          <vs-checkbox
                        
                          v-model="sponsorInfo.dependentsInfo.spouse.alienNumber"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'alienNumber',
                                })
                              "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              name="0"
                              placeholder="123 - 45 - 6789"
                              data-vv-as="123 - 45 - 6789"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                       <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Present Address <em v-if="sponsorInfo.dependentsInfo.spouse.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'currentAddress'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.currentAddress"
                            @change="
                              selectCheck({ section: 'sponsorInfo.dependentsInfo.spouse', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div> 
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status<em v-if="sponsorInfo.dependentsInfo.spouse.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.dependentsInfo.spouse.currentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.dependentsInfo.spouse',

                                        key: 'currentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.spouse',key: 'passportExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date Current Status<em v-if="sponsorInfo.dependentsInfo.spouse.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.spouse',key:'passportExpiryDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'passportExpiryDate'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.spouse',key:'passportExpiryDate'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.spouse.passportExpiryDate"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.spouse',
                                  key: 'passportExpiryDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- children starts here -->
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full" v-if="checkSpouseLabel({section:'sponsorInfo.dependentsInfo.children'})" >
                          <div class="form_group w-full">
                            <label class="form_label"
                              ><h3 class="small-header">Children
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'hasChildren'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'hasChildren'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'hasChildren'})">
                                  <vs-checkbox
                                
                                  v-model="
                               sponsorInfo.dependentsInfo.children.hasChildren
                              "
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'hasChildren',
                                })
                              "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                              </div>
                              </h3> 
                            </label>
                          </div>
                      </div>  
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'firstName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">First Name<em v-if="sponsorInfo.dependentsInfo.children.firstName">*</em></label>

                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'firstName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'firstName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'firstName'})">
                            
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.children.firstName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'firstName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="sponsorInfo.dependentsInfo.children.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'middleName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.children.middleName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'lastName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Last Name<em v-if="sponsorInfo.dependentsInfo.children.lastName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'lastName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'lastName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'lastName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.children.lastName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'lastName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="sponsorInfo.dependentsInfo.children.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'maidenName'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.children.maidenName"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="sponsorInfo.dependentsInfo.children.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'dateOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'dateOfBirth'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'dateOfBirth'})">
                              <vs-checkbox
                            
                              v-model="sponsorInfo.dependentsInfo.children.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'dateOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="sponsorInfo.dependentsInfo.children.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'countryOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.children.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="sponsorInfo.dependentsInfo.children.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'provinceOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.children.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="sponsorInfo.dependentsInfo.children.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'locationOfBirth'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.children.locationOfBirth"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'locationOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.dependentsInfo.children',key: 'relationshipToYou'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Relationship to you<em v-if="sponsorInfo.dependentsInfo.children.relationshipToYou">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.dependentsInfo.children',key:'relationshipToYou'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'relationshipToYou'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.dependentsInfo.children',key:'relationshipToYou'})">
                              <vs-checkbox
                              
                              v-model="sponsorInfo.dependentsInfo.children.relationshipToYou"
                              @change="
                                selectCheck({
                                  section: 'sponsorInfo.dependentsInfo.children',
                                  key: 'relationshipToYou',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <!-- Father Information -->
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your father details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Father Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'fatherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'fatherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'fatherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          sponsorInfo.fatherInfo.fatherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'sponsorInfo.fatherInfo',
                            key: 'fatherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

                            <div class="vx-col w-full">
                              <div class="form-container alt-rows-bg questionnaire_hb">
                                <div class="vx-row">
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'firstName'})">
                                    <div class="vx-input-group flex form-input-group FML">
                                      <div class="vx-input-group-default flex-grow">
                                        <div class="vx-col w-full md:w-1/2">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">First Name<em v-if="sponsorInfo.fatherInfo.firstName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'firstName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'firstName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'firstName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.firstName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo',
                                              key: 'firstName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>

                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'middleName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Middle Name<em v-if="sponsorInfo.fatherInfo.middleName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'middleName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'middleName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'middleName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.middleName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo',
                                              key: 'middleName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'lastName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Last Name<em v-if="sponsorInfo.fatherInfo.lastName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'lastName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'lastName'})}"  >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'lastName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.lastName"
                                                @change="
                                                  selectCheck({
                                                    section: 'sponsorInfo.fatherInfo',
                                                    key: 'lastName',
                                                  })
                                                "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'otherNames'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Have you ever used any other names previously?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'otherNames'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'otherNames'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'otherNames'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.fatherInfo.otherNames"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.fatherInfo',
                                      key: 'otherNames',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>                         
                              </div>
                                  </div>
                                  <div class="vx-col w-full">
                                      <div class="form_group w-full">
                                        <label class="form_label"
                                          ><h3 class="small-header">Name at Birth</h3>
                                        </label>
                                      </div>
                                  </div>
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo.nameAtBirth',key: 'firstName'})">
                                    <div class="vx-input-group flex form-input-group FML">
                                      <div class="vx-input-group-default flex-grow">
                                        <div class="vx-col w-full md:w-1/2">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">First Name<em v-if="sponsorInfo.fatherInfo.nameAtBirth.firstName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'firstName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'firstName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'firstName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.nameAtBirth.firstName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo.nameAtBirth',
                                              key: 'firstName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>

                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo.nameAtBirth',key: 'middleName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Middle Name<em v-if="sponsorInfo.fatherInfo.nameAtBirth.middleName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'middleName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'middleName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'middleName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.nameAtBirth.middleName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo.nameAtBirth',
                                              key: 'middleName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo.nameAtBirth',key: 'lastName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Last Name<em v-if="sponsorInfo.fatherInfo.nameAtBirth.lastName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'lastName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'lastName'})}"  >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo.nameAtBirth',key:'lastName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.fatherInfo.nameAtBirth.lastName"
                                                @change="
                                                  selectCheck({
                                                    section: 'sponsorInfo.fatherInfo.nameAtBirth',
                                                    key: 'lastName',
                                                  })
                                                "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'dateOfBirth'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Date of Birth<em v-if="sponsorInfo.fatherInfo.dateOfBirth">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'dateOfBirth'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'dateOfBirth'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'dateOfBirth'})">
                                              <vs-checkbox
                                            
                                              v-model="sponsorInfo.fatherInfo.dateOfBirth"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo',
                                              key: 'dateOfBirth',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'countryOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Country of Birth<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'countryOfBirth'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'countryOfBirth'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'countryOfBirth'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.fatherInfo.countryOfBirth"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.fatherInfo',
                                          key: 'countryOfBirth',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                  <div class="con-select w-full">
                                    <multiselect :options="[]" placeholder="Select">
                                    </multiselect>
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'provinceOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Province of Birth<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'provinceOfBirth'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'provinceOfBirth'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'provinceOfBirth'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.fatherInfo.provinceOfBirth"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.fatherInfo',
                                          key: 'provinceOfBirth',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                  <div class="con-select w-full">
                                    <multiselect :options="[]" placeholder="Select">
                                    </multiselect>
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'locationOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Location of Birth<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'locationOfBirth'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'locationOfBirth'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'locationOfBirth'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.fatherInfo.locationOfBirth"
                                      @change="
                                        selectCheck({ section: 'sponsorInfo.fatherInfo', key: 'locationOfBirth' })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                  <div class="vs-con-input">
                                    <input type="text" class="vs-inputx vs-input--input normal" />
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'deceasedCity'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Deceased City<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'deceasedCity'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'deceasedCity'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'deceasedCity'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.fatherInfo.deceasedCity"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.fatherInfo',
                                          key: 'deceasedCity',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                  <div class="con-select w-full">
                                    <multiselect :options="[]" placeholder="Select">
                                    </multiselect>
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'deceasedDate'})">
                                      <div class="form_group mt-datepicker-wrap">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Deceased Date<em v-if="sponsorInfo.fatherInfo.deceasedDate">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'deceasedDate'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'deceasedDate'})}" >
                                                  <span class="checkmark" >
                                                    <i class="material-icons">check</i>
                                                  </span>
                                                </span>
                                                <div class="tooltip_cnt">
                                                  <p>Field is required</p>
                                                </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'deceasedDate'})">
                                                <vs-checkbox
                                              
                                                v-model="sponsorInfo.fatherInfo.deceasedDate"
                                            @change="
                                              selectCheck({
                                                section: 'sponsorInfo.fatherInfo',
                                                key: 'deceasedDate',
                                              })
                                            "
                                                ></vs-checkbox>
                                                <div class="tooltip_cnt">
                                                  <p>Validation is required</p>
                                                </div>
                                              </div>
                                              </div>
                                          
                                        </div>
                                        <div
                                          class="mx-datepicker pad5"
                                          typeable="true"
                                          name="dfdateOfBirth"
                                          data-vv-as="Date of Birth"
                                        >
                                          <div class="vs-con-input">
                                            <Datepicker
                                              format="MM/DD/YYYY"
                                              placeholder="MM/DD/YYYY"
                                            ></Datepicker>
                                          </div>
                                        </div>
                                      </div>
                                </div>
                            </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'isUSCitizen'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Is your father now or was he ever a U.S. citizen?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'isUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'isUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'isUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.fatherInfo.isUSCitizen"
                                    @change="
                                    selectCheck({
                                      section: 'sponsorInfo.fatherInfo',
                                      key: 'isUSCitizen',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'dateFromUSCitizen'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> Dates from US citizen<em v-if="sponsorInfo.fatherInfo.dateFromUSCitizen">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'dateFromUSCitizen'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'dateFromUSCitizen'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'dateFromUSCitizen'})">
                                              <vs-checkbox
                                            
                                              v-model="sponsorInfo.fatherInfo.dateFromUSCitizen"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.fatherInfo',
                                              key: 'dateFromUSCitizen',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                              </div>
                                <!-- <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.fatherInfo',key: 'currentAddress'})">
                              <h3 class="small-header">
                                Current Residence  <em v-if="currentAddress">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.fatherInfo',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'currentAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.fatherInfo',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.fatherInfo.currentAddress"
                                  @change="
                                    selectCheck({ section: 'sponsorInfo.fatherInfo', key: 'currentAddress' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                                </div> -->
                              </div>
                            </div>
                            </div>
                  </div>
                </vs-col>
                <!-- MOther Information -->
                <vs-col class="w-full p-0 mt-5">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your mother details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Mother Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'motherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'motherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'motherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          sponsorInfo.motherInfo.motherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'sponsorInfo.motherInfo',
                            key: 'motherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

                            <div class="vx-col w-full">
                              <div class="form-container alt-rows-bg questionnaire_hb">
                                <div class="vx-row">
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'firstName'})">
                                    <div class="vx-input-group flex form-input-group FML">
                                      <div class="vx-input-group-default flex-grow">
                                        <div class="vx-col w-full md:w-1/2">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">First Name<em v-if="sponsorInfo.motherInfo.firstName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'firstName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'firstName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'firstName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.firstName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo',
                                              key: 'firstName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>

                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'middleName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Middle Name<em v-if="sponsorInfo.motherInfo.middleName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'middleName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'middleName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'middleName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.middleName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo',
                                              key: 'middleName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'lastName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Last Name<em v-if="sponsorInfo.motherInfo.lastName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'lastName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'lastName'})}"  >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'lastName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.lastName"
                                                @change="
                                                  selectCheck({
                                                    section: 'sponsorInfo.motherInfo',
                                                    key: 'lastName',
                                                  })
                                                "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'otherNames'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Have you ever used any other names previously?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'otherNames'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'otherNames'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'otherNames'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.motherInfo.otherNames"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.motherInfo',
                                      key: 'otherNames',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>                         
                              </div>
                                  </div>
                                  <div class="vx-col w-full">
                                      <div class="form_group w-full">
                                        <label class="form_label"
                                          ><h3 class="small-header">Name at Birth</h3>
                                        </label>
                                      </div>
                                  </div>
                                  <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.motherInfo.nameAtBirth',key: 'firstName'})">
                                    <div class="vx-input-group flex form-input-group FML">
                                      <div class="vx-input-group-default flex-grow">
                                        <div class="vx-col w-full md:w-1/2">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">First Name<em v-if="sponsorInfo.motherInfo.nameAtBirth.firstName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo.nameAtBirth',key:'firstName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'firstName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'firstName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.nameAtBirth.firstName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo.nameAtBirth',
                                              key: 'firstName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>

                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo.nameAtBirth',key: 'middleName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Middle Name<em v-if="sponsorInfo.motherInfo.nameAtBirth.middleName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo.nameAtBirth',key:'middleName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'middleName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'middleName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.nameAtBirth.middleName"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo.nameAtBirth',
                                              key: 'middleName',
                                            })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo.nameAtBirth',key: 'lastName'})">
                                          <div class="form_group">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Last Name<em v-if="sponsorInfo.motherInfo.nameAtBirth.lastName">*</em></label>
                                              <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo.nameAtBirth',key:'lastName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'lastName'})}"  >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo.nameAtBirth',key:'lastName'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.motherInfo.nameAtBirth.lastName"
                                                @change="
                                                  selectCheck({
                                                    section: 'sponsorInfo.motherInfo.nameAtBirth',
                                                    key: 'lastName',
                                                  })
                                                "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                            </div>
                                            <div class="vs-input w-full vs-input-primary">
                                              <div class="vs-con-input">
                                                <input
                                                  type="text"
                                                  maxlength="200"
                                                  class="vs-inputx vs-input--input normal"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'dateOfBirth'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Date of Birth<em v-if="sponsorInfo.motherInfo.dateOfBirth">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'dateOfBirth'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'dateOfBirth'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'dateOfBirth'})">
                                              <vs-checkbox
                                            
                                              v-model="sponsorInfo.motherInfo.dateOfBirth"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo',
                                              key: 'dateOfBirth',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'countryOfBirth'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country of Birth<em>*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'countryOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.motherInfo.countryOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.motherInfo',
                                        key: 'countryOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="con-select w-full">
                                  <multiselect :options="[]" placeholder="Select">
                                  </multiselect>
                                </div>
                              </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'provinceOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Province of Birth<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'provinceOfBirth'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'provinceOfBirth'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'provinceOfBirth'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.motherInfo.provinceOfBirth"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.motherInfo',
                                          key: 'provinceOfBirth',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                  <div class="con-select w-full">
                                    <multiselect :options="[]" placeholder="Select">
                                    </multiselect>
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'locationOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Location of Birth<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'locationOfBirth'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'locationOfBirth'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'locationOfBirth'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.motherInfo.locationOfBirth"
                                      @change="
                                        selectCheck({ section: 'sponsorInfo.motherInfo', key: 'locationOfBirth' })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                  <div class="vs-con-input">
                                    <input type="text" class="vs-inputx vs-input--input normal" />
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'deceasedCity'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Deceased City<em>*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'deceasedCity'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'deceasedCity'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'deceasedCity'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.motherInfo.deceasedCity"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.motherInfo',
                                          key: 'deceasedCity',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                  <div class="con-select w-full">
                                    <multiselect :options="[]" placeholder="Select">
                                    </multiselect>
                                  </div>
                                </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'deceasedDate'})">
                                      <div class="form_group mt-datepicker-wrap">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Deceased Date<em v-if="sponsorInfo.motherInfo.deceasedDate">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'deceasedDate'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'deceasedDate'})}" >
                                                  <span class="checkmark" >
                                                    <i class="material-icons">check</i>
                                                  </span>
                                                </span>
                                                <div class="tooltip_cnt">
                                                  <p>Field is required</p>
                                                </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'deceasedDate'})">
                                                <vs-checkbox
                                              
                                                v-model="sponsorInfo.motherInfo.deceasedDate"
                                            @change="
                                              selectCheck({
                                                section: 'sponsorInfo.motherInfo',
                                                key: 'deceasedDate',
                                              })
                                            "
                                                ></vs-checkbox>
                                                <div class="tooltip_cnt">
                                                  <p>Validation is required</p>
                                                </div>
                                              </div>
                                              </div>
                                          
                                        </div>
                                        <div
                                          class="mx-datepicker pad5"
                                          typeable="true"
                                          name="dfdateOfBirth"
                                          data-vv-as="Date of Birth"
                                        >
                                          <div class="vs-con-input">
                                            <Datepicker
                                              format="MM/DD/YYYY"
                                              placeholder="MM/DD/YYYY"
                                            ></Datepicker>
                                          </div>
                                        </div>
                                      </div>
                                </div>
                            </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'isUSCitizen'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Is your father now or was he ever a U.S. citizen?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'isUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'isUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'isUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.motherInfo.isUSCitizen"
                                    @change="
                                    selectCheck({
                                      section: 'sponsorInfo.motherInfo',
                                      key: 'isUSCitizen',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'dateFromUSCitizen'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> Dates from US citizen<em v-if="sponsorInfo.motherInfo.dateFromUSCitizen">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.motherInfo',key:'dateFromUSCitizen'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'dateFromUSCitizen'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'dateFromUSCitizen'})">
                                              <vs-checkbox
                                            
                                              v-model="sponsorInfo.motherInfo.dateFromUSCitizen"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.motherInfo',
                                              key: 'dateFromUSCitizen',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                              </div>
                                <!-- <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.motherInfo',key: 'currentAddress'})">
                              <h3 class="small-header">
                                Current Residence  <em v-if="currentAddress">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'sponsorInfo.motherInfo',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.motherInfo',key:'currentAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.motherInfo',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="sponsorInfo.motherInfo.currentAddress"
                                  @change="
                                    selectCheck({ section: 'sponsorInfo.motherInfo', key: 'currentAddress' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                                </div> -->
                              </div>
                            </div>
                            </div>
                  </div>
                </vs-col>
                <!-- Sponsor employement -->
                <div class="vx-col w-full mb-5 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'sponsorInfo',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed?<em v-if="sponsorInfo.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Please write the following information about your current and past employment for the past five years in the U.S and abroad starting with your most current Job.
                  </vs-alert>
                </vs-col>
                <vs-col
                class="m-auto float-none"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                >
                <div class="form-container pt-10 form-container_QT">
                          <h3 class="small-header">Employment 
                            
                      <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                          <vs-checkbox
                        
                          v-model="
                        sponsorInfo.prevEmploymentInfo.prevEmploymentInfo
                      "
                      @change="
                        selectCheck({
                          section: 'sponsorInfo.prevEmploymentInfo',
                          key: 'prevEmploymentInfo',
                        })
                      "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                          </h3>
                  <div class="vx-row">

                    <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'employerName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Employer Name<em v-if="sponsorInfo.prevEmploymentInfo.employerName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'employerName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'employerName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'employerName'})">
                                      <vs-checkbox
                                    
                                      v-model="
                                    sponsorInfo.prevEmploymentInfo.employerName
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'employerName',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'currentEmployer'})">
                            <div class="d-flex align-center">
                              <a class="switch-label mr-3"> Current Employer? </a>
                              <vs-switch>
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                              </vs-switch>
                              <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'currentEmployer'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                      <vs-checkbox
                                    
                                      v-model=" 
                                  sponsorInfo.prevEmploymentInfo.currentEmployer
                                "
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo.prevEmploymentInfo',
                                    key: 'currentEmployer',
                                  })
                                "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                              
                            </div>
                          </div>
                          
                          <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'jobTitle'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Job Title<em v-if="sponsorInfo.prevEmploymentInfo.jobTitle">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'jobTitle'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'jobTitle'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'jobTitle'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.jobTitle"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'jobTitle',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'businessType'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label"
                                  >Employer Business E.g., IT<em v-if="sponsorInfo.prevEmploymentInfo.businessType">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'businessType'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'businessType'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'businessType'})">
                                      <vs-checkbox
                                    
                                      v-model="
                                    sponsorInfo.prevEmploymentInfo.businessType
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'businessType',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'salary'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Salary<em v-if="sponsorInfo.prevEmploymentInfo.salary">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'salary'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'salary'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'salary'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.salary"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'salary',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'payFrequency'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Pay Frequency<em v-if="sponsorInfo.prevEmploymentInfo.payFrequency">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'payFrequency'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'payFrequency'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'payFrequency'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.payFrequency"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'payFrequency',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'jobDuties'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Description of Duties Performed<em v-if="sponsorInfo.prevEmploymentInfo.jobDuties">*</em>
                                  <div class="IB_tooltip H1-140">
                                    <span
                                      ><info-icon
                                        size="1.5x"
                                        class="custom-class"
                                      ></info-icon
                                    ></span>
                                    <div class="tooltip_cnt">
                                      <p>
                                        Please fill in your Job Duties only.Avoid
                                        inserting all project details.
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'jobDuties'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'jobDuties'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'jobDuties'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.jobDuties"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'jobDuties',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div class="vs-con-textarea w-full vs-textarea-primary">
                                <textarea class="vs-textarea"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'startDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Start Date<em v-if="sponsorInfo.prevEmploymentInfo.startDate">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'startDate'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'startDate'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'startDate'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.startDate"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'startDate',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'endDate'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">End Date<em v-if="sponsorInfo.prevEmploymentInfo.endDate">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'endDate'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'endDate'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'endDate'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.endDate"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.prevEmploymentInfo',
                                      key: 'endDate',
                                    })
                                  "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                
                              </div>
                              <div
                                class="mx-datepicker pad5"
                                typeable="true"
                                name="dfdateOfBirth"
                                data-vv-as="Date of Birth"
                              >
                                <div class="vs-con-input">
                                  <Datepicker
                                    format="MM/DD/YYYY"
                                    placeholder="MM/DD/YYYY"
                                  ></Datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentInfo',key: 'address'})">
                            <h3 class="small-header">
                              Work Address<em v-if="sponsorInfo.prevEmploymentInfo.address">*</em>
                              <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentInfo',key:'address'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'address'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentInfo',key:'address'})">
                                      <vs-checkbox
                                    
                                      v-model="sponsorInfo.prevEmploymentInfo.address"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo.prevEmploymentInfo',

                                    key: 'address',
                                  })
                                "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                              
                            </h3>
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Street Address</label>
                                  </div>
                                  <vs-input
                                    class="w-full"
                                    v-validate="'required'"
                                    data-vv-as="Street Address"
                                  />
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Apt, Suite</label>
                                  </div>
                                  <div class="address-suite">
                                    <ul
                                      class="demo-alignment custom-radio"
                                      vs-type="flex"
                                      vs-align="center"
                                    >
                                      <li>
                                        <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                      </li>
                                    </ul>
                                    <vs-input class="" data-vv-as="Apt, Suite" />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Country</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select Country"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> State</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select State"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> City</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select City"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label">Zip Code</label>
                                  </div>
                                  <vs-input class="w-full" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>
                 <!-- Sponsor employement outside USA -->
                 <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;" v-if="showOrHideField({section: 'sponsorInfo',key: 'haveYouEverEmployed'})">
                  <div class="form_group">
                    <div class="d-flex align-end mb-1">
                      <label class="form_label">Have you ever been employed  Outside US?<em v-if="sponsorInfo.haveYouEverEmployed">*</em></label>
                      <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'sponsorInfo',key:'haveYouEverEmployed'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo',key:'haveYouEverEmployed'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo',key:'haveYouEverEmployed'})">
                                  <vs-checkbox
                                
                                  v-model="sponsorInfo.haveYouEverEmployed"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo',
                                        key: 'haveYouEverEmployed',
                                      })
                                    "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                      
                    </div>
                    <div class="form_radio_btns">
                      <vs-button class="yes mr-5" color="success" type="border">
                        Yes</vs-button
                      >
                      <vs-button class="no" color="danger" type="border"
                        >No</vs-button
                      >
                    </div>
                  </div>
                </div>
                <vs-col class="w-full p-0 mt-6">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Last Employer outside of the United States for more than one year.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment Outside US
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <vs-checkbox
                          
                            v-model="
                          sponsorInfo.prevEmploymentOutsideUS.prevEmploymentOutsideUS
                        "
                        @change="
                          selectCheck({
                            section: 'sponsorInfo.prevEmploymentOutsideUS',
                            key: 'prevEmploymentOutsideUS',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">
                        <div class="vx-col w-full">
                          <div class="form-container alt-rows-bg questionnaire_hb">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'employerName'})">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label">Employer Name<em v-if="sponsorInfo.prevEmploymentOutsideUS.employerName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'employerName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'employerName'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'employerName'})">
                                          <vs-checkbox
                                        
                                          v-model="
                                        sponsorInfo.prevEmploymentOutsideUS.employerName
                                      "
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'employerName',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo',key: 'currentEmployer'})">
                                <div class="d-flex align-center">
                                  <a class="switch-label mr-3"> Current Employer? </a>
                                  <vs-switch>
                                    <span slot="on">Yes</span>
                                    <span slot="off">No</span>
                                  </vs-switch>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'currentEmployer'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                                          <vs-checkbox
                                        
                                          v-model=" 
                                      sponsorInfo.prevEmploymentOutsideUS.currentEmployer
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.prevEmploymentOutsideUS',
                                        key: 'currentEmployer',
                                      })
                                    "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                              </div>
                              
                              <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'jobTitle'})">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label">Job Title<em v-if="sponsorInfo.prevEmploymentOutsideUS.jobTitle">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobTitle'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.prevEmploymentOutsideUS.jobTitle"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'jobTitle',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'businessType'})">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label"
                                      >Employer Business E.g., IT<em v-if="sponsorInfo.prevEmploymentOutsideUS.businessType">*</em></label
                                    >
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'businessType'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'businessType'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'businessType'})">
                                          <vs-checkbox
                                        
                                          v-model="
                                        sponsorInfo.prevEmploymentOutsideUS.businessType
                                      "
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'businessType',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'salary'})">
                                                      <div class="form_group">
                                                        <div class="d-flex align-end mb-1">
                                                          <label for class="form_label">Salary<em v-if="sponsorInfo.prevEmploymentOutsideUS.salary">*</em></label>
                                                          <div class="check_box_container"  v-if="isEdit">
                                                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'salary'})">
                                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'salary'})}" >
                                                                  <span class="checkmark" >
                                                                    <i class="material-icons">check</i>
                                                                  </span>
                                                                </span>
                                                                <div class="tooltip_cnt">
                                                                  <p>Field is required</p>
                                                                </div>
                                                              </div>
                                                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'salary'})">
                                                                <vs-checkbox
                                                              
                                                                v-model="sponsorInfo.prevEmploymentOutsideUS.salary"
                                                            @change="
                                                              selectCheck({
                                                                section: 'sponsorInfo.prevEmploymentOutsideUS',
                                                                key: 'salary',
                                                              })
                                                            "
                                                                ></vs-checkbox>
                                                                <div class="tooltip_cnt">
                                                                  <p>Validation is required</p>
                                                                </div>
                                                              </div>
                                                              </div>
                                                          
                                                        </div>
                                                        <div class="vs-con-input">
                                                          <input
                                                            type="text"
                                                            class="vs-inputx vs-input--input normal"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'payFrequency'})">
                                                      <div class="form_group">
                                                        <div class="d-flex align-end mb-1">
                                                          <label for class="form_label">Pay Frequency<em v-if="sponsorInfo.prevEmploymentOutsideUS.payFrequency">*</em></label>
                                                          <div class="check_box_container"  v-if="isEdit">
                                                              <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'payFrequency'})}" >
                                                                  <span class="checkmark" >
                                                                    <i class="material-icons">check</i>
                                                                  </span>
                                                                </span>
                                                                <div class="tooltip_cnt">
                                                                  <p>Field is required</p>
                                                                </div>
                                                              </div>
                                                              <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                                                <vs-checkbox
                                                              
                                                                v-model="sponsorInfo.prevEmploymentOutsideUS.payFrequency"
                                                            @change="
                                                              selectCheck({
                                                                section: 'sponsorInfo.prevEmploymentOutsideUS',
                                                                key: 'payFrequency',
                                                              })
                                                            "
                                                                ></vs-checkbox>
                                                                <div class="tooltip_cnt">
                                                                  <p>Validation is required</p>
                                                                </div>
                                                              </div>
                                                              </div>
                                                          
                                                        </div>
                                                        <div class="vs-con-input">
                                                          <input
                                                            type="text"
                                                            class="vs-inputx vs-input--input normal"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'jobDuties'})">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"
                                      >Description of Duties Performed<em v-if="sponsorInfo.prevEmploymentOutsideUS.jobDuties">*</em>
                                      <div class="IB_tooltip H1-140">
                                        <span
                                          ><info-icon
                                            size="1.5x"
                                            class="custom-class"
                                          ></info-icon
                                        ></span>
                                        <div class="tooltip_cnt">
                                          <p>
                                            Please fill in your Job Duties only.Avoid
                                            inserting all project details.
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobDuties'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.prevEmploymentOutsideUS.jobDuties"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'jobDuties',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div class="vs-con-textarea w-full vs-textarea-primary">
                                    <textarea class="vs-textarea"></textarea>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'startDate'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Start Date<em v-if="sponsorInfo.prevEmploymentOutsideUS.startDate">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'startDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'startDate'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'startDate'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.prevEmploymentOutsideUS.startDate"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'startDate',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'endDate'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">End Date<em v-if="sponsorInfo.prevEmploymentOutsideUS.endDate">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'endDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'endDate'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'endDate'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.prevEmploymentOutsideUS.endDate"
                                      @change="
                                        selectCheck({
                                          section: 'sponsorInfo.prevEmploymentOutsideUS',
                                          key: 'endDate',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--   

                              -->
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'sponsorInfo.prevEmploymentOutsideUS',key: 'address'})">
                                <h3 class="small-header">
                                  Work Address<em v-if="sponsorInfo.prevEmploymentOutsideUS.address">*</em>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.prevEmploymentOutsideUS',key:'address'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'address'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.prevEmploymentOutsideUS',key:'address'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.prevEmploymentOutsideUS.address"
                                    @change="
                                      selectCheck({
                                        section: 'sponsorInfo.prevEmploymentOutsideUS',

                                        key: 'address',
                                      })
                                    "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </h3>
                                <div class="vx-row">
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Street Address</label>
                                      </div>
                                      <vs-input
                                        class="w-full"
                                        v-validate="'required'"
                                        data-vv-as="Street Address"
                                      />
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Apt, Suite</label>
                                      </div>
                                      <div class="address-suite">
                                        <ul
                                          class="demo-alignment custom-radio"
                                          vs-type="flex"
                                          vs-align="center"
                                        >
                                          <li>
                                            <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                          </li>
                                          <li>
                                            <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                          </li>
                                          <li>
                                            <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                          </li>
                                        </ul>
                                        <vs-input class="" data-vv-as="Apt, Suite" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Country</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select Country"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label"> State</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select State"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label"> City</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select City"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label">Zip Code</label>
                                      </div>
                                      <vs-input class="w-full" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'benfApplyAdjustStatus'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Is beneficiary is applying for adjustment of status based on your application?  </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'benfApplyAdjustStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'benfApplyAdjustStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'benfApplyAdjustStatus'})">
                              <vs-checkbox
                            
                                v-model="sponsorInfo.affidavitInfo.benfApplyAdjustStatus"
                                @change="
                                  selectCheck({
                                    section: 'sponsorInfo.affidavitInfo',
                                    key: 'benfApplyAdjustStatus',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                            </div>
                          </div>
                        </div>
                        </div>
                  </div>
                
                </vs-col>
                <!-- Affidavits Information -->
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  If the beneficiary is applying for adjustment of status based on your application, you will need to file an AFFIDAVIT OF SUPPORT (Form I-864) for the beneficiary.  The following information is required for the AFFIDAVIT OF SUPPORT IN FORM I-864 </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Affidavit Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'affidavitInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'affidavitInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'affidavitInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          sponsorInfo.affidavitInfo.affidavitInfo
                        "
                        @change="
                          selectCheck({
                            section: 'sponsorInfo.affidavitInfo',
                            key: 'affidavitInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="form-container alt-rows-bg questionnaire_hb">
                                <div class="vx-row">
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'currentAnnualSalary'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Current annual salary<em v-if="sponsorInfo.affidavitInfo.currentAnnualSalary">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'currentAnnualSalary'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'currentAnnualSalary'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'currentAnnualSalary'})">
                                          <vs-checkbox
                                        
                                          v-model="sponsorInfo.affidavitInfo.currentAnnualSalary"
                                          @change="
                                            selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'currentAnnualSalary' })
                                          "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      </div>
                                      <div class="vs-con-input">
                                        <input type="text" class="vs-inputx vs-input--input normal" />
                                      </div>
                                    </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'nameOfEmployer'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Name of the employer<em v-if="sponsorInfo.affidavitInfo.nameOfEmployer">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'nameOfEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'nameOfEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'nameOfEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.nameOfEmployer"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'nameOfEmployer' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'currentPosition'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Current Position<em v-if="sponsorInfo.affidavitInfo.currentPosition">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'currentPosition'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'currentPosition'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'currentPosition'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.currentPosition"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'currentPosition' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'depositsInBankUSA'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Deposits in Bank<em v-if="sponsorInfo.affidavitInfo.depositsInBankUSA">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'depositsInBankUSA'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'depositsInBankUSA'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'depositsInBankUSA'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.depositsInBankUSA"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'depositsInBankUSA' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'benfAdjustmentDocument'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >Copies of most recent bank statement<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'benfAdjustmentDocument'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'benfAdjustmentDocument'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'benfAdjustmentDocument'})">
                             <vs-checkbox
                            
                             v-model="sponsorInfo.affidavitInfo.benfAdjustmentDocument"
                                 @change="
                                   selectCheck({
                                     section: 'sponsorInfo.affidavitInfo',
                                     key: 'benfAdjustmentDocument',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                                 </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'reasonableValPersonalProperty'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Reasonable value of personal property<em v-if="sponsorInfo.affidavitInfo.reasonableValPersonalProperty">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'reasonableValPersonalProperty'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'reasonableValPersonalProperty'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'reasonableValPersonalProperty'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.reasonableValPersonalProperty"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'reasonableValPersonalProperty' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'haveMarketValInStocksAndBonds'})" >
                                  <div class="d-flex align-center">
                                    <a class="switch-label mr-3"> DO you have bonds and stocks </a>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                    <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'haveMarketValInStocksAndBonds'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'haveMarketValInStocksAndBonds'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'haveMarketValInStocksAndBonds'})">
                                        <vs-checkbox
                                      
                                          v-model="sponsorInfo.affidavitInfo.haveMarketValInStocksAndBonds"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.affidavitInfo',
                                              key: 'haveMarketValInStocksAndBonds',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'marketValInStocksAndBonds'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Market value of bonds and stocks<em v-if="sponsorInfo.affidavitInfo.marketValInStocksAndBonds">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'marketValInStocksAndBonds'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'marketValInStocksAndBonds'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'marketValInStocksAndBonds'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.marketValInStocksAndBonds"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'marketValInStocksAndBonds' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'sumOfLifeInsurance'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Sum of Life Insurance<em v-if="sponsorInfo.affidavitInfo.sumOfLifeInsurance">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'sumOfLifeInsurance'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'sumOfLifeInsurance'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'sumOfLifeInsurance'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.sumOfLifeInsurance"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'sumOfLifeInsurance' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'cashSurrValOfLifeInsurance'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Cash surrender value of Life Insurance<em v-if="sponsorInfo.affidavitInfo.cashSurrValOfLifeInsurance">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'cashSurrValOfLifeInsurance'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'cashSurrValOfLifeInsurance'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'cashSurrValOfLifeInsurance'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.cashSurrValOfLifeInsurance"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'cashSurrValOfLifeInsurance' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'haveValOfRealEstate'})" >
                                  <div class="d-flex align-center">
                                    <a class="switch-label mr-3"> DO you owned Real Estate</a>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                    <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'haveValOfRealEstate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'haveValOfRealEstate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'haveValOfRealEstate'})">
                                        <vs-checkbox
                                      
                                          v-model="sponsorInfo.affidavitInfo.haveValOfRealEstate"
                                          @change="
                                            selectCheck({
                                              section: 'sponsorInfo.affidavitInfo',
                                              key: 'haveValOfRealEstate',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'valOfRealEstate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Value of Real Estate <em v-if="sponsorInfo.affidavitInfo.valOfRealEstate">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'valOfRealEstate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'valOfRealEstate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'valOfRealEstate'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.valOfRealEstate"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'valOfRealEstate' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'amountOfMortgageProperty'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Amount of Morgage on the property <em v-if="sponsorInfo.affidavitInfo.amountOfMortgageProperty">*</em> </label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'amountOfMortgageProperty'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'amountOfMortgageProperty'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'amountOfMortgageProperty'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.amountOfMortgageProperty"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'amountOfMortgageProperty' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'sponsorInfo.affidavitInfo',key: 'addressPropertyIsLocate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Address where the real property is located <em v-if="sponsorInfo.affidavitInfo.addressPropertyIsLocate">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.affidavitInfo',key:'addressPropertyIsLocate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'addressPropertyIsLocate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.affidavitInfo',key:'addressPropertyIsLocate'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.affidavitInfo.addressPropertyIsLocate"
                                        @change="
                                          selectCheck({ section: 'sponsorInfo.affidavitInfo', key: 'addressPropertyIsLocate' })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                    <div class="vs-con-input">
                                      <input type="text" class="vs-inputx vs-input--input normal" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              </div>
                            </div>
                            </div>
                  </div>
                </vs-col>
                <!-- sponsor documents -->
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  >
                  <div class="form-container pt-10 form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          List of documents needs to be updated
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                          </span>
                        </h3>
                        <div class="documents_group case_documents">
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'sponsorInfo.documents',key: 'sponsorPassport'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of all the pages of the passport of the Petitioner (including the blank pages).  Please make sure that the photo(s) and biographic information are clearly visible<em v-if="sponsorInfo.documents.passport">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.documents',key:'sponsorPassport'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorPassport'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorPassport'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.documents.sponsorPassport"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.documents',
                                      key: 'sponsorPassport',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'sponsorInfo.documents',key: 'sponsorGreenCard'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of the Naturalization Certificate/Green Card (front and back) of the Petitioner<em v-if="sponsorInfo.documents.sponsorGreenCard">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.documents',key:'sponsorGreenCard'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorGreenCard'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorGreenCard'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.documents.sponsorGreenCard"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.documents',
                                      key: 'sponsorGreenCard',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'sponsorInfo.documents',key: 'sponsorBirthCertificate'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of the Birth Certificate of the Petitioner<em v-if="sponsorInfo.documents.sponsorBirthCertificate">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.documents',key:'sponsorBirthCertificate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorBirthCertificate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorBirthCertificate'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.documents.sponsorBirthCertificate"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.documents',
                                      key: 'sponsorBirthCertificate',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'sponsorInfo.documents',key: 'sponsorPhotographs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Two (2) photographs of the Petitioner<em v-if="sponsorInfo.documents.sponsorPhotographs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'sponsorInfo.documents',key:'sponsorPhotographs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorPhotographs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'sponsorInfo.documents',key:'sponsorPhotographs'})">
                                        <vs-checkbox
                                      
                                        v-model="sponsorInfo.documents.sponsorPhotographs"
                                  @change="
                                    selectCheck({
                                      section: 'sponsorInfo.documents',
                                      key: 'sponsorPhotographs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <div v-if="currentTab=='Petitioner Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                class="m-auto float-none"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT"> 
                    <div class="vx-row">
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'benfComeToUSOpenNewOffice'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Is the beneficiary coming to the United States to open a new office?<em v-if="petitionerQuestInfo.benfComeToUSOpenNewOffice">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'benfComeToUSOpenNewOffice'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'benfComeToUSOpenNewOffice'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'benfComeToUSOpenNewOffice'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.benfComeToUSOpenNewOffice"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'benfComeToUSOpenNewOffice',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'classificationScougt'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Classification sought <em v-if="petitionerQuestInfo.classificationScougt">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'classificationScougt'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'classificationScougt'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'classificationScougt'})">
                              <vs-checkbox
                             
                              v-model="petitionerQuestInfo.classificationScougt"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'classificationScougt',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  L-1A manager or executive </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >L-1B specialized knowledge </vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'nameOfEmpAbroad'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Name of Employer Abroad <em v-if="petitionerQuestInfo.nameOfEmpAbroad">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'nameOfEmpAbroad'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'nameOfEmpAbroad'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'nameOfEmpAbroad'})">
                              <vs-checkbox
                              
                              v-model="petitionerQuestInfo.nameOfEmpAbroad"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'nameOfEmpAbroad',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'address'})">
                        <h3 class="small-header">
                          Address of Employer Abroad  <em v-if="petitionerQuestInfo.address">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'petitionerQuestInfo',key:'address'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'address'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'address'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.address"
                            @change="
                              selectCheck({ section: 'petitionerQuestInfo', key: 'address' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.dateOfBenfEmployment',key: 'dateOfBenfEmployment'})">
                        <h3 class="small-header">
                          Dates of beneficiary's employment with this employer  <em v-if="petitionerQuestInfo.dateOfBenfEmployment.dateOfBenfEmployment">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfBenfEmployment'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfBenfEmployment'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfBenfEmployment'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.dateOfBenfEmployment.dateOfBenfEmployment"
                            @change="
                              selectCheck({ section: 'petitionerQuestInfo.dateOfBenfEmployment', key: 'dateOfBenfEmployment' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                      </div>
                      
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo.dateOfBenfEmployment',key: 'dateOfEmpFrom'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Dates of Employement From<em v-if="petitionerQuestInfo.dateOfBenfEmployment.dateOfEmpFrom">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpFrom'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpFrom'})}"  >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpFrom'})">
                                <vs-checkbox
                                
                                v-model="petitionerQuestInfo.dateOfBenfEmployment.dateOfEmpFrom"
                                @change="
                                  selectCheck({
                                    section: 'petitionerQuestInfo.dateOfBenfEmployment',
                                    key: 'dateOfEmpFrom',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                  :disabled="true"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo.dateOfBenfEmployment',key: 'dateOfEmpTo'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Dates of Employement To<em v-if="petitionerQuestInfo.dateOfBenfEmployment.dateOfEmpTo">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpTo'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpTo'})}"  >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'dateOfEmpTo'})">
                                <vs-checkbox
                                
                                v-model="petitionerQuestInfo.dateOfBenfEmployment.dateOfEmpTo"
                                @change="
                                  selectCheck({
                                    section: 'petitionerQuestInfo.dateOfBenfEmployment',
                                    key: 'dateOfEmpTo',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                  :disabled="true"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo.dateOfBenfEmployment',key: 'explaOfInterruptions'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Explanation of Interruptions<em v-if="petitionerQuestInfo.dateOfBenfEmployment.explaOfInterruptions">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'explaOfInterruptions'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'explaOfInterruptions'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.dateOfBenfEmployment',key:'explaOfInterruptions'})">
                              <vs-checkbox
                              
                              v-model="petitionerQuestInfo.dateOfBenfEmployment.explaOfInterruptions"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.dateOfBenfEmployment',
                                      key: 'explaOfInterruptions',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                        </div>
                     

                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'descBenfDutAbroad3Years'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Describe the beneficiary's duties abroad for the 3 years preceding the filing of the petition <em v-if="petitionerQuestInfo.descBenfDutAbroad3Years">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'descBenfDutAbroad3Years'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'descBenfDutAbroad3Years'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'descBenfDutAbroad3Years'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.descBenfDutAbroad3Years"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'descBenfDutAbroad3Years',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'descBenfPropDutiesInUs'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Describe the beneficiary's proposed duties in the United States.<em v-if="petitionerQuestInfo.descBenfPropDutiesInUs">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'descBenfPropDutiesInUs'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'descBenfPropDutiesInUs'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'descBenfPropDutiesInUs'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.descBenfPropDutiesInUs"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'descBenfPropDutiesInUs',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'sumBenfEduAndWorkExp'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Summarize the beneficiary's education and work experience.<em v-if="petitionerQuestInfo.sumBenfEduAndWorkExp">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'sumBenfEduAndWorkExp'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'sumBenfEduAndWorkExp'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'sumBenfEduAndWorkExp'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.sumBenfEduAndWorkExp"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'sumBenfEduAndWorkExp',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'companyRelaToAbroad'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >How is the U.S. company related to the company abroad? <em v-if="petitionerQuestInfo.companyRelaToAbroad">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'companyRelaToAbroad'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'companyRelaToAbroad'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'companyRelaToAbroad'})">
                              <vs-checkbox
                             
                              v-model="petitionerQuestInfo.companyRelaToAbroad"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'companyRelaToAbroad',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">Parent </vs-button>
                                <vs-button class="no" color="danger" type="border" >Branch</vs-button>
                                <vs-button class="yes mr-5" color="success" type="border">Subsidiary</vs-button>
                                <vs-button class="yes mr-5" color="success" type="border">Affiliate</vs-button>
                                <vs-button class="yes mr-5" color="success" type="border">Joint Venture</vs-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      

                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          Describe the percentage of stock ownership and managerial control of each company that has a qualifying relationship. Provide the Federal Employer Identification Number for each U.S. company that has a qualifying relationship.  <em v-if="petitionerQuestInfo.desPerStockOwnerShip.desPerStockOwnerShip">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'desPerStockOwnerShip'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'desPerStockOwnerShip'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'desPerStockOwnerShip'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.desPerStockOwnerShip.desPerStockOwnerShip"
                            @change="
                              selectCheck({ section: 'petitionerQuestInfo.desPerStockOwnerShip', key: 'desPerStockOwnerShip' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <!-- <label>Describe the percentage of stock ownership and managerial control of each company that has a qualifying relationship. Provide the Federal Employer Identification Number for each U.S. company that has a qualifying relationship. </label> -->
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo.desPerStockOwnerShip',key: 'perOfCompany'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Percentage of company stock ownership and managerial control of each company that has a qualifying relationship<em v-if="petitionerQuestInfo.desPerStockOwnerShip.perOfCompany">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'perOfCompany'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'perOfCompany'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'perOfCompany'})">
                                  <vs-checkbox
                                  
                                  v-model="petitionerQuestInfo.desPerStockOwnerShip.perOfCompany"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.desPerStockOwnerShip',
                                      key: 'perOfCompany',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo.desPerStockOwnerShip',key: 'fedEmpIdentification'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Federal Employer Identification Number for each U.S. company that has a qualifying relationship<em v-if="petitionerQuestInfo.desPerStockOwnerShip.fedEmpIdentification">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'fedEmpIdentification'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'fedEmpIdentification'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.desPerStockOwnerShip',key:'fedEmpIdentification'})">
                                  <vs-checkbox
                                  
                                  v-model="petitionerQuestInfo.desPerStockOwnerShip.fedEmpIdentification"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.desPerStockOwnerShip',
                                      key: 'fedEmpIdentification',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'everqualRelaOneYearEmpl'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Do the companies currently have the same qualifying relationship as they did during the one-year period of the beneficiary's employment with the company abroad?<em v-if="petitionerQuestInfo.everqualRelaOneYearEmpl">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmpl'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmpl'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmpl'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.everqualRelaOneYearEmpl"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'everqualRelaOneYearEmpl',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes </vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No </vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'everqualRelaOneYearEmplExpla'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provide an explanation <em v-if="petitionerQuestInfo.everqualRelaOneYearEmplExpla">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmplExpla'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmplExpla'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'everqualRelaOneYearEmplExpla'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.everqualRelaOneYearEmplExpla"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'everqualRelaOneYearEmplExpla',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full">
                        <h3 class="small-header">Offsite Work Location</h3>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'benePriOffsiteEmp'})">
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Will the beneficiary be stationed primarily offsite <em v-if="petitionerQuestInfo.benePriOffsiteEmp">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'benePriOffsiteEmp'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'benePriOffsiteEmp'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'benePriOffsiteEmp'})">
                                <vs-checkbox
                              
                                v-model="petitionerQuestInfo.benePriOffsiteEmp"
                                    @change="
                                      selectCheck({
                                        section: 'petitionerQuestInfo',
                                        key: 'benePriOffsiteEmp',
                                      })
                                    "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                                  
                                </div>
                                <div class="form_radio_btns">
                                  <vs-button class="yes mr-5" color="success" type="border">
                                    Yes</vs-button
                                  >
                                  <vs-button class="no" color="danger" type="border"
                                    >No </vs-button
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'priOffsiteEmpExpla'})">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Describe how and by whom the beneficiary's work will be controlled and supervised<em v-if="petitionerQuestInfo.priOffsiteEmpExpla">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'priOffsiteEmpExpla'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'priOffsiteEmpExpla'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'priOffsiteEmpExpla'})">
                                <vs-checkbox
                              
                                v-model="petitionerQuestInfo.priOffsiteEmpExpla"
                                  @change="
                                      selectCheck({
                                        section: 'petitionerQuestInfo',
                                        key: 'priOffsiteEmpExpla',
                                      })
                                    "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            </div>
                            <div class="vs-con-textarea w-full vs-textarea-primary">
                              <textarea class="vs-textarea" :disabled="true"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'priReasplaceToAnotWorksite'})">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Describe the reasons why placement at another worksite outside the petitioner, subsidiary, affiliate, or parent is needed<em v-if="petitionerQuestInfo.priReasplaceToAnotWorksite">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'priReasplaceToAnotWorksite'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'priReasplaceToAnotWorksite'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'priReasplaceToAnotWorksite'})">
                                <vs-checkbox
                              
                                v-model="petitionerQuestInfo.priReasplaceToAnotWorksite"
                                  @change="
                                      selectCheck({
                                        section: 'petitionerQuestInfo',
                                        key: 'priReasplaceToAnotWorksite',
                                      })
                                    "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            </div>
                            <div class="vs-con-textarea w-full vs-textarea-primary">
                              <textarea class="vs-textarea" :disabled="true"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'jobTitle'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Job Title<em v-if="petitionerQuestInfo.jobTitle">*</em></label>

                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'jobTitle'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'jobTitle'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'jobTitle'})">
                            
                             <vs-checkbox
                            
                             v-model="petitionerQuestInfo.jobTitle"
                             @change="
                               selectCheck({
                                 section: 'petitionerQuestInfo',
                                 key: 'jobTitle',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'workAddress'})">
                        <h3 class="small-header">
                          Work Address<em v-if="petitionerQuestInfo.workAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'petitionerQuestInfo',key:'workAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'workAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'workAddress'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.workAddress"
                            @change="
                              selectCheck({ section: 'petitionerQuestInfo', key: 'workAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="workAddress-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'itineraryPeti'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Did you include an itinerary with the petition?<em v-if="petitionerQuestInfo.itineraryPeti">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'itineraryPeti'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'itineraryPeti'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'itineraryPeti'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.itineraryPeti"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'itineraryPeti',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'everBenfWorkOffSiteAnothComp'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Will the beneficiary(ies) work for you offsite at another company or organization's location? <em v-if="petitionerQuestInfo.everBenfWorkOffSiteAnothComp">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'everBenfWorkOffSiteAnothComp'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'everBenfWorkOffSiteAnothComp'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'everBenfWorkOffSiteAnothComp'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.everBenfWorkOffSiteAnothComp"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'everBenfWorkOffSiteAnothComp',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'everBenfExcluCommonOrNorthIslands'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Will the beneficiary(ies) work exclusively in the Commonwealth of the Northern Mariana Islands (CNMI)?<em v-if="petitionerQuestInfo.everBenfExcluCommonOrNorthIslands">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'everBenfExcluCommonOrNorthIslands'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'everBenfExcluCommonOrNorthIslands'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'everBenfExcluCommonOrNorthIslands'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.everBenfExcluCommonOrNorthIslands"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'everBenfExcluCommonOrNorthIslands',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'fullTimePosition'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Is this a full-time position?<em v-if="petitionerQuestInfo.fullTimePosition">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'fullTimePosition'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'fullTimePosition'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'fullTimePosition'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.fullTimePosition"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'fullTimePosition',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'hoursPerWeek'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">How many hours per week for the position?<em v-if="petitionerQuestInfo.hoursPerWeek">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'hoursPerWeek'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'hoursPerWeek'})}">
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'hoursPerWeek'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.hoursPerWeek"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'hoursPerWeek',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'salary'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Wages<em v-if="petitionerQuestInfo.salary">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'salary'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'salary'})}">
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'salary'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.salary"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'salary',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'payFrequency'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Pay Terms<em v-if="petitionerQuestInfo.payFrequency">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'petitionerQuestInfo',key:'payFrequency'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'payFrequency'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'payFrequency'})">
                              <vs-checkbox
                              
                              v-model="petitionerQuestInfo.payFrequency"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'payFrequency',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select" :disabled="true">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'otherCompensation'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Other Compensation<em v-if="petitionerQuestInfo.otherCompensation">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'otherCompensation'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'otherCompensation'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'otherCompensation'})">
                              <vs-checkbox
                            
                              v-model="petitionerQuestInfo.otherCompensation"
                                @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo',
                                      key: 'otherCompensation',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-textarea w-full vs-textarea-primary">
                            <textarea class="vs-textarea" :disabled="true"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'dateOfIntendedEmpFrom'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Dates of intended employment from<em v-if="petitionerQuestInfo.dateOfIntendedEmpFrom">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'dateOfIntendedEmpFrom'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'dateOfIntendedEmpFrom'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'dateOfIntendedEmpFrom'})">
                              <vs-checkbox
                              
                              v-model="petitionerQuestInfo.dateOfIntendedEmpFrom"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'dateOfIntendedEmpFrom',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'petitionerQuestInfo',key: 'dateOfIntendedEmpTo'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Dates of intended employment to<em v-if="petitionerQuestInfo.dateOfIntendedEmpTo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo',key:'dateOfIntendedEmpTo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo',key:'dateOfIntendedEmpTo'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo',key:'dateOfIntendedEmpTo'})">
                              <vs-checkbox
                              
                              v-model="petitionerQuestInfo.dateOfIntendedEmpTo"
                              @change="
                                selectCheck({
                                  section: 'petitionerQuestInfo',
                                  key: 'dateOfIntendedEmpTo',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>












                     
                      
                    </div>
                  </div>
                </vs-col> 
                <!-- Petitioner documents -->
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  >
                  <div class="form-container pt-10 form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          List of documents needs to be updated
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                          </span>
                        </h3>
                        <label>USA Company documents</label>
                        <div class="documents_group case_documents">
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'incorporationCertDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Certificate of Incorporation<em v-if="petitionerQuestInfo.usaCompanyDocuments.incorporationCertDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'incorporationCertDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'incorporationCertDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'incorporationCertDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.incorporationCertDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'incorporationCertDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'amendmentCertDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Certificate of Amendment of Certificate of Incorporation <em v-if="petitionerQuestInfo.usaCompanyDocuments.amendmentCertDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'amendmentCertDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'amendmentCertDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'amendmentCertDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.amendmentCertDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'amendmentCertDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'stockCopyCertDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of stock certificates<em v-if="petitionerQuestInfo.usaCompanyDocuments.stockCopyCertDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'stockCopyCertDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'stockCopyCertDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'stockCopyCertDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.stockCopyCertDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'stockCopyCertDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'leaAgreeForPropOffice'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Lease Agreements for the proposed office <em v-if="petitionerQuestInfo.usaCompanyDocuments.leaAgreeForPropOffice">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'leaAgreeForPropOffice'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'leaAgreeForPropOffice'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'leaAgreeForPropOffice'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.leaAgreeForPropOffice"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'leaAgreeForPropOffice',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'curOrgaChart'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Current Organizational Chart<em v-if="petitionerQuestInfo.usaCompanyDocuments.curOrgaChart">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'curOrgaChart'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'curOrgaChart'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'curOrgaChart'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.curOrgaChart"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'curOrgaChart',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'propOrgaChart'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Proposed Organizational Chart<em v-if="petitionerQuestInfo.usaCompanyDocuments.propOrgaChart">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'propOrgaChart'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'propOrgaChart'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'propOrgaChart'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.propOrgaChart"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'propOrgaChart',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'l1AVisaBusiPlan'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >L1-A Visa Business Plan<em v-if="petitionerQuestInfo.usaCompanyDocuments.l1AVisaBusiPlan">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'l1AVisaBusiPlan'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'l1AVisaBusiPlan'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'l1AVisaBusiPlan'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.l1AVisaBusiPlan"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'l1AVisaBusiPlan',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'minOfBoardMeetings'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Minutes of Board Meetings<em v-if="petitionerQuestInfo.usaCompanyDocuments.minOfBoardMeetings">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'minOfBoardMeetings'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'minOfBoardMeetings'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'minOfBoardMeetings'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.minOfBoardMeetings"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'minOfBoardMeetings',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'contraExecOfCopyDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Copy of the contracts executed<em v-if="petitionerQuestInfo.usaCompanyDocuments.contraExecOfCopyDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'contraExecOfCopyDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'contraExecOfCopyDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'contraExecOfCopyDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.contraExecOfCopyDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'contraExecOfCopyDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'auditFinaStatMostRecent'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Most recent audited financial statements or Federal Tax Returns <em v-if="petitionerQuestInfo.usaCompanyDocuments.auditFinaStatMostRecent">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'auditFinaStatMostRecent'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'auditFinaStatMostRecent'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'auditFinaStatMostRecent'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.auditFinaStatMostRecent"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'auditFinaStatMostRecent',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'bankIndicAndBal'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Letter from bank indicating status and balance<em v-if="petitionerQuestInfo.usaCompanyDocuments.bankIndicAndBal">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'bankIndicAndBal'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'bankIndicAndBal'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'bankIndicAndBal'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.bankIndicAndBal"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'bankIndicAndBal',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.usaCompanyDocuments',key: 'productDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Product Documents<em v-if="petitionerQuestInfo.usaCompanyDocuments.productDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.usaCompanyDocuments',key:'productDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'productDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.usaCompanyDocuments',key:'productDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.usaCompanyDocuments.productDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.usaCompanyDocuments',
                                      key: 'productDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="documents_group case_documents mb-2">
                          <label class="mb-5">Foreign Company documents</label>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.foreignCompanyDocuments',key: 'taxReturns'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Income tax Returns <em v-if="petitionerQuestInfo.foreignCompanyDocuments.taxReturns">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'taxReturns'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'taxReturns'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'taxReturns'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.foreignCompanyDocuments.taxReturns"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.foreignCompanyDocuments',
                                      key: 'taxReturns',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.foreignCompanyDocuments',key: 'bankStatements'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Bank Statements<em v-if="petitionerQuestInfo.foreignCompanyDocuments.bankStatements">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'bankStatements'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'bankStatements'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'bankStatements'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.foreignCompanyDocuments.bankStatements"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.foreignCompanyDocuments',
                                      key: 'bankStatements',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.foreignCompanyDocuments',key: 'verifyOrSupportLetter'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Verification/Support Letter <em v-if="petitionerQuestInfo.foreignCompanyDocuments.verifyOrSupportLetter">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'verifyOrSupportLetter'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'verifyOrSupportLetter'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'verifyOrSupportLetter'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.foreignCompanyDocuments.verifyOrSupportLetter"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.foreignCompanyDocuments',
                                      key: 'verifyOrSupportLetter',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.foreignCompanyDocuments',key: 'orgnaStructureDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Organization Structure<em v-if="petitionerQuestInfo.foreignCompanyDocuments.orgnaStructureDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'orgnaStructureDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'orgnaStructureDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'orgnaStructureDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.foreignCompanyDocuments.orgnaStructureDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.foreignCompanyDocuments',
                                      key: 'orgnaStructureDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'petitionerQuestInfo.foreignCompanyDocuments',key: 'proAndLossStatDocs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Profit and Loss Statements of Foreign Company <em v-if="petitionerQuestInfo.foreignCompanyDocuments.proAndLossStatDocs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'proAndLossStatDocs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'proAndLossStatDocs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'petitionerQuestInfo.foreignCompanyDocuments',key:'proAndLossStatDocs'})">
                                        <vs-checkbox
                                      
                                        v-model="petitionerQuestInfo.foreignCompanyDocuments.proAndLossStatDocs"
                                  @change="
                                    selectCheck({
                                      section: 'petitionerQuestInfo.foreignCompanyDocuments',
                                      key: 'proAndLossStatDocs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>








                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <vs-popup
      class="holamundo success-popups"
      title="Your registration is complete."
      :active.sync="SuccessQuestionnaire"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire submitted successfully!</h2>
      <p>
        It will be reviewed by the petitioner and appropriate actions will be taken soon.
      </p>
    </vs-popup>

    <vs-popup
      class="holamundo success-popups"
      title="Template configuration complete."
      :active.sync="showFinalsubmitPopup"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire template submission!</h2>
      <p>Are you sure to continue?</p>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="showFinalsubmitPopup = false"
          >Cancel</vs-button
        >
        <vs-button color="success" class="save ml-3" type="filled" @click="saveMe(true)"
          >Yes</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import Datepicker from "vuejs-datepicker-inv";
import immiMask from "@/views/forms/fields/maskinput.vue";
import "vue2-datepicker/index.css";
import immiuploader from "@/views/forms/fields/fileupload.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import immitextarea from "@/views/forms/fields/simpletextarea.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
import immiPhone from "@/views/forms/fields/phonenumber.vue";
import immiyesorno from "@/views/forms/fields/yesorno.vue";
import addressField from "@/views/forms/fields/address.vue";
import { InfoIcon } from "vue-feather-icons";
import { EyeIcon } from "vue-feather-icons";
import Multiselect from "vue-multiselect-inv";
import { Trash2Icon } from "vue-feather-icons";
import _ from "lodash";
import QuestTempDocumentComp from "@/views/Questionnaire/QuestTempDocumentComp.vue";


export default {
  props: {
    templateId: {
      default: "",
    },
    isEdit:true,
    entityType:''
  },
  beforeDestroy() {
    this.SuccessQuestionnaire = false;
    document.removeEventListener("click", this.reloadthePage);
  },
  data() {
    return {
      eFileTagsList:[],
      sampleData:{
          key: "resume",
          lebel: "",
          required: false,
          description: "",
          fieldRequired:false,
          section: "documents",
        },
      currentTab: 'Personal Info',
      tabslist: [{
                        key: "casedetails",
                        name: "Personal Info"
                    }
    
                ],
      SuccessQuestionnaire: false,
      showFinalsubmitPopup: false,
      beneficiaryInfo: {
        benfAssets:{
          benfAssets:true,
          firstName: true,
          lastName: true,
          middleName: true,
          typeOfAsset: true,
          amount: true
        },
        benfIncome:{
          benfIncome:true,
          firstName: true,
          lastName: true,
          middleName: true,
          dateOfBirth: true,
          relToTheBenf: true,
          amount: true
        },
       
        houseHoldNumber:true,
        houseHoldAnnualIncome:true,
        houseHoldAnnualAssets:true,
        houseHoldAnnualliabilities:true,
        inadmissibility:true,
        highestDegreeCompleted:true,
        listOfCertifications:true,
        SSI:true,
        benefitsRecAmounts:{
          benefitReceived: true,
          startDate: true,
          endDate: true,
          amount: true
        },
        longTermInstiAtGovtExpense:true,
        periodOfInstutions:{
          institutionName:true,
          stateDetails:true,
          locationDetails:true,
          dateFrom:true,
          dateTo:true,
          reason:true,
        },
        illegalGamblingOrDrug:true,
        illegalActivityOrSource:true,
        beneficiaryCnfmNumber:false,
        // L1 Visa Fields Starts
        typeOfOffice:true,
        officeAddress:true,
        // L1 Visa Fields Ends
        // i-485 new fields starts
        i485AdditionalInformation:true,
        everDeniedAdmissionInUS: true, // 14.Have you EVER been denied admission to the United States?
        isVisaDenieedTOUS: true, /// 15.HAVE YOU EVER BEEN DENIED A VISA TO THE UNITED STATES?
        everWorkedInUSWithoutAuth: true, // 16. Have you EVER worked in the United States without authorization?
        everViolatedTandCofYourNonImmStatus: true, // 17. Have you EVER violated the terms or conditions of your nonimmigrant status?
        everBeenInRemovalExcl: true, // 18. Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?
        everBeenIssuedOrderExclRemoval: true, // 19. Have you EVER been issued a final order of exclusion, deportation, or removal?
        everHadPriorOrderExclDeport: true, // 20. Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?
        
        everHeldPermResidentStatus: true, //21.Have you EVER held lawful permanent resident status which was later rescinded?
        everGrantedVolDepartimmgOfficer: true,//22.Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?
        everAppliedReliefOrExclDeport: true,//23.Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?
        everJNonImmmExchangeVistor: true,//24.a. Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?
        //if 24.a yes
        everCompailedForeignResi: true, //24.b Have you complied with the foreign residence requirement?
        everGrantedWavierRecomndLtr: true, //24.c Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you? 
        
        //Criminal Acts and Violations
        everArrested: true, //25. Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?
        everCommittedCrime: true, //26.Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? 
        everPledGuilty: true, //27.Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?
        everPunishedByJudge: true, //28.Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?
        everAccusedCrimProc: true, //29.Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? 
        everViolated: true, //30.Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country?
        everConvictedTwoOrMoreOffens: true,//31.Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years ormore?
        everIlleglTraf: true, //32.Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?
        everKnowinglyIlleglTraf: true, //33.Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?
        everSpouseSondaughterIlleglTraf: true,//34. Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?
        everEngageProst: true,//35.Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?
        everdirOrIndirectProst: true, //36.Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?
        everReceiveMoneyFronProst: true, //37.Have you EVER received any proceeds or money fromprostitution?
        everIntentIllegalGamblUS: true, //38.Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?
        everImmunityCriminalOffensedInUS: true, //39.Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?
        everViolateReliFreedomAsForeignGovOffi: true,//40. Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?
        everForceFraudCommercialSexActs: true,//41.Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?
        everTraffPersonIntoInvolSlavery: true, //42.Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.
        everKnowWithTraffPersonCommSexAct: true, //43.Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?
        everSpouseSonDughterEngTraffAnyFinBef: true,//44.Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?
        everEngMoneyLaundering: true,//45.Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?
        
        //Security and Related
        everViolateEvidenceLawRelatedInUS: true,//46.a. Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?
        everViolateExpGoodsSensInfoTechInUS: true,//46.b. Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? 
        everOverthrowingUSGovtByForceViolence: true,//46.c. Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?
        everActivityDangerScurityOfUs: true,//46.d.Engage in any activity that could endanger the welfare,safety, or security of the United States? 
        everEngUnlawfulActivity: true,//46.e.Engage in any other unlawful activity?
        everEngActSeriousForeignPolicyforUs: true,//47.Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?
        everCommitedKidnapHjkEtc: true,//48.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? 
        everCommMemberGrpOrgKidnapHjkEtc: true, //48.b. Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? 
        everAskMoneyRecruGrpKidnapHijackEtc: true, //48.c.Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?
        everProvideMoneyForAssiKidnapHjkEtc: true, //48.d.Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? 
        everProvideMoneyForAssiIndiGrpKidnapHjkEtc: true,//48.e. Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?
        everTraiParaOrMilataryWepons: true,//49.Have you EVER received any type of military,paramilitary, or weapons training? 
        everEngKidnapHjkEtc: true,//50.Do you intend to engage in any of the activities listed in any part of Item Numbers 48.a. - 49.?
        //if answered yes items b/w 46.a to 50
        //Additional info
        everSpoOrChiEngKidnapHjkEtc: true,//51.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property? 
        everHSpoOrChiPartMemberKidnapHjkEtc: true, //51.b. Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? 
        everSpoOrChiRecrutKidnapHjkEtc: true, //51.c. Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? 
        everSpoOrChiAskMoneyAssiKidnapHjkEtc: true,//51.d. Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.? 
        everSpoOrChiForAssiIndiGrpKidnapHjkEtc: true,//51.e. Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.? 
        everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc: true,//51.f. Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.? 
        //if answered yes items of 51
        //Additional info
        everSellProvideTransWepon: true,//52. Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?
        everWorkedPrisionAndDetained: true,//53. Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?
        everUsingWeponPartGrpOrgThreatPerson: true,//54.Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?
        everServedParaOrMilataryEtc: true,//55.Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?
        everMemberCommPartyInUS: true,//56.Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?
        ever080545To230393AssoNaziGerGov: true,//57.During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?
        everInvolveTorture: true,//58.a. Acts involving torture or genocide?
        everKillAnyPerson: true,//58.b.Killing any person?
        everSeverInjuAnyPerson: true,//58.c.Intentionally and severely injuring any person?
        everEngAnySexualContent: true,//58.d. Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?
        everLimitReligBnf: true,//58.e. Limiting or denying any person's ability to exercise religious beliefs?
        everUsedBelow15yrsPerson: true,//59.Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?
        everHelpUnder15yrsPerson: true,//60. Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?
        //if answered yes items b/w 52 to 60
        //Public Assistance
        everRcvPublicAssiInUS: true,//61.Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?
        everFutureRcvPublicAssiInUs: true,//62.Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?
        //Illegal Entries and Other Immigration Violations
        everAttenRmvProcFiledAfter010497: true,//63.a. Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?
        everRmvProcFiledReason: true,//63.b. If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?
        rmvProcFiledResonWriteStmt: true,//63.c.If your answer to Item Number 63.b. is "Yes," attach a written statement explaining why you had reasonable cause.
        everSubmitFraudDocUSGov: true,//64.Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?
        everLiedMisrepreInfoEnterUS: true,//65.Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?
        everClaimFlaslyUSCitizen: true,//66.Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?
        everStowawayOnVessel: true,//67.Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?
        everTrytoEnterUsIllegaly: true,//68. Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?
        everFinalOrderCivilPenalty: true,//69. Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?
        //Removal, Unlawful Presence, or Illegal Reentry After Previous Immigration Violations
        everRemovedfromUs: true,//70. Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?
        everEnterUSWithoutInspAdmit: true, //71.Have you EVER entered the United States without being inspected and admitted or paroled?
        everSince010497More180DLessYrULFStayUS: true,//72.a. For more than 180 days but less than a year, and thendeparted the United States?
        everSince010497YrOrMoreULFDepartUS: true,//72.b.For one year or more and then departed the United States?  
        everSince010497ReEntMoreYrULFStayUS: true,//73.a.Having been unlawfully present in the United States for more than one year in the aggregate?
        everSince010497RmvFromUS: true,//73.b.Having been deported, excluded, or removed from the United States?
        //Miscellaneous Conduct
        planForPractPolyInUS: true,//Do you plan to practice polygamy in the United States?
        AreYouAccomOtherCountry: true,//75.Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?
        everAnyUsChildUnderCustody: true,//76. Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?
        everVoilationAnyFedaral: true,//77.Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?
        everUsCtzshipAvoidTax: true,//78.Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?
        everAppliedForExemptServiceUS: true,//79.a. Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?
        everReliServTrainAreYouForeignNation: true,//79.b. Been relieved or discharged from such training or serviceon the ground that you are a foreign national?
        everConvictDestUSArmedForce: true,//79.c. Been convicted of desertion from the U.S. armed forces?
        everRemOutsideUSAviodTrainArmedForce: true,//80.a. Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?
        nationImgrstaIfAviodTrainArmForcUS: true,//80.b. If your answer to Item Number 80.a. is “Yes,” what was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)?
        criminalActsAndViolationsAddiInfo:true,
        genEligAndInadmisGroundsQ46aTo50AddiInfo:true,
        genEligAndInadmisGroundsQ52To60AddiInfo:true,
        genEligAndInadmisGroundsQ51AddiInfo:true,
        // i-485 fields end
        anyOtherPersonEmployedInUS:true,
        hasAnyDependetsinUStoFileH4:true,
        haveYouEverEmployed:true,
          appliedAOSInUSDocs:true,
          associations: [{
          name:true, 
              address:{
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
              },
          startDate: true,
          endDate:true,
          natureofAssociations:true,
          }],
          previousSpouse: {
            previousSpouse:true,
            firstName: true,
            middleName: true,
            lastName: true,
            dateOfBirth: true,
            dateOfMarriage: true,
            dateOfMarriageEnd: true,
            maidenName: true,
            //Place of Marriage
            countryOfMarriage: true,
            countryOfMarriageDetails: true,
            provinceOfMarriage: true,
            provinceOfMarriageDetails: true,
            locationOfMarriage: true,

            //Place of Termination
            countryOfMarriageTermination: true,
            countryOfMarriageTerminationDetails: true,
            provinceOfMarriageTermination: true,
            provinceOfMarriageTerminationDetails: true,
            locationOfMarriageTermination: true,
            obtainPermResidenceThroughSpouse: true,
            marriageEndedDueTo: true,
            marriageEndedOtherInfo: true,
          },
          curNonImmigrantVisaNumber:true, 
          curNonImmigrantVisaCategory : true,  
          doesBirthRegistered:true, 
          isVisaDenieedTOUS:true,
          visaDeniedReason:true,
          haveYoueverPresntUnlawfully:true,
          presntUnlawfullyReason:true,
          haveYouEverReceivedPublicAssistendeInUS:true,
          haveYouEverlikelyReceivePublicAssistendeInUS:true,
          eadCard:true,
          everAppliedAOSInUS: true,
          appliedAOSInUSDocs:true,
          haveYouArrestedBefore:true, 
          haveYouArrestedBeforeDocs:true, 
          maritalStatusDetails:true,
          haveYouEverTravelledToUS:true,
          currentlyInUS: true,
          haveOwnershipInterest: true,
          ownershipInterestDesc: true,
          haveYouEverAppliedH1bCase: true,
          prevH1bCaseStatus:true,
          prevH1bCaseDesc: true,
          anyImmPetitionFiledDesc:true,
          consulateInfo: {
              locationId: true,
              locationDetails: true,
              stateId: true,
              stateDetails: true,
              countryId: true,
              countryDetails: true
          },
          alienNumber: true,
          lastArrivalNumber: true,
          placeOfLastEntryInUS: true,
          hasMasterDegreeInUS:true,
          educations: [{
              _id: 0,
              name: true,
              address: {
                  line1: true,
                  line2: true,
                  aptType: true,
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
                  zipcode: true,
                 
              },
              highestDegree: true,
              highestDegreeDetails: true,
              majorFieldOfStudy: true,
              attendedFrom: true,
              attendedTo: true,
              graduatedYear: true,
              degreereceived: true,
              isAccredited: true,
              isForProfit: true,
              graduatedDate:true
          }],
          nonImmPetitionsInfo: [{
              _id: 0,
              visaStatus: true,
              visaStatusDetails: true,
              receiptNo: true,
              petitionerName: true,
              validFrom:true,
              validTo:true,
          }],
          h1bImmPetitionsInfo: [{
              typeId:true,
              _id: 0,
              typeId: true,
              typeDetails: true,
              receiptNo: true,
              petitionerName: true,
              validFrom:true,
              validTo:true,
          }],     
          didThisPtnrFliedImmPetitionEarlier:true,
          anyImmPetitionFiled: true,
          immPetitionInfo: {
              anyOtherAlienFiled: true,
              filedNumber: true,
              employerName: true,
              rirOrRegularProcessing: true,
              filedStateId: true,
              filedStateDetails: true,
              applCurStatus: true,
              seekingFiledtrueforETA750: true,
              anyI140Filed: true,
              i140Info: {
                  fieldNumber: true,
                  employerName: true,
                  priorityNumber: true,
                  eb2orEb3: true,
                  currentStatus: true
              }
          },
          prevEmploymentInfo: [{
              _id: 0,
              employerName: true,
              address: {
                  line1: true,
                  line2: true,
                  aptType: true,
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
                  zipcode: true
              },
              businessType: true,
              jobTitle: true,
              jobDuties: true,
              startDate: true,
              endDate: true,
              salary:true,
              payFrequency:true,
              currentEmployer: true,
          }],
          prevEmploymentOutsideUS:[{
              _id: 0,
              employerName:true,
              address: {
                  line1: true,
                  line2: true,
                  aptType: true,
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
                  zipcode: true
              },
              businessType: true,
              jobTitle: true,
              jobDuties: true,
              startDate: true,
              endDate: true,
              salary:true,
              payFrequency:true,
              currentEmployer: true ,
          }],
          
          addressOutsideUS: {
              line1: true,
              line2: true,
              aptType: true,
              locationId: true,
              locationDetails: true,
              stateId: true,
              stateDetails: true,
              countryId: true,
              countryDetails: true,
              zipcode: true
          },
    
          name: true,
          firstName: true,
          middleName: true,
          lastName: true,
          hasOtherNames: true,
          otherNames: [{
              _id: 0,
              name: true,
              firstName: true,
              middleName: true,
              lastName: true,
          }],
          gender: true,
          email: true,
          education: {
              highestDegree: true,
              highestDegreeDetails: true,
              majorFieldOfStudy: true
          },
          maritalStatus: true,
          // GC 485 fields start
          noOfChildrens: true,
          noOfTimesMarriedBeneficiary:true,
          dateOfMarriage: true,
          countryOfMarriage: true,
          countryOfMarriageDetails: true,
          provinceOfMarriage: true,
          provinceOfMarriageDetails: true,
          locationOfMarriage: true,
          doYouHaveMarriageCert: true ,
          appliedAOSInUSDocs:true,
          marriageCertDocs: true,
          have2AffidavitsAttestingToMarriage: true,
          nameDiffFromBirthCert:true,
          have2AffidavitsOfBirthFamily:true,
          birthCertHaveNamePobDob:true,
          birthCertHaveNamePobDob:true,
          have2AffidavitsOfBirthFamily:true,
          previouslyMarried:true,
          
        
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          countryOfCitizenship: true,
          countryOfCitizenshipDetails: true,
          I94: true,
          I94ExpiryDate: true,
          I94StatusName:true,
          
          height: {
          feet: true,
          inches: true
          },
              weight: true,
              race: {
                  id: true,
                  name: true
              },
              eyeColor: {
                  id: true,
                  name: true
              },
              hairColor: {
                  id: true,
                  name: true
              },
              firstArrivalDate: true,
              lastArrivalDate: true,
              reasonOfLastArrival: true,
              stateOfLastEntryInUS: true,
              stateDetailsOfLastEntryInUS: true,
              placeOfLastEntryInUS: true,
              caseIssuedDate: true,
              caseExpiryDate: true,
              placeOfCaseIssued: true,
              // i140PriorityDate:true,
              classification:true,
              // GC 485 fields end
              homePhoneNumber: true,
              homePhoneCountryCode: {
                  countryCode: true,
                  countryCallingCode: true
              },
              cellPhoneNumber: true,
              cellPhoneCountryCode: {
                  countryCode: true,
                  countryCallingCode: true
              },
              // GC 485 fields start
              noOfChildrens: true,
              dateOfMarriage: true,
              countryOfMarriage: true,
              countryOfMarriageDetails: true,
              provinceOfMarriage: true,
              provinceOfMarriageDetails: true,
              locationOfMarriage: true,
              doYouHaveMarriageCert: true ,
              appliedAOSInUSDocs:true,
              marriageCertDocs: true,
                        have2AffidavitsAttestingToMarriage: true,
                        nameDiffFromBirthCert:true,
                        have2AffidavitsOfBirthFamily:true,
                        birthCertHaveNamePobDob:true,
                        birthCertHaveNamePobDob:true,
                        have2AffidavitsOfBirthFamily:true,
                        previouslyMarried:true,
                        
                      
                        dateOfBirth: true,
                        countryOfBirth: true,
                        countryOfBirthDetails: true,
                        provinceOfBirth: true,
                        provinceOfBirthDetails: true,
                        locationOfBirth: true,
                        countryOfCitizenship: true,
                        countryOfCitizenshipDetails: true,
                        I94: true,
                        I94ExpiryDate: true,
                        sevisNumber: true,
                        eadNumber: true,
                        isI94DSExpiryDate:true,
                        I94StatusName:true,
                        
                        height: {
                        feet: true,
                        inches: true
                        },
                        weight: true,
                        race: {
                            id: true,
                            name: true
                        },
                        eyeColor: {
                            id: true,
                            name: true
                        },
                        hairColor: {
                            id: true,
                            name: true
                        },
                        firstArrivalDate: true,
                        lastArrivalDate: true,
                        reasonOfLastArrival: true,
                        stateOfLastEntryInUS: true,
                        stateDetailsOfLastEntryInUS: true,
                        placeOfLastEntryInUS: true,
                        caseIssuedDate: true,
                        caseExpiryDate: true,
                        placeOfCaseIssued: true,
                        i140PriorityDate:true,
                        classification:true,
                        // GC 485 fields end
                        homePhoneNumber: true,
                        homePhoneCountryCode: {
                            countryCode: true,
                            countryCallingCode: true
                        },
                        cellPhoneNumber: true,
                        cellPhoneCountryCode: {
                            countryCode: true,
                            countryCallingCode: true
                        },
                        // GC 485 fields start
                        allIssuedpassportData: [{
                            countryId: true,
                            countryDetails: true,
                            number: true,
                            issuedDate: true,
                            expiryDate: true 
                        }],
                        curVisaExpiryDate:true,
                        isDSExpiryDate:true,
                        dateFromWhichResideInUs:true,
                        inspectedByAnyImmOfficer:true,
                        issuedAnyEADFromUSCIS:true,
                        enterInUSUnderCaseWaiverProgram:true,
                        hasPermResidencyInOtherCountry:true,
                        permResidencyCountryId:true,
                        permResidencyCountryDetails:true,
                       
                        iAmFromUS: true,
                        mailingAddressIsSameAsAddress:true,
                          mailingAddress: {
                              line1: true,
                              line2: true,
                              aptType: true,
                              locationId: true,
                              locationDetails: true,
                              stateId: true,
                              stateDetails: true,
                              countryId: true,
                              countryDetails: true,
                              zipcode: true
                          },
                          currentAddress:{
                            line1: true,
                            line2: true,
                            aptType: true,
                            locationId: true,
                            locationDetails: true,
                            stateId: true,
                            stateDetails: true,
                            countryId: true,
                            countryDetails: true,
                            zipcode: true
                        },
                        address: {
                            line1: true,
                            line2: true,
                            aptType: true,
                            locationId: true,
                            locationDetails: true,
                            stateId: true,
                            stateDetails: true,
                            countryId: true,
                            countryDetails: true,
                            zipcode: true
                        },
                        addressOfLastNYears: [{
                            line1: true,
                            line2: true,
                            aptType: true,
                            locationId: true,
                            locationDetails: true,
                            stateId: true,
                            stateDetails: true,
                            countryId: true,
                            countryDetails: true,
                            zipcode: true,
                            startDate: true,
                            endDate: true,
                        }], 
                        addressOutsideUSMoreThanYear:[{
                            line1: true,
                            line2: true,
                            aptType: true,
                            locationId: true,
                            locationDetails: true,
                            stateId: true,
                            stateDetails: true,
                            countryId: true,
                            countryDetails: true,
                            zipcode: true,
                            startDate: true,
                            endDate: true,
                        }],
                        consulateNotifyAddress: true,
                        SSN: true,
                        hasI140ImmPetitionFiled: true,
                        I140ImmPetitionFiledDetails: true,
                        passportNumber: true,
                        passportIssuedNumber: true,
                        passportExpiryNumber: true,
                        curNonImmigrantVisaStatus: true,
                        curNonImmigrantVisaStatusDetails: true,
                        curVisaExpiryNumber: true,
                        sevisNumber: true,
                        eadNumber: true,
                        priorPeriodOfStayInUS: [{
                            _id: 0,
                            enteredNumber: true,
                            departedNumber: true,
                            visaStatus: true,
                            visaStatusDetails: true,
                            noOfDays: true,
                            dateerror: true
                        }],
                        noOfDaysStayInUS: true,
                        confirmDaysStayInUS: true,
                        hasApprovedI140: true,
                        hasPermPendingForMorethan365Days: true,
    
                         //i140
                         passportIssuedCountry:true,
                         passportIssuedCountryDetails:true,
                        immPetitionPriorityDate: true, // list your Priority Date obtained from your previous immigrant petition
                        applyI485AdjOrConsuProcess: true, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },
                        adjustmentOfI485Status: true, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                        consularProcessing:true,// Consular Processing { type: Boolean, default: false },
                        areYouUnderRemoveOfIndOrUscis: true, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },
                        anyImmPetitionFiled:true,
                    },
      fatherInfo:{
        name: true,
    firstName: true,
    middleName: true,
    lastName: true,
    hasOtherNames: true,
    otherNames: [{
        _id: 0,
        name: true,
        firstName: true,
        middleName: true,
        lastName: true,
    }],
    dateOfBirth: true,
    countryOfBirth: true,
    countryOfBirthDetails: true,
    provinceOfBirth: true,
    provinceOfBirthDetails: true,
    locationOfBirth: true,
    currentAddress: true,
    isUSCitizen: true,
    dateFromUSCitizen: true,
    nameAtBirth:{
        firstName: true, 
        middleName: true, 
        lastName: true,
    },
    deceasedCity: true,
    deceasedCityDetails:true,
    deceasedDate: true,
      },
      motherInfo:{
        name: true,
    firstName: true,
    middleName: true,
    lastName: true,
    hasOtherNames: true,
    otherNames: [{
        _id: 0,
        name: true,
        firstName: true,
        middleName: true,
        lastName: true,
    }],
    dateOfBirth: true,
    countryOfBirth: true,
    countryOfBirthDetails: true,
    provinceOfBirth: true,
    provinceOfBirthDetails: true,
    locationOfBirth: true,
    currentAddress: true,
    isUSCitizen: true,
    dateFromUSCitizen: true,
    nameAtBirth:{
        firstName: true, 
        middleName: true, 
        lastName: true,
    },
    deceasedCity: true,
    deceasedCityDetails:true,
    deceasedDate: true,
      },
      documents: {
      //  new I-130 documents
      sponsorSpousePassport:true,
      sponsorSpouseMarriageCertificate:true,
      sponsorSpouseBirthCertificate:true,
      sponsorSpouseMarriagePhotographs:true,
      sponsorSpouseMartialRelationship:true,
      sponsorSpousePhotographs:true,
      sponsorFatherPassport:true,
      sponsorFatherBirthCertificate:true,
      sponsorFatherParentsMarriageCertificate:true,
      sponsorMotherPassport:true,
      sponsorMotherBirthCertificate:true,
      sponsorSiblingPassport:true,
      sponsorSiblingBirthCertWithParents:true,
      sponsorSiblingBirthCertificate:true,
      sponsorSiblingBffidavits:true,
      sponsorChildPassport:true,
      sponsorChildBirthCertWithParents:true,
      sponsorChildBirthCertificate:true,
      // ends
        eadCard:true,
        bnfSpouseLatestI797: true,
        bnfSpousePassport: true,
        bnfSpouseRecentPayStubs: true,
        bnfSpouseFormAllI20: true,
        slgOfferLetter:true,
        slgSignedOfferLetter:true,
        marriageCertificate: true,
        underlyingLaborApplications: true,
        mostRecentTaxTranscrips: true,
        resume: true,
        education: true,
        expLetters: true,
        INSNotices: true,
        I140ApprovalNotice: true,
        passport: true,
        passportVisaI94: true,
        formI20: true,
        socialSecurityCardAndProfLicense: true,
        other: true,
        payStubs: true,
        offerLetter: true,
        clientLetter: true,
        vendorLetter: true,
        msa: true,
        po: true,
        beneficiaryDocs: true,
        h1bRegSelectionNotice: true,
        employmentAgreement: true,
        primeVendor: true,
        formI94: true,
        priorFormI797: true,
        I797NoticeofApprovalforI140: true,
        ead: true,
        w2: true,
        birthCertificate: true,
        photographs: true,
        medicalExamins: true,
        dependentForI134: true,
        dependentTaxReturns: true,
        bankStatements: true,
        evidenceOfContinuVisaStatus: true,
        evidenceOfFilePetitionBefore30Apr2001: true,
        proofOfIncomeOrAsset: true,
        proofOfMedicalInsurence: true,
        recentCreditReport: true,
        permResidence: true,
        empAuth: true,  
        capSelectNotice:true,
        slgResume: true,
        slgCollegeDegreesCert: true,
        slgTransScripts: true,
        slgExpLetters: true,
        slgPassportAndVisa: true,
        slgI94: true,
        slgPrevNonimmApprovalNotices: true,
        slgPrevImmApprovalNotices: true,
        slgI140OrPermNoties: true,
        slgPrevLaborApplications: true,

        slgAckOfPrevLaborApplications: true,
        slgPaystubs: true,
        slgI20: true,
        slgEad: true,
        slgEvalOfEduCredentials: true,
        slgEvalOfEduExpCredentials:true,

        formI797H4ApprovalNotice: true,
        formI797H1BApprovalNoticePrinNonCtzn: true,
        passportOfPrinNonCtzn: true,
        last3MonthsPayslipsOfPrinNonCtzn: true,
        marriageCertificate: true,
        h4Ead: true,
        // L1 case fields
        last12MonthsPayslips: true, // Beneficiary’s Pay Slips (past 12 months)
        proExecOrmanagerial: true, // Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.) (only for L1A)
        copyOfVeriPoliBenfApproved: true, //Copies of various policies Beneficiary approved
        copyOfContExecByBeneficiary: true, //Copies of Contracts executed by Beneficiary (only for L1A)
        copyOfBoardMinBenfPlayRole: true, // Copies of Board Minutes where Beneficiary played a role (only for L1A)
        payRevisionLetters: true, // Pay Revision Letters (Exhibit 14) (only for L1A)
        leaveAppliForms: true, // Leave Application Forms (Exhibit 14) (only for L1A)
        manageManPowerReq: true, // Manage Manpower Request (Exhibit 14) (only for L1A)
        offerLetterFromUSComp: true, // Offer letter from the US Company
        empAgreementFromUSComp: true, //Employment Agreement from the US Company,
        offerLetterFromForeComp: true, // Offer letter from the Foreign Company
        empAgreementFromForeComp: true, // Employment Agreement from the Foreign Company
        trainingCert: true, // Training Certificate (only for L1B) optional
        proofOfSpecKnowledge: true, // Proof of specialized knowledge (Note: Technical and functional knowledge) (only for L1B)
        spbAllCollegeDegree: true,
        spbAllMastOrBachMarkSheets: true,
        spbSubmitAllI20: true,
        spbSubSpouseOrI194OrlastTwoPays: true,
        spbSubMostRecAppOrI194OrTwoStatements: true,

      },

      dependentsInfo: {
        spouse: {
          inadmissibility:true,
          highestDegreeCompleted:true,
          listOfCertifications:true,
          SSI:true,
          benefitsRecAmounts:{
            benefitReceived: true,
            startDate: true,
            endDate: true,
            amount: true
          },
          longTermInstiAtGovtExpense:true,
          periodOfInstutions:{
            institutionName:true,
            stateDetails:true,
            locationDetails:true,
            dateFrom:true,
            dateTo:true,
            reason:true,
          },
          maidenName:true,
          hasSpouse:true,
          mailingAddressIsSameAsAddress:true,
          gender:true,
          sevisNumber: true,
          eadNumber: true,
          haveYouEverTravelledToUS:true,
          isI94DSExpiryDate:true,
          anyOtherPersonEmployedInUS:true,
          haveYouEverEmployed:true,
          h4EadPhotoEmailStmt:true,
            isDSExpiryDate:true, 
            prevEmploymentInfo: [{
              _id: 0,
              employerName: true,
              address: {
                  line1: true,
                  line2: true,
                  aptType: true,
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
                  zipcode: true
              },
              businessType: true,
              jobTitle: true,
              jobDuties: true,
              startDate: true,
              endDate: true,
              salary:true,
              payFrequency:true,
              currentEmployer: true,
          }],
          prevEmploymentOutsideUS:[{
              _id: 0,
              employerName:true,
              address: {
                  line1: true,
                  line2: true,
                  aptType: true,
                  locationId: true,
                  locationDetails: true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
                  zipcode: true
              },
              businessType: true,
              jobTitle: true,
              jobDuties: true,
              startDate: true,
              endDate: true,
              salary:true,
              payFrequency:true,
              currentEmployer: true ,
          }],
          race: {
          id: true,
          name: true,
        },
        addressOfLastNYears: [{
                line1: true,
                line2: true,
                aptType: true,
                locationId: true,
                locationDetails: true,
                stateId: true,
                stateDetails: true,
                countryId: true,
                countryDetails: true,
                zipcode: true,
                startDate: true,
                endDate: true,
            }], 
            addressOutsideUSMoreThanYear:[{
                line1: true,
                line2: true,
                aptType: true,
                locationId: true,
                locationDetails: true,
                stateId: true,
                stateDetails: true,
                countryId: true,
                countryDetails: true,
                zipcode: true,
                startDate: true,
                endDate: true,
            }],
            previousSpouse:{
                // hasOtherNames:true,
                // otherNames: [{
                //     _id: 0,
                //     name: true,
                //     firstName: true,
                //     middleName: true,
                //     lastName: true,
                // }],
                previousSpouse:true,
                maidenName:true,
                marriageEndedDueTo:true,
                firstName: true,
                middleName: true,
                lastName: true,
                dateOfBirth: true,
                dateOfMarriage:true,
                dateOfMarriageEnd:true,

                  //Place of Marriage
                countryOfMarriage: true,
                countryOfMarriageDetails: true,
                provinceOfMarriage: true,
                provinceOfMarriageDetails: true,
                locationOfMarriage: true,

                //Place of Termination
                countryOfMarriageTermination: true,
                countryOfMarriageTerminationDetails: true,
                provinceOfMarriageTermination: true,
                provinceOfMarriageTerminationDetails: true,
                locationOfMarriageTermination: true,
                obtainPermResidenceThroughSpouse:true,  
                marriageEndedDueTo:true,
                marriageEndedOtherInfo:true,
            },
            dateOfLastEntryInUS:true,
            haveYoueverPresntUnlawfully:true,
            presntUnlawfullyReason:true,
            haveYouEverReceivedPublicAssistendeInUS:true,
            haveYouEverlikelyReceivePublicAssistendeInUS:true,
            everAppliedAOSInUS: true,
            appliedAOSInUSDocs:true,
            haveYouArrestedBefore:true,
            haveYouArrestedBeforeDocs:true,
            doesBirthRegistered:true,
            curNonImmigrantVisaNumber:true,
           
            enterInUSUnderCaseWaiverProgram: true,
            inspectedByAnyImmOfficer: true,
            issuedAnyEADFromUSCIS: true,
            hasPermResidencyInOtherCountry:true,
            permResidencyCountryId: true,
            permResidencyCountryDetails: true,
          visaDeniedReason:true,
          isVisaDenieedTOUS:true,
          hasPermResidencyInOtherCountry: true,
          permResidencyCountryId: true,
          permResidencyCountryDetails: true,
            everAppliedAOSInUS:true,
            associations:[ {
              name:true,
              address:{
                  locationId: true,
                  locationDetails:true,
                  stateId: true,
                  stateDetails: true,
                  countryId: true,
                  countryDetails: true,
              },
              startDate: true,
              endDate: true,
              natureofAssociations: true,
          }],
       
          dateOfMarriage: true,
          dateOfMarriageEnd:true,
          countryOfMarriage: true,
          countryOfMarriageDetails: true,
          provinceOfMarriage: true,
          provinceOfMarriageDetails:true,
          locationOfMarriage: true,
          currentSpouseName:true,
          doYouHaveSSN:true,
          doYouWantTheSsaToIssueYouSS:true,
          ssnFather: {
            familyName: true,
            givenName: true
          },
          ssnMother: {
            familyName: true,
            givenName: true
          },
          immigStatusLastArrival:true,
          maritalStatus:true,
          presentMaritalStatusDetails:true,
          curNonImmigrantVisaStatus:true,
          fatherInfo:{
            name: true,
            firstName: true,
            middleName: true,
            lastName: true,
            hasOtherNames: true,
            otherNames: [{
                _id: 0,
                name: true,
                firstName: true,
                middleName: true,
                lastName: true,
            }],
            dateOfBirth: true,
            countryOfBirth: true,
            countryOfBirthDetails: true,
            provinceOfBirth: true,
            provinceOfBirthDetails: true,
            locationOfBirth: true,
            currentAddress: true,
            isUSCitizen: true,
            dateFromUSCitizen: true,
            nameAtBirth:{
                firstName: true, 
                middleName: true, 
                lastName: true,
            },
           deceasedCity: true,
           deceasedCityDetails:true,
           deceasedDate: true,
          },
          motherInfo:{
        name: true,
        firstName: true,
        middleName: true,
        lastName: true,
        hasOtherNames: true,
        otherNames: [{
            _id: 0,
            name: true,
            firstName: true,
            middleName: true,
            lastName: true,
        }],
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          currentAddress: true,
          isUSCitizen: true,
          dateFromUSCitizen: true,
          nameAtBirth:{
              firstName: true, 
              middleName: true, 
              lastName: true,
          },
          deceasedCity: true,
          deceasedCityDetails:true,
          deceasedDate: true,
          },
      
          issuedAnyEADFromUSCIS: true,
          relationship: true,
          saved: true,
          currentlyInUS: true,
          hasOtherNames: true,
          otherNames: [
            {
              _id: 0,
              name: true,
              firstName: true,
              middleName: true,
              lastName: true,
            },
          ],
          passportIssuedNumber: true,
          passportIssuedCountry:true,
          alienNumber: true,
          currentAddress: true,
          addressOutsideUS: {
            line1: true,
            line2: true,
            aptType: true,
            locationId: true,
            locationDetails: true,
            stateId: true,
            stateDetails: true,
            countryId: true,
            countryDetails: true,
            zipcode: true,
          },
          priorPeriodOfStayInUS:true,
          have2AffidavitsOfBirthFamily: true,
          h4Required: true,
          l2Required:true,
          height: {
          feet: true,
          inches: true,
         },
          h4EADRequired: true,
          doYouAlreadyH4EAD:true,
          l2EADRequired:true,
          doYouAlreadyL2EAD:true,
          name: true,
          firstName: true,
          middleName: true,
          lastName: true,
          email: true,
          phoneNumber: true,
          phoneCountryCode: {
            countryCode: true,
            countryCallingCode: true,
          },
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          locationOfBirthDetails: true,
          countryOfCitizenship: true,
          countryOfCitizenshipDetails: true,
          passportNumber: true,
          passportExpiryNumber: true,
          I94: true,
          I94ExpiryNumber: true,
          currentStatus: true,
          currentStatusDetails: true,
          statusExpiryNumber: true,
          SSN: true,
          lastArrivalNumber: true,
          placeOfLastEntryInUS: true,
          physicalAddress: true,
          documents: {
            eadCard:true,
            passport: true,
            visa: true,
            formI94: true,
            formI797: true,
            formI20: true,
            payStubs: true,
            marriageCertificate: true,
            
            noticeOfApprovalOfH1Status: true,
            approvalNoticeOfPrevH4: true,
            slgApprovalNoticeOfPrevH4:true,
            other: true,
          },
          //i140
          adjustmentOfI485Status: true, //Adjustment of Status (I-485) //{ type: Boolean, default: true },
          consularProcessing: true, // Consular Processing { type: Boolean, default: true },
        },
        childrens: {
          inadmissibility:true,
          highestDegreeCompleted:true,
          listOfCertifications:true,
          SSI:true,
          benefitsRecAmounts:{
            benefitReceived: true,
            startDate: true,
            endDate: true,
            amount: true
          },
          longTermInstiAtGovtExpense:true,
          periodOfInstutions:{
            institutionName:true,
            stateDetails:true,
            locationDetails:true,
            dateFrom:true,
            dateTo:true,
            reason:true,
          },
          maidenName:true,
          hasChildren:true,
          currentAddress: true,
          mailingAddressIsSameAsAddress:true,
          gender:true,
          sevisNumber: true,
          eadNumber: true,
          haveYouEverTravelledToUS:true,
          isI94DSExpiryDate:true,
          anyOtherPersonEmployedInUS:true,
          haveYouEverEmployed:true,
          isDSExpiryDate:true,
          applyingWithYou:true,
          dateOfLastEntryInUS:true,
          passportIssuedDate:true,
          h4EADRequired:true,
          l2EADRequired:true,
          doYouAlreadyL2EAD:true,
          doYouAlreadyH4EAD:true,
          have2AffidavitsOfBirthFamily:true,
          saved: true,
          relationship: true,
          currentlyInUS: true,
          hasOtherNames: true,
          doYouHaveSSN:true,
          doYouWantTheSsaToIssueYouSS:true,
          maritalStatus:true,
          ssnFather: {
            familyName: true,
            givenName: true
          },
          ssnMother: {
            familyName: true,
            givenName: true
          },
          immigStatusLastArrival:true,
          otherNames: [
            {
              _id: true,
              name: true,
              firstName: true,
              middleName: true,
              lastName: true,
            },
          ],
          placeOfLastEntryInUS:true,
          stateOfLastEntryInUS:true,
          prevEmploymentInfo: {
           // prevEmploymentInfo:true,
            _id: 0,
            employerName: true,
            address: {
              line1: true,
              line2: true,
              aptType: true,
              locationId: true,
              locationDetails: true,
              stateId: true,
              stateDetails: true,
              countryId: true,
              countryDetails: true,
              zipcode: true,
          },
          salary:true,
          businessType: true,
          jobTitle: true,
          jobDuties: true,
          startDate: true,
          endDate: true,
          payFrequency:true,
          payFrequency:true,
          currentEmployer: true,
        },
          alienNumber: true,
          lastArrivalNumber: true,
          placeOfLastEntryInUS: true,
          physicalAddress: true,
          addressOutsideUS: {
            line1: true,
            line2: true,
            aptType: true,
            locationId: true,
            locationDetails: {
              id: true,
              name: true,
              stateId: true,
              countryId: true,
            },
            stateId: true,
            stateDetails: {
              id: true,
              name: true,
              countryId: true,
            },
            countryId: true,
            countryDetails: {
              id: true,
              name: true,
              shortName: true,
              phoneCode: true,
              countryId: true,
              currencySymbol: true,
              currencyCode: true,
              zipcodeLength: true,
            },
            zipcode: true,
          },
          passportIssuedNumber: true,
          priorPeriodOfStayInUS: true,
          h4Required: true,
          l2Required:true,
          name: true,
          firstName: true,
          middleName: true,
          lastName: true,
          email:true,
          phoneNumber:true,
          phoneCountryCode: {
          countryCode: true,
          countryCallingCode: true
          },
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          locationOfBirthDetails: true,
          countryOfCitizenship: true,
          countryOfCitizenshipDetails: true,
          passportNumber: true,
          passportExpiryNumber: true,
          passportIssuedCountry:true,
          I94: true,
          I94ExpiryNumber: true,
          currentStatus: true,
          statusExpiryNumber: true,
          documents: {
            passport: true,
            visa: true,
            formI94: true,
            birthCertificate: true,
            approvalNotice: true,
            approvalNoticeOfPrevH4: true,
            slgApprovalNoticeOfPrevH4:true,
            other: true,

          },

          //i140
          adjustmentOfI485Status: true, //Adjustment of Status (I-485) //{ type: Boolean, default: true },
          consularProcessing: true, // Consular Processing { type: Boolean, default: false },
        },
      },
      isEveryThingLoaded:false,
      fields: [ 
        // for dependents Starts
        {
          "key": "inadmissibility",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "highestDegreeCompleted",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "listOfCertifications",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "SSI",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "benefitReceived",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "startDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "endDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "amount",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },

        {
          "key": "longTermInstiAtGovtExpense",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "institutionName",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "stateDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "locationDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "dateFrom",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "dateTo",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "reason",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "inadmissibility",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "highestDegreeCompleted",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "listOfCertifications",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "SSI",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "benefitReceived",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "startDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "endDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "amount",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },

        {
          "key": "longTermInstiAtGovtExpense",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "institutionName",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "stateDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "locationDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "dateFrom",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "dateTo",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "reason",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        // for dependents end
     
      {
        "key": "houseHoldNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualIncome",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualAssets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualliabilities",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "inadmissibility",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "highestDegreeCompleted",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "listOfCertifications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "SSI",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "benefitReceived",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "amount",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      
      {
        "key": "longTermInstiAtGovtExpense",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "institutionName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "stateDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "locationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "dateFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "dateTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "reason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },

      {
        "key": "illegalGamblingOrDrug",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "illegalActivityOrSource",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
          "key": "benfAssets",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },

      {
          "key": "firstName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "lastName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "middleName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "typeOfAsset",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "amount",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "benfIncome",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "firstName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "lastName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "middleName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "dateOfBirth",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "relToTheBenf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "amount",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
      {
        "key": "beneficiaryCnfmNumber",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "typeOfOffice",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "officeAddress",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "i485AdditionalInformation",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everDeniedAdmissionInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everWorkedInUSWithoutAuth",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolatedTandCofYourNonImmStatus",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everBeenInRemovalExcl",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everBeenIssuedOrderExclRemoval",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHadPriorOrderExclDeport",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHeldPermResidentStatus",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everGrantedVolDepartimmgOfficer",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedReliefOrExclDeport",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everJNonImmmExchangeVistor",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCompailedForeignResi",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everGrantedWavierRecomndLtr",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everArrested",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommittedCrime",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everPledGuilty",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everPunishedByJudge",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAccusedCrimProc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolated",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everConvictedTwoOrMoreOffens",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKnowinglyIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpouseSondaughterIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngageProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everdirOrIndirectProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everReceiveMoneyFronProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everIntentIllegalGamblUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everImmunityCriminalOffensedInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateReliFreedomAsForeignGovOffi",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everForceFraudCommercialSexActs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTraffPersonIntoInvolSlavery",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKnowWithTraffPersonCommSexAct",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpouseSonDughterEngTraffAnyFinBef",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngMoneyLaundering",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateEvidenceLawRelatedInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateExpGoodsSensInfoTechInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everOverthrowingUSGovtByForceViolence",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everActivityDangerScurityOfUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngUnlawfulActivity",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngActSeriousForeignPolicyforUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommitedKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommMemberGrpOrgKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAskMoneyRecruGrpKidnapHijackEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everProvideMoneyForAssiKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everProvideMoneyForAssiIndiGrpKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTraiParaOrMilataryWepons",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiEngKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHSpoOrChiPartMemberKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiRecrutKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiAskMoneyAssiKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiForAssiIndiGrpKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSellProvideTransWepon",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everWorkedPrisionAndDetained",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsingWeponPartGrpOrgThreatPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everServedParaOrMilataryEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everMemberCommPartyInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "ever080545To230393AssoNaziGerGov",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everInvolveTorture",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKillAnyPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSeverInjuAnyPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngAnySexualContent",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everLimitReligBnf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsedBelow15yrsPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHelpUnder15yrsPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRcvPublicAssiInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everFutureRcvPublicAssiInUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAttenRmvProcFiledAfter010497",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRmvProcFiledReason",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "rmvProcFiledResonWriteStmt",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSubmitFraudDocUSGov",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everLiedMisrepreInfoEnterUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everClaimFlaslyUSCitizen",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everStowawayOnVessel",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTrytoEnterUsIllegaly",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everFinalOrderCivilPenalty",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRemovedfromUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEnterUSWithoutInspAdmit",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497More180DLessYrULFStayUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497YrOrMoreULFDepartUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497ReEntMoreYrULFStayUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497RmvFromUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "planForPractPolyInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "AreYouAccomOtherCountry",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAnyUsChildUnderCustody",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everVoilationAnyFedaral",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsCtzshipAvoidTax",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedForExemptServiceUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everReliServTrainAreYouForeignNation",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everConvictDestUSArmedForce",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRemOutsideUSAviodTrainArmedForce",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "nationImgrstaIfAviodTrainArmForcUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "criminalActsAndViolationsAddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ46aTo50AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ51AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ52To60AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4EadPhotoEmailStmt",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "last12MonthsPayslips",
        "lebel": "Beneficiary’s Pay Slips",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proExecOrmanagerial",
        "lebel": "Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfVeriPoliBenfApproved",
        "lebel": "Copies of various policies Beneficiary approved",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfContExecByBeneficiary",
        "lebel": "Copies of Contracts executed by Beneficiary",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfBoardMinBenfPlayRole",
        "lebel": "Copies of Board Minutes where Beneficiary played a role",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payRevisionLetters",
        "lebel": "Pay Revision Letters (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "leaveAppliForms",
        "lebel": "Leave Application Forms (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "manageManPowerReq",
        "lebel": "Manage Manpower Request (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromUSComp",
        "lebel": "Offer letter from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromUSComp",
        "lebel": "Employment Agreement from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromForeComp",
        "lebel": "Offer letter from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromForeComp",
        "lebel": "Employment Agreement from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "trainingCert",
        "lebel": "Training Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfSpecKnowledge",
        "lebel": "Proof of specialized knowledge (Note: Technical and functional knowledge)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePassport",
        "lebel": "Copy of all the pages of the passport of your spouse (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriageCertificate",
        "lebel": "Copy of the Marriage Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseBirthCertificate",
        "lebel": "Copy of the Birth Certificate of the Spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriagePhotographs",
        "lebel": "Photographs of the marriage and after marriage photographs of the couples",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseAffidavits",
        "lebel": "Affidavits from the parents of you and your spouse confirming your bona fide marital relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMartialRelationship",
        "lebel": "Any other document that show the ongoing martial relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePhotographs",
        "lebel": "Two (2) passport sized photographs of your spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherPassport",
        "lebel": "Copy of all the pages of the passport of your father (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherParentsMarriageCertificate",
        "lebel": "Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherPassport",
        "lebel": "Copy of all the pages of the passport of your mother (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your mother’s",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingPassport",
        "lebel": "Copy of all the pages of the passport of your sibling (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertWithParents",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertificate",
        "lebel": "Copy of your sibling’s birth certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBffidavits",
        "lebel": "Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildPassport",
        "lebel": "Copy of all the pages of the passport of your child (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertWithParents",
        "lebel": "Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertificate",
        "lebel": "Copy of your child’s birth certificate showing child’s name and your name- if you are the child’s mother",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "marriageEndedOtherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "marriageEndedOtherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo.fatherInfo"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "marriageEndedDueTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "obtainPermResidenceThroughSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "locationOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "previousSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hasChildren",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "noOfTimesMarriedBeneficiary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "noOfChildrens",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "doYouHaveMarriageCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "marriageCertDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "have2AffidavitsAttestingToMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "previouslyMarried",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "previousSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "locationOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "obtainPermResidenceThroughSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "inspectedByAnyImmOfficer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "issuedAnyEADFromUSCIS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "enterInUSUnderCaseWaiverProgram",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasPermResidencyInOtherCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "permResidencyCountryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "permResidencyCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedAOSInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveOwnershipInterest",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "ownershipInterestDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevH1bCaseStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverAppliedH1bCase",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevH1bCaseDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiledDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consulateInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "educations",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "graduatedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "nonImmPetitionsInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "h1bImmPetitionsInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "didThisPtnrFliedImmPetitionEarlier",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "immPetitionPriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyOtherAlienFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "rirOrRegularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedStateId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedStateDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "applCurStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "seekingFiledDateforETA750",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "anyI140Filed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "fieldDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "priorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "eb2orEb3",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "feet",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.height"
    },
    {
        "key": "inches",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.height"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "email",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "education",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.education"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.education"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94StatusName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "homePhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "homePhoneCountryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "homePhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "homePhoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "cellPhoneCountryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consulateNotifyAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasI140ImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I140ImmPetitionFiledDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasMasterDegreeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "allIssuedPassportData",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curNonImmigrantVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curVisaExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "noOfDaysStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "confirmDaysStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasApprovedI140",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasPermPendingForMorethan365Days",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasAnyDependetsinUStoFileH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "areYouUnderRemoveOfIndOrUscis",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "relationship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentSpouseName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouHaveSSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "immigStatusLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnFather"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnFather"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnMother"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnMother"
    },
    {
        "key": "doYouWantTheSsaToIssueYouSS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "presentMaritalStatusDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUS"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "l2Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "h4Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouAlreadyH4EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "h4EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "l2EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouAlreadyL2EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "email",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "phoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.phoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.phoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.cellPhoneCountryCode"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "allIssuedPassportData",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "countryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "number",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "issuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "expiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "statusExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "physicalAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOfLastNYears"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOfLastNYears"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "feet",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.height"
    },
    {
        "key": "inches",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.height"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "adjustmentStatusToPermResidenceI485",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "natureofAssociations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "marriageEndedDueTo",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "curNonImmigrantVisaNumber",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "doesBirthRegistered",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "visaDeniedReason",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYoueverPresntUnlawfully",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "presntUnlawfullyReason",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverReceivedPublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "eadCard",
        "lebel": "Please provide a copy of the EAD CARD(S), front and  back",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "documents"
    },
    {
        "key": "haveYouArrestedBefore",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouArrestedBeforeDocs",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "natureofAssociations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "visaDeniedReason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYoueverPresntUnlawfully",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "presntUnlawfullyReason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverReceivedPublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "everAppliedAOSInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "appliedAOSInUSDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "appliedAOSInUSDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouArrestedBefore",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouArrestedBeforeDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doesBirthRegistered",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "curNonImmigrantVisaNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "enterInUSUnderCaseWaiverProgram",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "inspectedByAnyImmOfficer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "issuedAnyEADFromUSCIS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasPermResidencyInOtherCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "permResidencyCountryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "permResidencyCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eadCard",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "applyingWithYou",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "applyingWithYou",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "visa",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI797",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI20",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "payStubs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "marriageCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "noticeOfApprovalOfH1Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "approvalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "other",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "birthCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "photographs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "medicalExamins",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "dependentForI134",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "w2",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "bankStatements",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "recentCreditReport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "permResidence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "empAuth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "slgApprovalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "relationship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "l2Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouAlreadyH4EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "l2EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouAlreadyL2EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "email",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "phoneNumber",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.phoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.phoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.cellPhoneCountryCode"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "countryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "number",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "issuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "expiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "statusExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouWantTheSsaToIssueYouSS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouHaveSSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "immigStatusLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnFather"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnFather"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnMother"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnMother"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "physicalAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "adjustmentStatusToPermResidenceI485",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "height",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "visa",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "formI94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "birthCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "approvalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "approvalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "other",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "photographs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "medicalExamins",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "dependentForI134",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "w2",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "bankStatements",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "recentCreditReport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "permResidence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "empAuth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "slgApprovalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "resume",
        "lebel": "Resume",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "education",
        "lebel": "Master’s/ Bachelor’s degree certificate, transcripts,12th and 10th certificates",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "expLetters",
        "lebel": "Experience Letters",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "INSNotices",
        "lebel": "I-797, Notice of Approval granting the current nonimmigrant status (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "I-140 Approval Notice, if any",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passport",
        "lebel": "Passport- First page with photo and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportVisaI94",
        "lebel": "Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI20",
        "lebel": "All Form I-20s if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "socialSecurityCardAndProfLicense",
        "lebel": "Social Security Card",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "other",
        "lebel": "Other Documents, if any",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payStubs",
        "lebel": "Three recent pay stubs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetter",
        "lebel": "Employment Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "clientLetter",
        "lebel": "Client Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "vendorLetter",
        "lebel": "Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "msa",
        "lebel": "MSA/Service Agreement and PO/SOW",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "po",
        "lebel": "PO",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "beneficiaryDocs",
        "lebel": "Beneficiary Documents",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h1bRegSelectionNotice",
        "lebel": "H-1B Registration Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "employmentAgreement",
        "lebel": "Employment Agreement",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "primeVendor",
        "lebel": "Prime Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI94",
        "lebel": "Copy of I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "priorFormI797",
        "lebel": "Copy of I-797, Notice of Approvals for granting of legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "I797NoticeofApprovalforI140",
        "lebel": "I-797, Notice of Approval for I-140 if available",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "ead",
        "lebel": "EADs (if on OPT or STEM OPT Extension)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "w2",
        "lebel": "Copy of W-2 Forms issued for all tax years till present",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "birthCertificate",
        "lebel": "Birth Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "photographs",
        "lebel": "Photographs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "medicalExamins",
        "lebel": "Medical Examins",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentForI134",
        "lebel": "Dependent For I-134",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "Dependent Tax Returns",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bankStatements",
        "lebel": "Bank Statements",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "Evidence of Continue Visa Status",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "Evidence of File Petition Before 30-Apr-2001",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "Proof of Income or Asset",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "Proof of Medical Insurence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "recentCreditReport",
        "lebel": "Recent Credit Report",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "permResidence",
        "lebel": "Permanent Residence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAuth",
        "lebel": "Employment Auth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "capSelectNotice",
        "lebel": "CAP Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgResume",
        "lebel": "Current Resume- Please mention the accurate names of the employer and periods of employment. Do not state the client names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgCollegeDegreesCert",
        "lebel": "All College Degrees",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgTransScripts",
        "lebel": "Copies of all education documents including Certificates and Transcripts/Marks Memos",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgExpLetters",
        "lebel": "Letters of Experience",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPassportAndVisa",
        "lebel": "Copy of New and Old Passport along with Visa",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI94",
        "lebel": "I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevNonimmApprovalNotices",
        "lebel": "Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 etc.,)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevImmApprovalNotices",
        "lebel": "Copies of all prior Notice of Approvals/Receipts (if any) for legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI140OrPermNoties",
        "lebel": "Copy of any I-140 approval notices or PERM filing Notices (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "Copy of the previously filed Labor Application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgAckOfPrevLaborApplications",
        "lebel": "Copy of the Acknowledgement letter for the previously filed Labor application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPaystubs",
        "lebel": "Copies of most recent four paystubs to the present salary drawn.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "motherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "fatherInfo"
    },
    {
        "key": "marriageCertificate",
        "lebel": "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "underlyingLaborApplications",
        "lebel": "Copy of the underlying Labor Certification (PERM) if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "mostRecentTaxTranscrips",
        "lebel": "A copy of Most Recent Year’s Tax Transcripts – can be obtained from",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI20",
        "lebel": "Copies of all I-20’s.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEad",
        "lebel": "Copies of EAD cards.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduCredentials",
        "lebel": "Copy of Educational Evaluation, if any (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduExpCredentials",
        "lebel": "Education+Experience Evaluation",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H4ApprovalNotice",
        "lebel": "Form I-797 H4 approval notice if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseLatestI797",
        "lebel": "Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpousePassport",
        "lebel": "Spouse’s Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseRecentPayStubs",
        "lebel": "Three recent pay stubs (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseFormAllI20",
        "lebel": "Spouse’s all Form I-20s (if spouse is on F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgOfferLetter",
        "lebel": "Unsigned Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgSignedOfferLetter",
        "lebel": "Signed Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h4Ead",
        "lebel": "H4 EAD if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "marriageCertificate",
        "lebel": "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H1BApprovalNoticePrinNonCtzn",
        "lebel": "Form I-797 H-1B approval notice of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportOfPrinNonCtzn",
        "lebel": "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "last3MonthsPayslipsOfPrinNonCtzn",
        "lebel": "Last 3 months pay statements of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbAllCollegeDegree",
        "lebel": "Masters and/or Bachelors College Diploma/Degree",
        "required": true,
        "tooltip":"Dont upload Marksheet but only Degree here",
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbAllMastOrBachMarkSheets",
        "lebel": "All Marksheets/Transcripts",
        "tooltip":"Masters and/or Bachelors marks only",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubmitAllI20",
        "lebel": "Maintenance of Status - F1 Status (if on F-1 Status)",
        "required": true,
        "tooltip":"Submit all I-20's, OPT EAD cards and recent pay-statements from any employer (if working on OPT)",
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubSpouseOrI194OrlastTwoPays",
        "lebel": "Maintenance of Status - If on H4 or L2 Status",
        "required": true,
        "tooltip":'Submit Spouse approval, spouse I94/approval and spouse last two pay-statements',
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubMostRecAppOrI194OrTwoStatements",
        "lebel": "Maintenance of Status - If on  H1/B or L1 Status",
        "tooltip":'Submit most recent approval/I94 and last two pay-statements',
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
],
      sponsorInfo:{
        countryOfCitizenship:true,
        haveUSCitizenOrPermResident:true,
        filingThisPetitionerFor:true,
        anyOtherPersonEmployedInUS:true,
        haveYouEverEmployed:true,
        name: true,
        firstName: true,
        middleName: true,
        lastName: true,
        gender:true,
        nameDiffFromBirthCert: true, // anyOtherPersonEmployedInUS IF YOUR NAME IS DIFFERENT FROM THAT STATED ON YOUR BIRTH CERTIFICATE, HAVE YOU HAD IT LEGALLY CHANGED
        hasOtherNames: true,
        otherNames: true,
        birthCertHaveNamePobDob: true, // Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born?
        have2AffidavitsOfBirthFamily: true, // IF NOT, DO YOU HAVE TWO (2) AFFIDAVITS OF BIRTH FROM FAMILY MEMBERS? 
        currentAddress: true, // CURRENT U.S. PHYSICAL ADDRESS
        mailingAddressIsSameAsAddress: true, // CURRENT MAILING ADDRESS Same
        address: true, // if different from the physical address
        cellPhoneNumber: true, // DAYTIME PHONE NUMBER
        cellPhoneCountryCode: {
            countryCode:true,
            countryCallingCode: true
        },
        citizenshipAcquiredThrough:true,
        email: true, // Email
        SSN: true, // U.S. SOCIAL SECURITY NUMBER (If any)
        alienNumber: true, // ALIEN NUMBER (A#) (If known)
        dateOfBirth: true, // DATE OF BIRTH
        countryOfBirth:true,
        provinceOfBirth: true,
        locationOfBirth: true,
        maritalStatus: true, // Marital Status
        maritalStatusDetails: true,
        usCitizen: true, // If you are a U.S. Citizen
        citizenshipBirth: true, //  Citizenship was acquired through Birth
        citizenshipNaturalization: true,  //  Citizenship was acquired through Naturalization
        citizenshipParents: true,  //  Citizenship was acquired through Parents
        lawfulPerResident: true, // If you are a Lawful Permanent Resident
        lprRequired: true, // LPR was acquired through:
        certOfCitizenNumber: true, //Certificate of Citizenship Number: 
        dateReceivedLPR: Date, // Date received LPR
        placeOfIssuance: true, // Place of Issuance
        dateOfIssuance: true, // Date of Issuance
        usCitizenOrLPR: true, // Did you gain LPR through marriage to a U.S. citizen or a LPR? NO
        dateOfMarriage:true,
        countryOfCitizenship:true,
        countryOfMarriage: true,
        provinceOfMarriage: true,
        locationOfMarriage: true,
        // newly added i-130 sponsor keys start
        fillThisPetiChildOrParentRelation:true,
        fillThisBroOrSisRelatedByAdoption:true,
        gainLawPermResidentThroughAdoption:true,
        lawFulPermanentResident:{
          classOfAdmission:true,
          dateOfAdmission:true
        },
        cityOfAdmission:true,
        stateOfAdmission:true,
        anyOtherElseFiledPetitionForBnf:true,
        benfEverInImmigrationProceedings:true,
        typeOfProceedings:true,
        dateOfProceedings:true,
        stateOfProceedings:true,
        cityOfProceedings:true,
        hasSubmitSepPetiForOtherRelation:true,
        submitSupPetiForOtherRelative:{
          relative:true,
          familyName:true,
          givenName:true,
          middleName:true,
          relationShip:true
        },
        haveYouPrevFiledAnyPetitionForBnf:true,
        bnfPrevPetitionInfo: {
          familyName: true,
          givenName: true,
          middleName: true,
          dateOfFiling:  true,
          cityOfFiling: true,
          stateOfFiling: true,
          status: true, // approved/denied/withdrawn
        },
        // end
        affidavitInfo: {
          benfApplyAdjustStatus:true,
          benfAdjustmentDocument:true,
          affidavitInfo:true,
          currentAnnualSalary: true,
          nameOfEmployer: true,
          currentPosition: true,
          depositsInBankUSA: true,
          reasonableValPersonalProperty: true,
          haveMarketValInStocksAndBonds: true,
          marketValInStocksAndBonds: true,
          sumOfLifeInsurance: true,
          cashSurrValOfLifeInsurance: true,
          haveValOfRealEstate: true,
          valOfRealEstate: true,
          amountOfMortgageProperty: true,
          addressPropertyIsLocate: true
        },
        prevEmploymentInfo: {
              prevEmploymentInfo:true,
              employerName: true,
              address: true,
              businessType: true,
              jobTitle: true,
              jobDuties: true,
              startDate: true,
              endDate: true,
              salary:true,
              payFrequency:true,
              currentEmployer: true,
        },
        prevEmploymentOutsideUS:{
            prevEmploymentOutsideUS:true,
            _id: 0,
            employerName:true,
            address: true,
            businessType: true,
            jobTitle: true,
            jobDuties: true,
            startDate: true,
            endDate: true,
            salary:true,
            payFrequency:true,
            currentEmployer: true ,
        },
        addressOfLastNYears:{
          addressOfLastNYears:true,
          startDate:true,
          endDate:true
        },
        addressOutsideUSMoreThanYear:{
          addressOutsideUSMoreThanYear:true,
          startDate:true,
          endDate:true
        },
        height: {
            feet: true,
            inches: true
        },
        weight: true,
        race: {
            id: true,
            name: true
        },
        eyeColor: {
            id: true,
            name: true
        },
        hairColor: {
            id: true,
            name: true
        },
        nationality: true , // CITIZENSHIP/NATIONALITY
        dateFromUSCitizen: true, // DATE FROM WHICH YOU HAVE RESIDED IN THE USA
        filedOnAnyOtherPerOrPetitioner: true,// HAVE YOU EVER FILED A PETITION FOR THIS BENEFICIARY OR ANY OTHER PERSON
        filedName: true,// GIVE NAME, PLACE AND DATE OF FILING
        filedPlace: true,
        fileDateOfFiling: true,
        filedStatus: true,
        previouslyMarried:true,
        previousSpouse: {
          previousSpouse:true,
          firstName: true,
          middleName: true,
          lastName: true,
          maidenName: true,
          name: true,
          dateOfBirth: true,
          dateOfMarriage: true,
          dateOfMarriageEnd: true,
          countryOfMarriage: true,
          countryOfMarriageDetails: true,
          provinceOfMarriage: true,
          provinceOfMarriageDetails: true,
          locationOfMarriage: true,
          countryOfMarriageTermination: true,
          countryOfMarriageTerminationDetails: true,
          provinceOfMarriageTermination: true,
          provinceOfMarriageTerminationDetails: true,
          locationOfMarriageTermination: true,
          obtainPermResidenceThroughSpouse: true,
          marriageEndedDueTo: true, //Divorce, Death, Other
          marriageEndedOtherInfo: true
        },
        documents: {
          sponsorPassport: true, // Copy of all the pages of the passport of the Petitioner (including the blank pages).  Please make sure that the photo(s) and biographic information are clearly visible.
          sponsorGreenCard: true, // Copy of the Naturalization Certificate/Green Card (front and back) of the Petitioner
          sponsorBirthCertificate: true, // Copy of the Birth Certificate of the Petitioner
          sponsorPhotographs: true, // Two (2) photographs of the Petitioner – Only if filing I-130 for spouse
        },
        dependentsInfo:{
          spouse: {
            hasSpouse:true,
            name: true,
            firstName: true,
            middleName: true,
            lastName: true,
            maidenName:true,
            countryOfBirth:true,
            provinceOfBirth: true,
            locationOfBirth: true,// Place of birth 
            placeOfBirthDetails: true,
            alienNumber: true, // ALIEN NUMBER (A#) (If known)
            currentAddress: true, // PRESENT ADDRESS
            currentStatus: true, // CURRENT STATUS, IF IN THE USA
            passportExpiryDate: true, // DATE CURRENT STATUS EXPIRES 
          },
          children: {
            hasChildren:true,
            uuid: true,
            name: true,
            firstName: true,
            middleName: true,
            lastName: true,
            dateOfBirth: true,
            countryOfBirth:true,
            provinceOfBirth: true,
            locationOfBirth: true,
            relationshipToYou: true,
          }
        },
        fatherInfo: {
          fatherInfo:true,
          name: true,
          firstName: true,
          middleName: true,
          lastName: true, 
          hasOtherNames: true,
          otherNames: true,
          nameAtBirth: {
          firstName: true,
          middleName: true,
          lastName: true,
          },
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          currentAddress: true,
          isUSCitizen: true,
          dateFromUSCitizen: true,
          deceasedCity: true,
          deceasedCityDetails: true,
          deceasedDate: true
		    },
        motherInfo: {
          motherInfo:true,
          name: true,
          firstName: true,
          middleName: true,
          lastName: true, 
          hasOtherNames: true,
          otherNames: true,
          nameAtBirth: {
            firstName: true,
            middleName: true,
            lastName: true,
          },
          dateOfBirth: true,
          countryOfBirth: true,
          countryOfBirthDetails: true,
          provinceOfBirth: true,
          provinceOfBirthDetails: true,
          locationOfBirth: true,
          currentAddress: true,
          isUSCitizen: true,
          dateFromUSCitizen: true,
          deceasedCity: true,
          deceasedCityDetails: true,
          deceasedDate: true
		    },
      },
      petitionerQuestInfo:{
        petitionerType:true,
        benfComeToUSOpenNewOffice:true,
        classificationScougt:true,
        nameOfEmpAbroad:true,
        address:true,
        dateOfBenfEmployment:{
          dateOfBenfEmployment:true,
          explaOfInterruptions:true,
          dateOfEmpFrom:true,
          dateOfEmpTo:true
        },
        descBenfDutAbroad3Years:true,
        descBenfPropDutiesInUs:true,
        sumBenfEduAndWorkExp:true,
        companyRelaToAbroad:true,
        desPerStockOwnerShip:{
          desPerStockOwnerShip:true,
          perOfCompany:true,
          fedEmpIdentification:true,
        },
        everqualRelaOneYearEmpl:true,
        everqualRelaOneYearEmplExpla:true,
        benePriOffsiteEmp:true,
        priOffsiteEmpExpla:true,
        priReasplaceToAnotWorksite:true,
        jobTitle: true, // Job Title  
        workAddress: true, // Work Address
        itineraryPeti: true, // Did you include an itinerary with the petition? Ex: Yes or No
        everBenfWorkOffSiteAnothComp: true,// Will the beneficiary(ies) work for you off-site at another company or organization's location? Ex: Yes or No
        everBenfExcluCommonOrNorthIslands: true, // Will the beneficiary(ies) work exclusively in the Commonwealth of the Northern Mariana Islands (CNMI)?  Ex: Yes or No
        fullTimePosition:  true, //Is this a full-time position?
        hoursPerWeek:  { type: true, default: '' },  // How many hours per week for the position?
        salary: true, // wages Ex: "$5,000,000"
        payFrequency: true, // Pay Terms Ex: Hour/Week/Month/Year
        otherCompensation: true, // Other Compensation
        dateOfIntendedEmpFrom: true,
        dateOfIntendedEmpTo: true,
        usaCompanyDocuments: {
          incorporationCertDocs: true,  // Certificate of Incorporation
          amendmentCertDocs: true, // Certificate of Amendment of Certificate of Incorporation
          stockCopyCertDocs: true, // Copy of stock certificates
          leaAgreeForPropOffice: true, // Lease Agreements for the proposed office (only for L1A and to open new office)
          curOrgaChart: true, // Current Organizational Chart
          propOrgaChart: true, // Proposed Organizational Chart (only for L1A and to open new office)
          l1AVisaBusiPlan: true, //L1-A Visa Business Plan (only for L1A and to open new office)
          minOfBoardMeetings: true, // Minutes of Board Meetings (optional)
          contraExecOfCopyDocs: true, // Copy of the contracts executed (optional)
          auditFinaStatMostRecent: true, // Most recent audited financial statements or Federal Tax Returns
          bankIndicAndBal: true, // Letter from bank indicating status and balance (only for L1A and to open new office)
          productDocs: true, // Product Documents (Only for L1B) optional
        },
        foreignCompanyDocuments: {
          taxReturns: true, // Income tax Returns
          bankStatements: true, // Bank Statements
          verifyOrSupportLetter: true, // Verification/Support Letter
          orgnaStructureDocs: true, //Organization Structure
          proAndLossStatDocs: true // Profit and Loss Statements of Foreign Company 
        }
      },
      petitionerInfoModal:[
      { 
        key: "benfComeToUSOpenNewOffice",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "classificationScougt",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "nameOfEmpAbroad",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo", 
      },
      { 
        key: "dateOfBenfEmployment",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "explaOfInterruptions",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "dateOfEmpFrom",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "dateOfEmpTo",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "descBenfDutAbroad3Years",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "descBenfPropDutiesInUs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "sumBenfEduAndWorkExp",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "companyRelaToAbroad",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo", 
      },
      { 
        key: "desPerStockOwnerShip",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "perOfCompany",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "fedEmpIdentification",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "everqualRelaOneYearEmpl",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "everqualRelaOneYearEmplExpla",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "benePriOffsiteEmp",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "priOffsiteEmpExpla",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "priReasplaceToAnotWorksite",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "jobTitle",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "workAddress",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "itineraryPeti",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "everBenfWorkOffSiteAnothComp",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "everBenfExcluCommonOrNorthIslands",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "fullTimePosition",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "hoursPerWeek",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "payFrequency",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "otherCompensation",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "dateOfIntendedEmpFrom",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "dateOfIntendedEmpTo",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "incorporationCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "amendmentCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "stockCopyCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "leaAgreeForPropOffice",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "curOrgaChart",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "propOrgaChart",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "l1AVisaBusiPlan",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "minOfBoardMeetings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "contraExecOfCopyDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "auditFinaStatMostRecent",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "bankIndicAndBal",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "productDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "taxReturns",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "bankStatements",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "verifyOrSupportLetter",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "orgnaStructureDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "proAndLossStatDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
     
    ],
      sponsorInfomodal:[
      {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo.motherInfo"
      },
      { 
        key: "anyOtherPersonEmployedInUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "haveUSCitizenOrPermResident",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "filingThisPetitionerFor",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      // Newly added i-130 keys starts
      { 
        key: "fillThisPetiChildOrParentRelation",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "fillThisBroOrSisRelatedByAdoption",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "gainLawPermResidentThroughAdoption",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "classOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.lawFulPermanentResident",
      },
      { 
        key: "dateOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.lawFulPermanentResident",
      },
      { 
        key: "cityOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "stateOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "anyOtherElseFiledPetitionForBnf",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "benfEverInImmigrationProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      }, 
      { 
        key: "typeOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "dateOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "stateOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "cityOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "haveYouPrevFiledAnyPetitionForBnf",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "familyName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "givenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "dateOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "cityOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "stateOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "status",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      }, 
      { 
        key: "hasSubmitSepPetiForOtherRelation",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "relative",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "familyName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "givenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "relationShip",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      // end
      {
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      {
        key: "haveYouEverEmployed",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      {
        key: "citizenshipAcquiredThrough",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      {
          key: "dateOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "sponsorInfo",
        },
      {
          key: "countryOfBirth",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "sponsorInfo",
        },
      {
        key: "prevEmploymentOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "employerName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS", 
      },
      {
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "payFrequency",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },

      {
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "businessType",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "jobTitle",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "jobDuties",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "currentEmployer",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "prevEmploymentInfo",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "employerName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo", 
      },
      {
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "payFrequency",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },

      {
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "businessType",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "jobTitle",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "jobDuties",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "currentEmployer",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "addressOfLastNYears",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "addressOutsideUSMoreThanYear",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
      {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo"
      },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "previouslyMarried",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.dependentsInfo.spouse",
    },
    {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.dependentsInfo.children",
    },
    {
    "key": "hasSpouse",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateOfMarriage",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "gender",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "nameDiffFromBirthCert",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "birthCertHaveNamePobDob",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    key: "countryOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
  {
    key: "provinceOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
  {
    key: "locationOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
  {
    "key": "have2AffidavitsOfBirthFamily",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "mailingAddressIsSameAsAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "address",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "address",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "cellPhoneNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "email",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "SSN",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "alienNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "maritalStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "usCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipNaturalization",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipParents",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lawfulPerResident",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lprRequired",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "certOfCitizenNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateReceivedLPR",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "placeOfIssuance",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateOfIssuance",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "usCitizenOrLPR",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "height",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "feet",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.height"
  },
  {
    "key": "inches",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.height"
  },
  {
    "key": "weight",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "race",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "eyeColor",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "hairColor",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "nationality",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedOnAnyOtherPerOrPetitioner",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedPlace",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "fileDateOfFiling",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  
{
    key: "affidavitInfo",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "benfAdjustmentDocument",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "benfApplyAdjustStatus",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "currentAnnualSalary",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "nameOfEmployer",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "currentPosition",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "depositsInBankUSA",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "reasonableValPersonalProperty",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "haveMarketValInStocksAndBonds",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "marketValInStocksAndBonds",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "sumOfLifeInsurance",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "cashSurrValOfLifeInsurance",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "haveValOfRealEstate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "valOfRealEstate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "amountOfMortgageProperty",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "addressPropertyIsLocate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
  key: "marriageEndedOtherInfo",
  lebel: "",
  required: true,
  description: "",
  fieldRequired:true,
  section: "sponsorInfo.previousSpouse",
},
 {
      key: "previousSpouse",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "firstName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "middleName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "lastName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "name",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfBirth",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfMarriageEnd",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "locationOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageTerminationDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageTerminationDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "locationOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "obtainPermResidenceThroughSpouse",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key : "marriageEndedDueTo",
      lebel : "",
      required : true,       
      fieldRequired:true,
      description : "",
      section : "sponsorInfo.previousSpouse"
    },
  {
    "key": "sponsorPassport",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorGreenCard",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorBirthCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorPhotographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "provinceOfBirth", 
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "alienNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "passportExpiryDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "passport",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "marriageCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "birthCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "marriagePhotographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "affidavits",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "martialRelationship",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "photographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "fatherInfo",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "fatherInfo",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "provinceOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "isUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedCity",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedCityDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "provinceOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "isUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedCity",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedCityDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "uuid",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "hasChildren",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
  "key": "locationOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
{
  "key": "provinceOfBirth", 
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
  {
    "key": "relationshipToYou",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  }
       ],
      dbFields: [],
      responseFields: [],
      PayloadData: {
        name: "",
        questionnaireId: "",
        fields: [],
        sections: [],
      },
      configId: null,
      configDetails: null,
      updating:false,
    };
  },

  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    QuestTempDocumentComp,
    VuePhoneNumberInput,
    Datepicker,
    selectField,
    immiPhone,
    datepickerField,
    immiMask,
    immiyesorno,
    immiuploader,
    addressField,
    Trash2Icon,
    InfoIcon,
    EyeIcon,
    immiswitchyesno,
    immitextarea,
    //genderField,
    immiInput,
    Multiselect,
  },
  methods: {
    updateExistingData(){
      let updatedArray = [
    {
        "key": "resume",
        "lebel": "Resume",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgOfferLetter",
        "lebel": "Unsigned Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgSignedOfferLetter",
        "lebel": "Signed Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseLatestI797",
        "lebel": "Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpousePassport",
        "lebel": "Spouse’s Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseRecentPayStubs",
        "lebel": "Three recent pay stubs (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseFormAllI20",
        "lebel": "Spouse’s all Form I-20s (if spouse is on F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "underlyingLaborApplications",
        "lebel": "Copy of the underlying Labor Certification (PERM) if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "mostRecentTaxTranscrips",
        "lebel": "A copy of Most Recent Year’s Tax Transcripts – can be obtained from",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "education",
        "lebel": "Master’s/ Bachelor’s degree certificate, transcripts,12th and 10th certificates",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "expLetters",
        "lebel": "Experience Letters",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "INSNotices",
        "lebel": "I-797, Notice of Approval granting the current nonimmigrant status (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passport",
        "lebel": "Passport- First page with photo and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportVisaI94",
        "lebel": "Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI20",
        "lebel": "All Form I-20s if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "socialSecurityCardAndProfLicense",
        "lebel": "Social Security Card",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "other",
        "lebel": "Other Documents, if any",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payStubs",
        "lebel": "Three recent pay stubs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "vendorLetter",
        "lebel": "Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "msa",
        "lebel": "MSA/Service Agreement and PO/SOW",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "po",
        "lebel": "PO",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "beneficiaryDocs",
        "lebel": "Beneficiary Documents",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h1bRegSelectionNotice",
        "lebel": "H-1B Registration Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "employmentAgreement",
        "lebel": "Employment Agreement",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "primeVendor",
        "lebel": "Prime Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI94",
        "lebel": "Copy of I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "priorFormI797",
        "lebel": "Copy of I-797, Notice of Approvals for granting of legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "I797NoticeofApprovalforI140",
        "lebel": "I-797, Notice of Approval for I-140 if available",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "ead",
        "lebel": "EADs (if on OPT or STEM OPT Extension)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "w2",
        "lebel": "Copy of W-2 Forms issued for all tax years till present",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "photographs",
        "lebel": "Photographs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "birthCertificate",
        "lebel": "Birth Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetter",
        "lebel": "Employment Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "clientLetter",
        "lebel": "Client Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "photographs",
        "lebel": "Two (2) photographs of the Petitioner – Only if filing I-130 for spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "medicalExamins",
        "lebel": "Medical Examins",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentForI134",
        "lebel": "Dependent For I-134",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "Dependent Tax Returns",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bankStatements",
        "lebel": "Bank Statements",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "Evidence of Continue Visa Status",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "Evidence of File Petition Before 30-Apr-2001",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "Proof of Income or Asset",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "Proof of Medical Insurence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "recentCreditReport",
        "lebel": "Recent Credit Report",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "permResidence",
        "lebel": "Permanent Residence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAuth",
        "lebel": "Employment Auth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgResume",
        "lebel": "Current Resume- Please mention the accurate names of the employer and periods of employment. Do not state the client names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgCollegeDegreesCert",
        "lebel": "All College Degrees",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgTransScripts",
        "lebel": "Copies of all education documents including Certificates and Transcripts/Marks Memos",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgExpLetters",
        "lebel": "Letters of Experience",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPassportAndVisa",
        "lebel": "Copy of New and Old Passport along with Visa",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI94",
        "lebel": "I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevNonimmApprovalNotices",
        "lebel": "Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 etc.,)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevImmApprovalNotices",
        "lebel": "Copies of all prior Notice of Approvals/Receipts (if any) for legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI140OrPermNoties",
        "lebel": "Copy of any I-140 approval notices or PERM filing Notices (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "Copy of the previously filed Labor Application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgAckOfPrevLaborApplications",
        "lebel": "Copy of the Acknowledgement letter for the previously filed Labor application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPaystubs",
        "lebel": "Copies of most recent four paystubs to the present salary drawn.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI20",
        "lebel": "Copies of all I-20’s.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEad",
        "lebel": "Copies of EAD cards.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduCredentials",
        "lebel": "Copy of Educational Evaluation, if any (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduExpCredentials",
        "lebel": "Education+Experience Evaluation",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H4ApprovalNotice",
        "lebel": "Form I-797 H4 approval notice if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H1BApprovalNoticePrinNonCtzn",
        "lebel": "Form I-797 H-1B approval notice of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportOfPrinNonCtzn",
        "lebel": "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address0000",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "last3MonthsPayslipsOfPrinNonCtzn",
        "lebel": "Last 3 months pay statements of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h4Ead",
        "lebel": "H4 EAD if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "capSelectNotice",
        "lebel": "CAP Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePassport",
        "lebel": "Copy of all the pages of the passport of your spouse (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriageCertificate",
        "lebel": "Copy of the Marriage Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseBirthCertificate",
        "lebel": "Copy of the Birth Certificate of the Spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriagePhotographs",
        "lebel": "Photographs of the marriage and after marriage photographs of the couples",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseAffidavits",
        "lebel": "Affidavits from the parents of you and your spouse confirming your bona fide marital relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMartialRelationship",
        "lebel": "Any other document that show the ongoing martial relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePhotographs",
        "lebel": "Two (2) passport sized photographs of your spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherPassport",
        "lebel": "Copy of all the pages of the passport of your father (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherParentsMarriageCertificate",
        "lebel": "Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherPassport",
        "lebel": "Copy of all the pages of the passport of your mother (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your mother’s",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingPassport",
        "lebel": "Copy of all the pages of the passport of your sibling (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertWithParents",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertificate",
        "lebel": "Copy of your sibling’s birth certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBffidavits",
        "lebel": "Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildPassport",
        "lebel": "Copy of all the pages of the passport of your child (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertWithParents",
        "lebel": "Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertificate",
        "lebel": "Copy of your child’s birth certificate showing child’s name and your name- if you are the child’s mother",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "last12MonthsPayslips",
        "lebel": "Beneficiary’s Pay Slips",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proExecOrmanagerial",
        "lebel": "Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfVeriPoliBenfApproved",
        "lebel": "Copies of various policies Beneficiary approved",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfContExecByBeneficiary",
        "lebel": "Copies of Contracts executed by Beneficiary",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfBoardMinBenfPlayRole",
        "lebel": "Copies of Board Minutes where Beneficiary played a role",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payRevisionLetters",
        "lebel": "Pay Revision Letters (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "leaveAppliForms",
        "lebel": "Leave Application Forms (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "manageManPowerReq",
        "lebel": "Manage Manpower Request (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromUSComp",
        "lebel": "Offer letter from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromUSComp",
        "lebel": "Employment Agreement from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromForeComp",
        "lebel": "Offer letter from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromForeComp",
        "lebel": "Employment Agreement from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "trainingCert",
        "lebel": "Training Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfSpecKnowledge",
        "lebel": "Proof of specialized knowledge (Note: Technical and functional knowledge)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "marriageCertificate",
        "lebel": "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
      ];
      _.forEach(this.fields, (item)=>{
        if(item['section'] == 'documents'){
          let findItem = _.find(updatedArray, {'section':item['section'], 'key':item['key']});
          if(findItem){
            item['lebel'] = findItem['lebel'];
            item['efileDocTagIds'] = []
          }
        }
      });
      console.log(JSON.stringify(this.fields))
    },
    updateFields(val){
      let self = this;
      let updateSection = val['section'];
      let updateKey = val['key'];
      let updateReqVal = val['required'];
      _.update(self,updateSection+'.'+updateKey ,()=> updateReqVal)
      let fieldIndex = _.findIndex(this.fields, { section: updateSection, key: updateKey });
      if (fieldIndex > -1) {
        let Item = _.cloneDeep(this.fields[fieldIndex]);
       Item["required"] =  _.get(this ,updateSection+'.'+updateKey ,true);
       Item["fieldRequired"] = val['fieldRequired'];
       Item["efileDocTagIds"] = val['efileDocTagIds'];
      //  console.log(JSON.stringify(Item["efileDocTagIds"]))
      //  if(_.has(val, 'efileDocTagIds')){
        
      //  }else{
      //   Item["efileDocTagIds"] = [];
      //  }
       this.fields[fieldIndex] = Item;
      } else {
        let newItem = {
          key: key,
          lebel: "First Name",
          required: _.get(this ,section+'.'+key ,true),
          description: "",
          section: section,
        };
        this.fields.push(newItem);
      }
      this.fields = _.cloneDeep(this.fields);
    },
    cccheckFieldRequired({section= '',key= ''}){
    

    let item = _.find(this.fields,{section:section , key:key});
    if(item.fieldRequired){
     return true;
    }else{
      return false;
    }
  

   },
   showOrHideField({section= '',key= ''}){
    let localSection = section
    let localKey = key
    if(this.isEdit){
      return true
    }else if(this.checkProperty(this.dbFields, "length") > 0) {
      let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
      if(dbItem){
        return true
      }
      else {
        return false
      }
    }else{
      return true
    }

   },
    toogleFields({section= '',key= ''}){
      _.map(this.fields,(item)=>{
        if(item.section==section && item.key==key ){
          item.fieldRequired?item.fieldRequired=false:item.fieldRequired =true
          if(item.fieldRequired == false || item.fieldRequired == 'false' ){
            _.update(this, section + "." + key, () => false);
          }
        }
      });
     
      this.fields = _.cloneDeep(this.fields);

      //alert('sairam')
    },
    updateTablist() {
                if (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id == 2) {
    
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "dependentsinfo"
                    })
                    if (index) {
    
                    } else {
                        this.tabslist.push({
                            key: "dependentsinfo",
                            name: "Dependents Info"
                        })
                    }
    
                } else {
    
                    this.tabslist = _.filter(this.tabslist, function (item) {
    
                        return item.key != "dependentsinfo"
                    })
                }
    
            },
    goBack() {
                this.setActiveTab(this.tabslist[this.getIndexOfActivetab - 2].key)
    
            },
    selectCheck({ section = "", subSection = "", key = "" }) {
      
      let fieldIndex = _.findIndex(this.fields, { section: section, key: key });
     

      if (fieldIndex > -1) {
        let Item = _.cloneDeep(this.fields[fieldIndex]);
       Item["required"] =  _.get(this ,section+'.'+key ,true);
       this.fields[fieldIndex] = Item;
      } else {
        let newItem = {
          key: key,
          lebel: "First Name",
          required: _.get(this ,section+'.'+key ,true),
          description: "",
          section: section,
        };
        this.fields.push(newItem);
      }
      this.fields = _.cloneDeep(this.fields);
    },
    finalSubmit() {
      this.showFinalsubmitPopup = true;
    },
    // processDbFields() {
    //   let self = this;
     
    //   if (this.checkProperty(this.dbFields, "length") > 0) {
    //     _.forEach(this.dbFields, (dbItem) => {
    //       let dbsection = this.checkProperty(dbItem,'section')
    //       let dbkeyFiled = this.checkProperty(dbItem,'key')
    //       if (dbsection && dbkeyFiled) {
    //         _.map(self.fields, (item) => {
    //           if (dbkeyFiled == item['key'] && dbsection == item['section']) {
    //             item['required'] = dbItem['required'];
    //             item['fieldRequired'] =true;
                
    //           }else{
    //             item['fieldRequired'] =false;
    //             item['required'] = true;

    //           }
    //         });
    //         _.update(self,dbsection+'.'+dbkeyFiled ,()=>dbItem['required'])   
    //       }
    //     });
    //     this.fields =_.cloneDeep(this.fields);
    //   }
    // },
    processDataFields(){
      let self = this;
      try{
        if (this.checkProperty(this.dbFields, "length") > 0) {

          

        _.forEach(self.fields, (item)=>{
          let localItem = item
          let localSection = this.checkProperty(localItem,'section')
          let localKey = this.checkProperty(localItem,'key')
          let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
          item['fieldRequired'] = false;
          item['required'] = false;
          _.update(self,localSection+'.'+localKey ,()=>false)
          if(dbItem){
            item['fieldRequired'] = true;
            if(this.checkProperty(dbItem, 'required') || this.checkProperty(dbItem, 'required') == 'true' ){
              item['required'] = true;
            }
            else{
              item['required'] = false;
            }
            if(this.checkProperty(dbItem, 'section') == 'documents'){
              if(_.has(dbItem, 'efileDocTagIds')){
                item['efileDocTagIds'] = dbItem['efileDocTagIds'];
              }else{
                item['efileDocTagIds'] = [];
              }
            }
            _.update(self,localSection+'.'+localKey ,()=>dbItem['required'])
          }
        })
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      this.isEveryThingLoaded = true
      this.$vs.loading.close()
      }
      catch{
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      
    },
    intinateI130fields(){
      _.forEach(this.sponsorInfomodal,(item)=>{
        this.fields.push(item);
        
      });

      this.processDataFields();
    },
    intinateLvisafields(){
      _.forEach(this.petitionerInfoModal,(item)=>{
        this.fields.push(item);
      });
      this.processDataFields();
    },
    getConfigDetails() {
      let postData = { questionnaireId: this.configId };
      this.isEveryThingLoaded = false
      this.$vs.loading();
      this.$store
        .dispatch("commonAction", { data: postData, path: "/questionnaire/details" })
        .then((res) => {
          this.configDetails = res;

        
         
          this.PayloadData["name"] = res.name;
          this.PayloadData["questionnaireId"] = this.configId;
          this.dbFields = this.configDetails.fields;

          if( this.configDetails['entityType'] =='I-130'){
            this.intinateI130fields();
          }else if (this.configDetails['entityType'] =='L-VISA'){
            this.intinateLvisafields();
          }else{
            this.processDataFields();
           }  
          //this.processDbFields(); 
         
        }).catch((err)=>{
          this.isEveryThingLoaded = true
          this.$vs.loading.close()
        });
    },
    saveMe(isFinalSUbmit = false) {
      
      let PayloadData = _.cloneDeep(this.PayloadData);
      if (_.has(PayloadData, "questionnaireId")) {
        PayloadData["questionnaireId"] = this.configId;
      }
      if (_.has(PayloadData, "name")) {
        PayloadData["name"] = this.PayloadData["name"];
      }
      // if (_.has(PayloadData, "fields")) {
      //   PayloadData["fields"] = _.sortedUniq(this.fields);
      // }
      if (_.has(PayloadData, "sections")) {
        PayloadData["sections"] = _.sortedUniq(PayloadData.sections);
      }
      if (isFinalSUbmit) {
        PayloadData = Object.assign(PayloadData, { configCompleted: true });
        PayloadData["configCompleted"] = true;
      }
      if (this.configDetails.tenantId) {
        PayloadData = Object.assign(PayloadData, {
          tenantId: this.configDetails.tenantId,
        });
      }
      if(_.has(PayloadData, "fields")){
        PayloadData["fields"] = _.filter(this.fields ,(item)=>{
          return item['fieldRequired'] == true || item['fieldRequired'] == 'true' ;
        })
      }
      this.updating =true;
      this.$store
        .dispatch("commonAction", {
          data: PayloadData,
          path: "/questionnaire/update",
        })
        .then((res) => {
          this.updating =false;
          this.showToster({ message: res.message, isError: false });
          this.showFinalsubmitPopup = false;
          this.getConfigDetails();

          setTimeout(() => {
            if (this.templateId) {
              this.$emit("gotoList");
            } else {
              this.$router.push("/questionnaire-templates-list");
            }
          }, 10);
        })
        .catch((err) => {
          this.updating =false;
          this.showToster({ message: err, isError: true });
        });
    },
    //createTemplate(){},
    getEfileTagsCategories(){
      let payLoad={
        "matcher": {},
        "page": 1,
        "perpage": 1000,
        "category": "efile_doc_tags",
        "sorting": {
          "path": "name",
          "order": 1
        },
      };
      this.$store.dispatch('getList',{data:payLoad, path:'/masterdata/list'}).then((res)=>{
        if(res && res.list){
          let list = res.list
          _.forEach(list, (it)=>{
            it = Object.assign(it, { 'isSelected': false });
          })
          this.eFileTagsList = list
        }
      }).catch((err)=>{

      })
    }
  },
  mounted() {
    //this.updateExistingData()
    this.getEfileTagsCategories()
    this.updating =false;
    this.configId = this.$route.params.id;
    if (this.templateId) {
      this.configId = this.templateId;
    }
    this.getConfigDetails();
    //this.processDbFields(); 
    //
  },
  computed: {
    checkSpouseLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['obtainPermResidenceThroughSpouse','marriageEndedOtherInfo','marriageEndedDueTo','locationOfMarriageTermination','provinceOfMarriageTermination',
          'countryOfMarriageTermination','locationOfMarriage','provinceOfMarriage','countryOfMarriage','dateOfMarriageEnd','dateOfMarriage',
          'dateOfBirth','maidenName','lastName','middleName','firstName']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkPassportLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['passportNumber','passportIssuedDate','passportExpiryDate','passportIssuedCountry']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkParentLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['dateOfBirth','countryOfBirth','provinceOfBirth','locationOfBirth','currentAddress','deceasedCity','deceasedDate','isUSCitizen','dateFromUSCitizen']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkAssociationLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['associations','name','startDate','endDate','natureofAssociations','address']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkEmploymentLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['prevEmploymentInfo','employerName','currentEmployer','jobTitle','businessType','salary','payFrequency','jobDuties','startDate','endDate','address']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkEmploymentOutsideUsLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['prevEmploymentOutsideUS','employerName','currentEmployer','jobTitle','businessType','salary','payFrequency','jobDuties','startDate','endDate','address']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkSpouseDocsLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys = ['passport','visa','formI94','formI797','formI20','payStubs','marriageCertificate','slgApprovalNoticeOfPrevH4','other']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkChildDocsLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys = ['passport','visa','formI94','approvalNotice','birthCertificate','slgApprovalNoticeOfPrevH4','other']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkFieldRequired(){
     return (data)=>{

      let item = _.find(this.fields,{"section":data.section , "key":data.key});
     
      if(item && _.has(item ,"fieldRequired") && item.fieldRequired){
        return true;
      }else{
        return false;
      }
  }

},
            checkActiveTab(){
              return  _.findIndex(this.tabslist ,{"key":this.currentTab});
            },  
          
          getIndexOfActivetab() {
                var $self = this;
                return _.findIndex(this.tabslist, (e) => {
                    return e.key == $self.currentTab;
                }) + 1;
            },
            actiontype() {
                if (this.getIndexOfActivetab == this.tabslist.length) {
                    if (this.petition.questionnaireFilled) {
                        return "Update";
                    }
                    if (!this.petition.questionnaireFilled) {
                        return "Review & Submit";
                    }
                    return "Submit";
                }
                return "Next";
            }
          }
};
</script>
